/*! jQuery v2.2.4 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=a.document,e=c.slice,f=c.concat,g=c.push,h=c.indexOf,i={},j=i.toString,k=i.hasOwnProperty,l={},m="2.2.4",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return e.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:e.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a){return n.each(this,a)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(e.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:g,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=a&&a.toString();return!n.isArray(a)&&b-parseFloat(b)+1>=0},isPlainObject:function(a){var b;if("object"!==n.type(a)||a.nodeType||n.isWindow(a))return!1;if(a.constructor&&!k.call(a,"constructor")&&!k.call(a.constructor.prototype||{},"isPrototypeOf"))return!1;for(b in a);return void 0===b||k.call(a,b)},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?i[j.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=d.createElement("script"),b.text=a,d.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(s(a)){for(c=a.length;c>d;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):g.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:h.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,g=0,h=[];if(s(a))for(d=a.length;d>g;g++)e=b(a[g],g,c),null!=e&&h.push(e);else for(g in a)e=b(a[g],g,c),null!=e&&h.push(e);return f.apply([],h)},guid:1,proxy:function(a,b){var c,d,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(d=e.call(arguments,2),f=function(){return a.apply(b||this,d.concat(e.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:l}),"function"==typeof Symbol&&(n.fn[Symbol.iterator]=c[Symbol.iterator]),n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){i["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=!!a&&"length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+M+"))|)"+L+"*\\]",O=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+N+")*)|.*)\\)|)",P=new RegExp(L+"+","g"),Q=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),R=new RegExp("^"+L+"*,"+L+"*"),S=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),T=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),U=new RegExp(O),V=new RegExp("^"+M+"$"),W={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M+"|[*])"),ATTR:new RegExp("^"+N),PSEUDO:new RegExp("^"+O),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},X=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Z=/^[^{]+\{\s*\[native \w/,$=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,_=/[+~]/,aa=/'|\\/g,ba=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),ca=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},da=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(ea){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s,w=b&&b.ownerDocument,x=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==x&&9!==x&&11!==x)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==x&&(o=$.exec(a)))if(f=o[1]){if(9===x){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(w&&(j=w.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(o[2])return H.apply(d,b.getElementsByTagName(a)),d;if((f=o[3])&&c.getElementsByClassName&&b.getElementsByClassName)return H.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==x)w=b,s=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(aa,"\\$&"):b.setAttribute("id",k=u),r=g(a),h=r.length,l=V.test(k)?"#"+k:"[id='"+k+"']";while(h--)r[h]=l+" "+qa(r[h]);s=r.join(","),w=_.test(a)&&oa(b.parentNode)||b}if(s)try{return H.apply(d,w.querySelectorAll(s)),d}catch(y){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(Q,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function oa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Z.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return"undefined"!=typeof b.getElementsByClassName&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=Z.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Z.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",O)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Z.test(o.compareDocumentPosition),t=b||Z.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(T,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:W,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ba,ca),a[3]=(a[3]||a[4]||a[5]||"").replace(ba,ca),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return W.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&U.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ba,ca).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(P," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(Q,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(ba,ca),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return V.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(ba,ca).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Y.test(a.nodeName)},input:function(a){return X.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:na(function(){return[0]}),last:na(function(a,b){return[b-1]}),eq:na(function(a,b,c){return[0>c?c+b:c]}),even:na(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:na(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:na(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:na(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function pa(){}pa.prototype=d.filters=d.pseudos,d.setFilters=new pa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=R.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=S.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(Q," ")}),h=h.slice(c.length));for(g in d.filter)!(e=W[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function qa(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function ra(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j,k=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(j=b[u]||(b[u]={}),i=j[b.uniqueID]||(j[b.uniqueID]={}),(h=i[d])&&h[0]===w&&h[1]===f)return k[2]=h[2];if(i[d]=k,k[2]=a(b,c,g))return!0}}}function sa(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ta(a,b,c){for(var d=0,e=b.length;e>d;d++)fa(a,b[d],c);return c}function ua(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function va(a,b,c,d,e,f){return d&&!d[u]&&(d=va(d)),e&&!e[u]&&(e=va(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ta(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ua(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ua(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ua(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function wa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ra(function(a){return a===b},h,!0),l=ra(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[ra(sa(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return va(i>1&&sa(m),i>1&&qa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(Q,"$1"),c,e>i&&wa(a.slice(i,e)),f>e&&wa(a=a.slice(e)),f>e&&qa(a))}m.push(c)}return sa(m)}function xa(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=F.call(i));u=ua(u)}H.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xa(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ba,ca),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=W.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ba,ca),_.test(j[0].type)&&oa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qa(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||_.test(a)&&oa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.uniqueSort=n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},v=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},w=n.expr.match.needsContext,x=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,y=/^.[^:#\[\.,]*$/;function z(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(y.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return h.call(b,a)>-1!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(z(this,a||[],!1))},not:function(a){return this.pushStack(z(this,a||[],!0))},is:function(a){return!!z(this,"string"==typeof a&&w.test(a)?n(a):a||[],!1).length}});var A,B=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=n.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||A,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:B.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),x.test(e[1])&&n.isPlainObject(b))for(e in b)n.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&f.parentNode&&(this.length=1,this[0]=f),this.context=d,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?void 0!==c.ready?c.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};C.prototype=n.fn,A=n(d);var D=/^(?:parents|prev(?:Until|All))/,E={children:!0,contents:!0,next:!0,prev:!0};n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=w.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?h.call(n(a),this[0]):h.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.uniqueSort(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function F(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return u(a,"parentNode")},parentsUntil:function(a,b,c){return u(a,"parentNode",c)},next:function(a){return F(a,"nextSibling")},prev:function(a){return F(a,"previousSibling")},nextAll:function(a){return u(a,"nextSibling")},prevAll:function(a){return u(a,"previousSibling")},nextUntil:function(a,b,c){return u(a,"nextSibling",c)},prevUntil:function(a,b,c){return u(a,"previousSibling",c)},siblings:function(a){return v((a.parentNode||{}).firstChild,a)},children:function(a){return v(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(E[a]||n.uniqueSort(e),D.test(a)&&e.reverse()),this.pushStack(e)}});var G=/\S+/g;function H(a){var b={};return n.each(a.match(G)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?H(a):n.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){n.each(b,function(b,c){n.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==n.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return n.each(arguments,function(a,b){var c;while((c=n.inArray(b,f,c))>-1)f.splice(c,1),h>=c&&h--}),this},has:function(a){return a?n.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().progress(c.notify).done(c.resolve).fail(c.reject):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=e.call(arguments),d=c.length,f=1!==d||a&&n.isFunction(a.promise)?d:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(d){b[a]=this,c[a]=arguments.length>1?e.call(arguments):d,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(d>1)for(i=new Array(d),j=new Array(d),k=new Array(d);d>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().progress(h(b,j,i)).done(h(b,k,c)).fail(g.reject):--f;return f||g.resolveWith(k,c),g.promise()}});var I;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(I.resolveWith(d,[n]),n.fn.triggerHandler&&(n(d).triggerHandler("ready"),n(d).off("ready"))))}});function J(){d.removeEventListener("DOMContentLoaded",J),a.removeEventListener("load",J),n.ready()}n.ready.promise=function(b){return I||(I=n.Deferred(),"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(n.ready):(d.addEventListener("DOMContentLoaded",J),a.addEventListener("load",J))),I.promise(b)},n.ready.promise();var K=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)K(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},L=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function M(){this.expando=n.expando+M.uid++}M.uid=1,M.prototype={register:function(a,b){var c=b||{};return a.nodeType?a[this.expando]=c:Object.defineProperty(a,this.expando,{value:c,writable:!0,configurable:!0}),a[this.expando]},cache:function(a){if(!L(a))return{};var b=a[this.expando];return b||(b={},L(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[b]=c;else for(d in b)e[d]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=a[this.expando];if(void 0!==f){if(void 0===b)this.register(a);else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in f?d=[b,e]:(d=e,d=d in f?[d]:d.match(G)||[])),c=d.length;while(c--)delete f[d[c]]}(void 0===b||n.isEmptyObject(f))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!n.isEmptyObject(b)}};var N=new M,O=new M,P=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Q=/[A-Z]/g;function R(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Q,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:P.test(c)?n.parseJSON(c):c;
}catch(e){}O.set(a,b,c)}else c=void 0;return c}n.extend({hasData:function(a){return O.hasData(a)||N.hasData(a)},data:function(a,b,c){return O.access(a,b,c)},removeData:function(a,b){O.remove(a,b)},_data:function(a,b,c){return N.access(a,b,c)},_removeData:function(a,b){N.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=O.get(f),1===f.nodeType&&!N.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),R(f,d,e[d])));N.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){O.set(this,a)}):K(this,function(b){var c,d;if(f&&void 0===b){if(c=O.get(f,a)||O.get(f,a.replace(Q,"-$&").toLowerCase()),void 0!==c)return c;if(d=n.camelCase(a),c=O.get(f,d),void 0!==c)return c;if(c=R(f,d,void 0),void 0!==c)return c}else d=n.camelCase(a),this.each(function(){var c=O.get(this,d);O.set(this,d,b),a.indexOf("-")>-1&&void 0!==c&&O.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){O.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=N.get(a,b),c&&(!d||n.isArray(c)?d=N.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return N.get(a,c)||N.access(a,c,{empty:n.Callbacks("once memory").add(function(){N.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=N.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var S=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,T=new RegExp("^(?:([+-])=|)("+S+")([a-z%]*)$","i"),U=["Top","Right","Bottom","Left"],V=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)};function W(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return n.css(a,b,"")},i=h(),j=c&&c[3]||(n.cssNumber[b]?"":"px"),k=(n.cssNumber[b]||"px"!==j&&+i)&&T.exec(n.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,n.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var X=/^(?:checkbox|radio)$/i,Y=/<([\w:-]+)/,Z=/^$|\/(?:java|ecma)script/i,$={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};$.optgroup=$.option,$.tbody=$.tfoot=$.colgroup=$.caption=$.thead,$.th=$.td;function _(a,b){var c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function aa(a,b){for(var c=0,d=a.length;d>c;c++)N.set(a[c],"globalEval",!b||N.get(b[c],"globalEval"))}var ba=/<|&#?\w+;/;function ca(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],o=0,p=a.length;p>o;o++)if(f=a[o],f||0===f)if("object"===n.type(f))n.merge(m,f.nodeType?[f]:f);else if(ba.test(f)){g=g||l.appendChild(b.createElement("div")),h=(Y.exec(f)||["",""])[1].toLowerCase(),i=$[h]||$._default,g.innerHTML=i[1]+n.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;n.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",o=0;while(f=m[o++])if(d&&n.inArray(f,d)>-1)e&&e.push(f);else if(j=n.contains(f.ownerDocument,f),g=_(l.appendChild(f),"script"),j&&aa(g),c){k=0;while(f=g[k++])Z.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),l.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",l.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var da=/^key/,ea=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,fa=/^([^.]*)(?:\.(.+)|)/;function ga(){return!0}function ha(){return!1}function ia(){try{return d.activeElement}catch(a){}}function ja(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)ja(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=ha;else if(!e)return a;return 1===f&&(g=e,e=function(a){return n().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=n.guid++)),a.each(function(){n.event.add(this,b,e,d,c)})}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return"undefined"!=typeof n&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(G)||[""],j=b.length;while(j--)h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.hasData(a)&&N.get(a);if(r&&(i=r.events)){b=(b||"").match(G)||[""],j=b.length;while(j--)if(h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&N.remove(a,"handle events")}},dispatch:function(a){a=n.event.fix(a);var b,c,d,f,g,h=[],i=e.call(arguments),j=(N.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())a.rnamespace&&!a.rnamespace.test(g.namespace)||(a.handleObj=g,a.data=g.data,d=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==d&&(a.result=d)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!==this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>-1:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,e,f,g=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||d,e=c.documentElement,f=c.body,a.pageX=b.clientX+(e&&e.scrollLeft||f&&f.scrollLeft||0)-(e&&e.clientLeft||f&&f.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||f&&f.scrollTop||0)-(e&&e.clientTop||f&&f.clientTop||0)),a.which||void 0===g||(a.which=1&g?1:2&g?3:4&g?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,e,f=a.type,g=a,h=this.fixHooks[f];h||(this.fixHooks[f]=h=ea.test(f)?this.mouseHooks:da.test(f)?this.keyHooks:{}),e=h.props?this.props.concat(h.props):this.props,a=new n.Event(g),b=e.length;while(b--)c=e[b],a[c]=g[c];return a.target||(a.target=d),3===a.target.nodeType&&(a.target=a.target.parentNode),h.filter?h.filter(a,g):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==ia()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===ia()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ga:ha):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={constructor:n.Event,isDefaultPrevented:ha,isPropagationStopped:ha,isImmediatePropagationStopped:ha,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ga,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ga,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ga,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||n.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),n.fn.extend({on:function(a,b,c,d){return ja(this,a,b,c,d)},one:function(a,b,c,d){return ja(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=ha),this.each(function(){n.event.remove(this,a,c,b)})}});var ka=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,la=/<script|<style|<link/i,ma=/checked\s*(?:[^=]|=\s*.checked.)/i,na=/^true\/(.*)/,oa=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function pa(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function qa(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function ra(a){var b=na.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function sa(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(N.hasData(a)&&(f=N.access(a),g=N.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}O.hasData(a)&&(h=O.access(a),i=n.extend({},h),O.set(b,i))}}function ta(a,b){var c=b.nodeName.toLowerCase();"input"===c&&X.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function ua(a,b,c,d){b=f.apply([],b);var e,g,h,i,j,k,m=0,o=a.length,p=o-1,q=b[0],r=n.isFunction(q);if(r||o>1&&"string"==typeof q&&!l.checkClone&&ma.test(q))return a.each(function(e){var f=a.eq(e);r&&(b[0]=q.call(this,e,f.html())),ua(f,b,c,d)});if(o&&(e=ca(b,a[0].ownerDocument,!1,a,d),g=e.firstChild,1===e.childNodes.length&&(e=g),g||d)){for(h=n.map(_(e,"script"),qa),i=h.length;o>m;m++)j=e,m!==p&&(j=n.clone(j,!0,!0),i&&n.merge(h,_(j,"script"))),c.call(a[m],j,m);if(i)for(k=h[h.length-1].ownerDocument,n.map(h,ra),m=0;i>m;m++)j=h[m],Z.test(j.type||"")&&!N.access(j,"globalEval")&&n.contains(k,j)&&(j.src?n._evalUrl&&n._evalUrl(j.src):n.globalEval(j.textContent.replace(oa,"")))}return a}function va(a,b,c){for(var d,e=b?n.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||n.cleanData(_(d)),d.parentNode&&(c&&n.contains(d.ownerDocument,d)&&aa(_(d,"script")),d.parentNode.removeChild(d));return a}n.extend({htmlPrefilter:function(a){return a.replace(ka,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(l.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=_(h),f=_(a),d=0,e=f.length;e>d;d++)ta(f[d],g[d]);if(b)if(c)for(f=f||_(a),g=g||_(h),d=0,e=f.length;e>d;d++)sa(f[d],g[d]);else sa(a,h);return g=_(h,"script"),g.length>0&&aa(g,!i&&_(a,"script")),h},cleanData:function(a){for(var b,c,d,e=n.event.special,f=0;void 0!==(c=a[f]);f++)if(L(c)){if(b=c[N.expando]){if(b.events)for(d in b.events)e[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);c[N.expando]=void 0}c[O.expando]&&(c[O.expando]=void 0)}}}),n.fn.extend({domManip:ua,detach:function(a){return va(this,a,!0)},remove:function(a){return va(this,a)},text:function(a){return K(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.appendChild(a)}})},prepend:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(_(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return K(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!la.test(a)&&!$[(Y.exec(a)||["",""])[1].toLowerCase()]){a=n.htmlPrefilter(a);try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(_(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return ua(this,arguments,function(b){var c=this.parentNode;n.inArray(this,a)<0&&(n.cleanData(_(this)),c&&c.replaceChild(b,this))},a)}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),f=e.length-1,h=0;f>=h;h++)c=h===f?this:this.clone(!0),n(e[h])[b](c),g.apply(d,c.get());return this.pushStack(d)}});var wa,xa={HTML:"block",BODY:"block"};function ya(a,b){var c=n(b.createElement(a)).appendTo(b.body),d=n.css(c[0],"display");return c.detach(),d}function za(a){var b=d,c=xa[a];return c||(c=ya(a,b),"none"!==c&&c||(wa=(wa||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=wa[0].contentDocument,b.write(),b.close(),c=ya(a,b),wa.detach()),xa[a]=c),c}var Aa=/^margin/,Ba=new RegExp("^("+S+")(?!px)[a-z%]+$","i"),Ca=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)},Da=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e},Ea=d.documentElement;!function(){var b,c,e,f,g=d.createElement("div"),h=d.createElement("div");if(h.style){h.style.backgroundClip="content-box",h.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===h.style.backgroundClip,g.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",g.appendChild(h);function i(){h.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",h.innerHTML="",Ea.appendChild(g);var d=a.getComputedStyle(h);b="1%"!==d.top,f="2px"===d.marginLeft,c="4px"===d.width,h.style.marginRight="50%",e="4px"===d.marginRight,Ea.removeChild(g)}n.extend(l,{pixelPosition:function(){return i(),b},boxSizingReliable:function(){return null==c&&i(),c},pixelMarginRight:function(){return null==c&&i(),e},reliableMarginLeft:function(){return null==c&&i(),f},reliableMarginRight:function(){var b,c=h.appendChild(d.createElement("div"));return c.style.cssText=h.style.cssText="-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",h.style.width="1px",Ea.appendChild(g),b=!parseFloat(a.getComputedStyle(c).marginRight),Ea.removeChild(g),h.removeChild(c),b}})}}();function Fa(a,b,c){var d,e,f,g,h=a.style;return c=c||Ca(a),g=c?c.getPropertyValue(b)||c[b]:void 0,""!==g&&void 0!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),c&&!l.pixelMarginRight()&&Ba.test(g)&&Aa.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f),void 0!==g?g+"":g}function Ga(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Ha=/^(none|table(?!-c[ea]).+)/,Ia={position:"absolute",visibility:"hidden",display:"block"},Ja={letterSpacing:"0",fontWeight:"400"},Ka=["Webkit","O","Moz","ms"],La=d.createElement("div").style;function Ma(a){if(a in La)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ka.length;while(c--)if(a=Ka[c]+b,a in La)return a}function Na(a,b,c){var d=T.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Oa(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+U[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+U[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+U[f]+"Width",!0,e))):(g+=n.css(a,"padding"+U[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+U[f]+"Width",!0,e)));return g}function Pa(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=Ca(a),g="border-box"===n.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=Fa(a,b,f),(0>e||null==e)&&(e=a.style[b]),Ba.test(e))return e;d=g&&(l.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Oa(a,b,c||(g?"border":"content"),d,f)+"px"}function Qa(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=N.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&V(d)&&(f[g]=N.access(d,"olddisplay",za(d.nodeName)))):(e=V(d),"none"===c&&e||N.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Fa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=T.exec(c))&&e[1]&&(c=W(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(n.cssNumber[h]?"":"px")),l.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Fa(a,b,d)),"normal"===e&&b in Ja&&(e=Ja[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?Ha.test(n.css(a,"display"))&&0===a.offsetWidth?Da(a,Ia,function(){return Pa(a,b,d)}):Pa(a,b,d):void 0},set:function(a,c,d){var e,f=d&&Ca(a),g=d&&Oa(a,b,d,"border-box"===n.css(a,"boxSizing",!1,f),f);return g&&(e=T.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=n.css(a,b)),Na(a,c,g)}}}),n.cssHooks.marginLeft=Ga(l.reliableMarginLeft,function(a,b){return b?(parseFloat(Fa(a,"marginLeft"))||a.getBoundingClientRect().left-Da(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px":void 0}),n.cssHooks.marginRight=Ga(l.reliableMarginRight,function(a,b){return b?Da(a,{display:"inline-block"},Fa,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+U[d]+b]=f[d]||f[d-2]||f[0];return e}},Aa.test(a)||(n.cssHooks[a+b].set=Na)}),n.fn.extend({css:function(a,b){return K(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=Ca(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Qa(this,!0)},hide:function(){return Qa(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){V(this)?n(this).show():n(this).hide()})}});function Ra(a,b,c,d,e){return new Ra.prototype.init(a,b,c,d,e)}n.Tween=Ra,Ra.prototype={constructor:Ra,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||n.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Ra.propHooks[this.prop];return a&&a.get?a.get(this):Ra.propHooks._default.get(this)},run:function(a){var b,c=Ra.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ra.propHooks._default.set(this),this}},Ra.prototype.init.prototype=Ra.prototype,Ra.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[n.cssProps[a.prop]]&&!n.cssHooks[a.prop]?a.elem[a.prop]=a.now:n.style(a.elem,a.prop,a.now+a.unit)}}},Ra.propHooks.scrollTop=Ra.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},n.fx=Ra.prototype.init,n.fx.step={};var Sa,Ta,Ua=/^(?:toggle|show|hide)$/,Va=/queueHooks$/;function Wa(){return a.setTimeout(function(){Sa=void 0}),Sa=n.now()}function Xa(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=U[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ya(a,b,c){for(var d,e=(_a.tweeners[b]||[]).concat(_a.tweeners["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Za(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&V(a),q=N.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?N.get(a,"olddisplay")||za(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Ua.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?za(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=N.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;N.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ya(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function $a(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function _a(a,b,c){var d,e,f=0,g=_a.prefilters.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Sa||Wa(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{},easing:n.easing._default},c),originalProperties:b,originalOptions:c,startTime:Sa||Wa(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for($a(k,j.opts.specialEasing);g>f;f++)if(d=_a.prefilters[f].call(j,a,k,j.opts))return n.isFunction(d.stop)&&(n._queueHooks(j.elem,j.opts.queue).stop=n.proxy(d.stop,d)),d;return n.map(k,Ya,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(_a,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return W(c.elem,a,T.exec(b),c),c}]},tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.match(G);for(var c,d=0,e=a.length;e>d;d++)c=a[d],_a.tweeners[c]=_a.tweeners[c]||[],_a.tweeners[c].unshift(b)},prefilters:[Za],prefilter:function(a,b){b?_a.prefilters.unshift(a):_a.prefilters.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,null!=d.queue&&d.queue!==!0||(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(V).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=_a(this,n.extend({},a),f);(e||N.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=N.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Va.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=N.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Xa(b,!0),a,d,e)}}),n.each({slideDown:Xa("show"),slideUp:Xa("hide"),slideToggle:Xa("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(Sa=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),Sa=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Ta||(Ta=a.setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){a.clearInterval(Ta),Ta=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(b,c){return b=n.fx?n.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",l.checkOn=""!==a.value,l.optSelected=c.selected,b.disabled=!0,l.optDisabled=!c.disabled,a=d.createElement("input"),a.value="t",a.type="radio",l.radioValue="t"===a.value}();var ab,bb=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return K(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),e=n.attrHooks[b]||(n.expr.match.bool.test(b)?ab:void 0)),void 0!==c?null===c?void n.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=n.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!l.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(G);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)}}),ab={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=bb[b]||n.find.attr;bb[b]=function(a,b,d){var e,f;return d||(f=bb[b],bb[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,bb[b]=f),e}});var cb=/^(?:input|select|textarea|button)$/i,db=/^(?:a|area)$/i;n.fn.extend({prop:function(a,b){return K(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&n.isXMLDoc(a)||(b=n.propFix[b]||b,e=n.propHooks[b]),
void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=n.find.attr(a,"tabindex");return b?parseInt(b,10):cb.test(a.nodeName)||db.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),l.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var eb=/[\t\r\n\f]/g;function fb(a){return a.getAttribute&&a.getAttribute("class")||""}n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,fb(this)))});if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,fb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):n.isFunction(a)?this.each(function(c){n(this).toggleClass(a.call(this,c,fb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=n(this),f=a.match(G)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=fb(this),b&&N.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":N.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+fb(c)+" ").replace(eb," ").indexOf(b)>-1)return!0;return!1}});var gb=/\r/g,hb=/[\x20\t\r\n\f]+/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(gb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a)).replace(hb," ")}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],(c.selected||i===e)&&(l.optDisabled?!c.disabled:null===c.getAttribute("disabled"))&&(!c.parentNode.disabled||!n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(n.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>-1:void 0}},l.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var ib=/^(?:focusinfocus|focusoutblur)$/;n.extend(n.event,{trigger:function(b,c,e,f){var g,h,i,j,l,m,o,p=[e||d],q=k.call(b,"type")?b.type:b,r=k.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!ib.test(q+n.event.triggered)&&(q.indexOf(".")>-1&&(r=q.split("."),q=r.shift(),r.sort()),l=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=r.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},f||!o.trigger||o.trigger.apply(e,c)!==!1)){if(!f&&!o.noBubble&&!n.isWindow(e)){for(j=o.delegateType||q,ib.test(j+q)||(h=h.parentNode);h;h=h.parentNode)p.push(h),i=h;i===(e.ownerDocument||d)&&p.push(i.defaultView||i.parentWindow||a)}g=0;while((h=p[g++])&&!b.isPropagationStopped())b.type=g>1?j:o.bindType||q,m=(N.get(h,"events")||{})[b.type]&&N.get(h,"handle"),m&&m.apply(h,c),m=l&&h[l],m&&m.apply&&L(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=q,f||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!L(e)||l&&n.isFunction(e[q])&&!n.isWindow(e)&&(i=e[l],i&&(e[l]=null),n.event.triggered=q,e[q](),n.event.triggered=void 0,i&&(e[l]=i)),b.result}},simulate:function(a,b,c){var d=n.extend(new n.Event,c,{type:a,isSimulated:!0});n.event.trigger(d,null,b)}}),n.fn.extend({trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),l.focusin="onfocusin"in a,l.focusin||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a))};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=N.access(d,b);e||d.addEventListener(a,c,!0),N.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=N.access(d,b)-1;e?N.access(d,b,e):(d.removeEventListener(a,c,!0),N.remove(d,b))}}});var jb=a.location,kb=n.now(),lb=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||n.error("Invalid XML: "+b),c};var mb=/#.*$/,nb=/([?&])_=[^&]*/,ob=/^(.*?):[ \t]*([^\r\n]*)$/gm,pb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,qb=/^(?:GET|HEAD)$/,rb=/^\/\//,sb={},tb={},ub="*/".concat("*"),vb=d.createElement("a");vb.href=jb.href;function wb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(G)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function xb(a,b,c,d){var e={},f=a===tb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function yb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function zb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Ab(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:jb.href,type:"GET",isLocal:pb.test(jb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":ub,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?yb(yb(a,n.ajaxSettings),b):yb(n.ajaxSettings,a)},ajaxPrefilter:wb(sb),ajaxTransport:wb(tb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m=n.ajaxSetup({},c),o=m.context||m,p=m.context&&(o.nodeType||o.jquery)?n(o):n.event,q=n.Deferred(),r=n.Callbacks("once memory"),s=m.statusCode||{},t={},u={},v=0,w="canceled",x={readyState:0,getResponseHeader:function(a){var b;if(2===v){if(!h){h={};while(b=ob.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===v?g:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return v||(a=u[c]=u[c]||a,t[a]=b),this},overrideMimeType:function(a){return v||(m.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>v)for(b in a)s[b]=[s[b],a[b]];else x.always(a[x.status]);return this},abort:function(a){var b=a||w;return e&&e.abort(b),z(0,b),this}};if(q.promise(x).complete=r.add,x.success=x.done,x.error=x.fail,m.url=((b||m.url||jb.href)+"").replace(mb,"").replace(rb,jb.protocol+"//"),m.type=c.method||c.type||m.method||m.type,m.dataTypes=n.trim(m.dataType||"*").toLowerCase().match(G)||[""],null==m.crossDomain){j=d.createElement("a");try{j.href=m.url,j.href=j.href,m.crossDomain=vb.protocol+"//"+vb.host!=j.protocol+"//"+j.host}catch(y){m.crossDomain=!0}}if(m.data&&m.processData&&"string"!=typeof m.data&&(m.data=n.param(m.data,m.traditional)),xb(sb,m,c,x),2===v)return x;k=n.event&&m.global,k&&0===n.active++&&n.event.trigger("ajaxStart"),m.type=m.type.toUpperCase(),m.hasContent=!qb.test(m.type),f=m.url,m.hasContent||(m.data&&(f=m.url+=(lb.test(f)?"&":"?")+m.data,delete m.data),m.cache===!1&&(m.url=nb.test(f)?f.replace(nb,"$1_="+kb++):f+(lb.test(f)?"&":"?")+"_="+kb++)),m.ifModified&&(n.lastModified[f]&&x.setRequestHeader("If-Modified-Since",n.lastModified[f]),n.etag[f]&&x.setRequestHeader("If-None-Match",n.etag[f])),(m.data&&m.hasContent&&m.contentType!==!1||c.contentType)&&x.setRequestHeader("Content-Type",m.contentType),x.setRequestHeader("Accept",m.dataTypes[0]&&m.accepts[m.dataTypes[0]]?m.accepts[m.dataTypes[0]]+("*"!==m.dataTypes[0]?", "+ub+"; q=0.01":""):m.accepts["*"]);for(l in m.headers)x.setRequestHeader(l,m.headers[l]);if(m.beforeSend&&(m.beforeSend.call(o,x,m)===!1||2===v))return x.abort();w="abort";for(l in{success:1,error:1,complete:1})x[l](m[l]);if(e=xb(tb,m,c,x)){if(x.readyState=1,k&&p.trigger("ajaxSend",[x,m]),2===v)return x;m.async&&m.timeout>0&&(i=a.setTimeout(function(){x.abort("timeout")},m.timeout));try{v=1,e.send(t,z)}catch(y){if(!(2>v))throw y;z(-1,y)}}else z(-1,"No Transport");function z(b,c,d,h){var j,l,t,u,w,y=c;2!==v&&(v=2,i&&a.clearTimeout(i),e=void 0,g=h||"",x.readyState=b>0?4:0,j=b>=200&&300>b||304===b,d&&(u=zb(m,x,d)),u=Ab(m,u,x,j),j?(m.ifModified&&(w=x.getResponseHeader("Last-Modified"),w&&(n.lastModified[f]=w),w=x.getResponseHeader("etag"),w&&(n.etag[f]=w)),204===b||"HEAD"===m.type?y="nocontent":304===b?y="notmodified":(y=u.state,l=u.data,t=u.error,j=!t)):(t=y,!b&&y||(y="error",0>b&&(b=0))),x.status=b,x.statusText=(c||y)+"",j?q.resolveWith(o,[l,y,x]):q.rejectWith(o,[x,y,t]),x.statusCode(s),s=void 0,k&&p.trigger(j?"ajaxSuccess":"ajaxError",[x,m,j?l:t]),r.fireWith(o,[x,y]),k&&(p.trigger("ajaxComplete",[x,m]),--n.active||n.event.trigger("ajaxStop")))}return x},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax(n.extend({url:a,type:b,dataType:e,data:c,success:d},n.isPlainObject(a)&&a))}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return n.isFunction(a)?this.each(function(b){n(this).wrapInner(a.call(this,b))}):this.each(function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return!n.expr.filters.visible(a)},n.expr.filters.visible=function(a){return a.offsetWidth>0||a.offsetHeight>0||a.getClientRects().length>0};var Bb=/%20/g,Cb=/\[\]$/,Db=/\r?\n/g,Eb=/^(?:submit|button|image|reset|file)$/i,Fb=/^(?:input|select|textarea|keygen)/i;function Gb(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||Cb.test(a)?d(a,e):Gb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Gb(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Gb(c,a[c],b,e);return d.join("&").replace(Bb,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&Fb.test(this.nodeName)&&!Eb.test(a)&&(this.checked||!X.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(Db,"\r\n")}}):{name:b.name,value:c.replace(Db,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Hb={0:200,1223:204},Ib=n.ajaxSettings.xhr();l.cors=!!Ib&&"withCredentials"in Ib,l.ajax=Ib=!!Ib,n.ajaxTransport(function(b){var c,d;return l.cors||Ib&&!b.crossDomain?{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Hb[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=n("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Jb=[],Kb=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Jb.pop()||n.expando+"_"+kb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Kb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Kb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Kb,"$1"+e):b.jsonp!==!1&&(b.url+=(lb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?n(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Jb.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||d;var e=x.exec(a),f=!c&&[];return e?[b.createElement(e[1])]:(e=ca([a],b,f),f&&f.length&&n(f).remove(),n.merge([],e.childNodes))};var Lb=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Lb)return Lb.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};function Mb(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,n.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(e=d.getBoundingClientRect(),c=Mb(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0),d.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Ea})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;n.fn[a]=function(d){return K(this,function(a,d,e){var f=Mb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=Ga(l.pixelPosition,function(a,c){return c?(c=Fa(a,b),Ba.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return K(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)},size:function(){return this.length}}),n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var Nb=a.jQuery,Ob=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Ob),b&&a.jQuery===n&&(a.jQuery=Nb),n},b||(a.jQuery=a.$=n),n});
/*! Select2 4.0.10 | https://github.com/select2/select2/blob/master/LICENSE.md */ ! function (n) {
    "function" == typeof define && define.amd ? define(["jquery"], n) : "object" == typeof module && module.exports ? module.exports = function (e, t) {
        return void 0 === t && (t = "undefined" != typeof window ? require("jquery") : require("jquery")(e)), n(t), t
    } : n(jQuery)
}(function (u) {
    var e = function () {
            if (u && u.fn && u.fn.select2 && u.fn.select2.amd) var e = u.fn.select2.amd;
            var t, n, r, h, o, s, f, g, m, v, y, _, i, a, w;

            function b(e, t) {
                return i.call(e, t)
            }

            function l(e, t) {
                var n, r, i, o, s, a, l, c, u, d, p, h = t && t.split("/"),
                    f = y.map,
                    g = f && f["*"] || {};
                if (e) {
                    for (s = (e = e.split("/")).length - 1, y.nodeIdCompat && w.test(e[s]) && (e[s] = e[s].replace(w, "")), "." === e[0].charAt(0) && h && (e = h.slice(0, h.length - 1).concat(e)), u = 0; u < e.length; u++)
                        if ("." === (p = e[u])) e.splice(u, 1), u -= 1;
                        else if (".." === p) {
                        if (0 === u || 1 === u && ".." === e[2] || ".." === e[u - 1]) continue;
                        0 < u && (e.splice(u - 1, 2), u -= 2)
                    }
                    e = e.join("/")
                }
                if ((h || g) && f) {
                    for (u = (n = e.split("/")).length; 0 < u; u -= 1) {
                        if (r = n.slice(0, u).join("/"), h)
                            for (d = h.length; 0 < d; d -= 1)
                                if (i = (i = f[h.slice(0, d).join("/")]) && i[r]) {
                                    o = i, a = u;
                                    break
                                } if (o) break;
                        !l && g && g[r] && (l = g[r], c = u)
                    }!o && l && (o = l, a = c), o && (n.splice(0, a, o), e = n.join("/"))
                }
                return e
            }

            function A(t, n) {
                return function () {
                    var e = a.call(arguments, 0);
                    return "string" != typeof e[0] && 1 === e.length && e.push(null), s.apply(h, e.concat([t, n]))
                }
            }

            function x(t) {
                return function (e) {
                    m[t] = e
                }
            }

            function D(e) {
                if (b(v, e)) {
                    var t = v[e];
                    delete v[e], _[e] = !0, o.apply(h, t)
                }
                if (!b(m, e) && !b(_, e)) throw new Error("No " + e);
                return m[e]
            }

            function c(e) {
                var t, n = e ? e.indexOf("!") : -1;
                return -1 < n && (t = e.substring(0, n), e = e.substring(n + 1, e.length)), [t, e]
            }

            function S(e) {
                return e ? c(e) : []
            }
            return e && e.requirejs || (e ? n = e : e = {}, m = {}, v = {}, y = {}, _ = {}, i = Object.prototype.hasOwnProperty, a = [].slice, w = /\.js$/, f = function (e, t) {
                var n, r = c(e),
                    i = r[0],
                    o = t[1];
                return e = r[1], i && (n = D(i = l(i, o))), i ? e = n && n.normalize ? n.normalize(e, function (t) {
                    return function (e) {
                        return l(e, t)
                    }
                }(o)) : l(e, o) : (i = (r = c(e = l(e, o)))[0], e = r[1], i && (n = D(i))), {
                    f: i ? i + "!" + e : e,
                    n: e,
                    pr: i,
                    p: n
                }
            }, g = {
                require: function (e) {
                    return A(e)
                },
                exports: function (e) {
                    var t = m[e];
                    return void 0 !== t ? t : m[e] = {}
                },
                module: function (e) {
                    return {
                        id: e,
                        uri: "",
                        exports: m[e],
                        config: function (e) {
                            return function () {
                                return y && y.config && y.config[e] || {}
                            }
                        }(e)
                    }
                }
            }, o = function (e, t, n, r) {
                var i, o, s, a, l, c, u, d = [],
                    p = typeof n;
                if (c = S(r = r || e), "undefined" == p || "function" == p) {
                    for (t = !t.length && n.length ? ["require", "exports", "module"] : t, l = 0; l < t.length; l += 1)
                        if ("require" === (o = (a = f(t[l], c)).f)) d[l] = g.require(e);
                        else if ("exports" === o) d[l] = g.exports(e), u = !0;
                    else if ("module" === o) i = d[l] = g.module(e);
                    else if (b(m, o) || b(v, o) || b(_, o)) d[l] = D(o);
                    else {
                        if (!a.p) throw new Error(e + " missing " + o);
                        a.p.load(a.n, A(r, !0), x(o), {}), d[l] = m[o]
                    }
                    s = n ? n.apply(m[e], d) : void 0, e && (i && i.exports !== h && i.exports !== m[e] ? m[e] = i.exports : s === h && u || (m[e] = s))
                } else e && (m[e] = n)
            }, t = n = s = function (e, t, n, r, i) {
                if ("string" == typeof e) return g[e] ? g[e](t) : D(f(e, S(t)).f);
                if (!e.splice) {
                    if ((y = e).deps && s(y.deps, y.callback), !t) return;
                    t.splice ? (e = t, t = n, n = null) : e = h
                }
                return t = t || function () {}, "function" == typeof n && (n = r, r = i), r ? o(h, e, t, n) : setTimeout(function () {
                    o(h, e, t, n)
                }, 4), s
            }, s.config = function (e) {
                return s(e)
            }, t._defined = m, (r = function (e, t, n) {
                if ("string" != typeof e) throw new Error("See almond README: incorrect module build, no module name");
                t.splice || (n = t, t = []), b(m, e) || b(v, e) || (v[e] = [e, t, n])
            }).amd = {
                jQuery: !0
            }, e.requirejs = t, e.require = n, e.define = r), e.define("almond", function () {}), e.define("jquery", [], function () {
                var e = u || $;
                return null == e && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."), e
            }), e.define("select2/utils", ["jquery"], function (o) {
                var i = {};

                function u(e) {
                    var t = e.prototype,
                        n = [];
                    for (var r in t) {
                        "function" == typeof t[r] && "constructor" !== r && n.push(r)
                    }
                    return n
                }
                i.Extend = function (e, t) {
                    var n = {}.hasOwnProperty;

                    function r() {
                        this.constructor = e
                    }
                    for (var i in t) n.call(t, i) && (e[i] = t[i]);
                    return r.prototype = t.prototype, e.prototype = new r, e.__super__ = t.prototype, e
                }, i.Decorate = function (r, i) {
                    var e = u(i),
                        t = u(r);

                    function o() {
                        var e = Array.prototype.unshift,
                            t = i.prototype.constructor.length,
                            n = r.prototype.constructor;
                        0 < t && (e.call(arguments, r.prototype.constructor), n = i.prototype.constructor), n.apply(this, arguments)
                    }
                    i.displayName = r.displayName, o.prototype = new function () {
                        this.constructor = o
                    };
                    for (var n = 0; n < t.length; n++) {
                        var s = t[n];
                        o.prototype[s] = r.prototype[s]
                    }

                    function a(e) {
                        var t = function () {};
                        e in o.prototype && (t = o.prototype[e]);
                        var n = i.prototype[e];
                        return function () {
                            return Array.prototype.unshift.call(arguments, t), n.apply(this, arguments)
                        }
                    }
                    for (var l = 0; l < e.length; l++) {
                        var c = e[l];
                        o.prototype[c] = a(c)
                    }
                    return o
                };

                function e() {
                    this.listeners = {}
                }
                e.prototype.on = function (e, t) {
                    this.listeners = this.listeners || {}, e in this.listeners ? this.listeners[e].push(t) : this.listeners[e] = [t]
                }, e.prototype.trigger = function (e) {
                    var t = Array.prototype.slice,
                        n = t.call(arguments, 1);
                    this.listeners = this.listeners || {}, null == n && (n = []), 0 === n.length && n.push({}), (n[0]._type = e) in this.listeners && this.invoke(this.listeners[e], t.call(arguments, 1)), "*" in this.listeners && this.invoke(this.listeners["*"], arguments)
                }, e.prototype.invoke = function (e, t) {
                    for (var n = 0, r = e.length; n < r; n++) e[n].apply(this, t)
                }, i.Observable = e, i.generateChars = function (e) {
                    for (var t = "", n = 0; n < e; n++) {
                        t += Math.floor(36 * Math.random()).toString(36)
                    }
                    return t
                }, i.bind = function (e, t) {
                    return function () {
                        e.apply(t, arguments)
                    }
                }, i._convertData = function (e) {
                    for (var t in e) {
                        var n = t.split("-"),
                            r = e;
                        if (1 !== n.length) {
                            for (var i = 0; i < n.length; i++) {
                                var o = n[i];
                                (o = o.substring(0, 1).toLowerCase() + o.substring(1)) in r || (r[o] = {}), i == n.length - 1 && (r[o] = e[t]), r = r[o]
                            }
                            delete e[t]
                        }
                    }
                    return e
                }, i.hasScroll = function (e, t) {
                    var n = o(t),
                        r = t.style.overflowX,
                        i = t.style.overflowY;
                    return (r !== i || "hidden" !== i && "visible" !== i) && ("scroll" === r || "scroll" === i || (n.innerHeight() < t.scrollHeight || n.innerWidth() < t.scrollWidth))
                }, i.escapeMarkup = function (e) {
                    var t = {
                        "\\": "&#92;",
                        "&": "&amp;",
                        "<": "&lt;",
                        ">": "&gt;",
                        '"': "&quot;",
                        "'": "&#39;",
                        "/": "&#47;"
                    };
                    return "string" != typeof e ? e : String(e).replace(/[&<>"'\/\\]/g, function (e) {
                        return t[e]
                    })
                }, i.appendMany = function (e, t) {
                    if ("1.7" === o.fn.jquery.substr(0, 3)) {
                        var n = o();
                        o.map(t, function (e) {
                            n = n.add(e)
                        }), t = n
                    }
                    e.append(t)
                }, i.__cache = {};
                var n = 0;
                return i.GetUniqueElementId = function (e) {
                    var t = e.getAttribute("data-select2-id");
                    return null == t && (e.id ? (t = e.id, e.setAttribute("data-select2-id", t)) : (e.setAttribute("data-select2-id", ++n), t = n.toString())), t
                }, i.StoreData = function (e, t, n) {
                    var r = i.GetUniqueElementId(e);
                    i.__cache[r] || (i.__cache[r] = {}), i.__cache[r][t] = n
                }, i.GetData = function (e, t) {
                    var n = i.GetUniqueElementId(e);
                    return t ? i.__cache[n] && null != i.__cache[n][t] ? i.__cache[n][t] : o(e).data(t) : i.__cache[n]
                }, i.RemoveData = function (e) {
                    var t = i.GetUniqueElementId(e);
                    null != i.__cache[t] && delete i.__cache[t], e.removeAttribute("data-select2-id")
                }, i
            }), e.define("select2/results", ["jquery", "./utils"], function (h, f) {
                function r(e, t, n) {
                    this.$element = e, this.data = n, this.options = t, r.__super__.constructor.call(this)
                }
                return f.Extend(r, f.Observable), r.prototype.render = function () {
                    var e = h('<ul class="select2-results__options" role="listbox"></ul>');
                    return this.options.get("multiple") && e.attr("aria-multiselectable", "true"), this.$results = e
                }, r.prototype.clear = function () {
                    this.$results.empty()
                }, r.prototype.displayMessage = function (e) {
                    var t = this.options.get("escapeMarkup");
                    this.clear(), this.hideLoading();
                    var n = h('<li role="alert" aria-live="assertive" class="select2-results__option"></li>'),
                        r = this.options.get("translations").get(e.message);
                    n.append(t(r(e.args))), n[0].className += " select2-results__message", this.$results.append(n)
                }, r.prototype.hideMessages = function () {
                    this.$results.find(".select2-results__message").remove()
                }, r.prototype.append = function (e) {
                    this.hideLoading();
                    var t = [];
                    if (null != e.results && 0 !== e.results.length) {
                        e.results = this.sort(e.results);
                        for (var n = 0; n < e.results.length; n++) {
                            var r = e.results[n],
                                i = this.option(r);
                            t.push(i)
                        }
                        this.$results.append(t)
                    } else 0 === this.$results.children().length && this.trigger("results:message", {
                        message: "noResults"
                    })
                }, r.prototype.position = function (e, t) {
                    t.find(".select2-results").append(e)
                }, r.prototype.sort = function (e) {
                    return this.options.get("sorter")(e)
                }, r.prototype.highlightFirstItem = function () {
                    var e = this.$results.find(".select2-results__option[aria-selected]"),
                        t = e.filter("[aria-selected=true]");
                    0 < t.length ? t.first().trigger("mouseenter") : e.first().trigger("mouseenter"), this.ensureHighlightVisible()
                }, r.prototype.setClasses = function () {
                    var t = this;
                    this.data.current(function (e) {
                        var r = h.map(e, function (e) {
                            return e.id.toString()
                        });
                        t.$results.find(".select2-results__option[aria-selected]").each(function () {
                            var e = h(this),
                                t = f.GetData(this, "data"),
                                n = "" + t.id;
                            null != t.element && t.element.selected || null == t.element && -1 < h.inArray(n, r) ? e.attr("aria-selected", "true") : e.attr("aria-selected", "false")
                        })
                    })
                }, r.prototype.showLoading = function (e) {
                    this.hideLoading();
                    var t = {
                            disabled: !0,
                            loading: !0,
                            text: this.options.get("translations").get("searching")(e)
                        },
                        n = this.option(t);
                    n.className += " loading-results", this.$results.prepend(n)
                }, r.prototype.hideLoading = function () {
                    this.$results.find(".loading-results").remove()
                }, r.prototype.option = function (e) {
                    var t = document.createElement("li");
                    t.className = "select2-results__option";
                    var n = {
                            role: "option",
                            "aria-selected": "false"
                        },
                        r = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
                    for (var i in (null != e.element && r.call(e.element, ":disabled") || null == e.element && e.disabled) && (delete n["aria-selected"], n["aria-disabled"] = "true"), null == e.id && delete n["aria-selected"], null != e._resultId && (t.id = e._resultId), e.title && (t.title = e.title), e.children && (n.role = "group", n["aria-label"] = e.text, delete n["aria-selected"]), n) {
                        var o = n[i];
                        t.setAttribute(i, o)
                    }
                    if (e.children) {
                        var s = h(t),
                            a = document.createElement("strong");
                        a.className = "select2-results__group";
                        h(a);
                        this.template(e, a);
                        for (var l = [], c = 0; c < e.children.length; c++) {
                            var u = e.children[c],
                                d = this.option(u);
                            l.push(d)
                        }
                        var p = h("<ul></ul>", {
                            class: "select2-results__options select2-results__options--nested"
                        });
                        p.append(l), s.append(a), s.append(p)
                    } else this.template(e, t);
                    return f.StoreData(t, "data", e), t
                }, r.prototype.bind = function (t, e) {
                    var l = this,
                        n = t.id + "-results";
                    this.$results.attr("id", n), t.on("results:all", function (e) {
                        l.clear(), l.append(e.data), t.isOpen() && (l.setClasses(), l.highlightFirstItem())
                    }), t.on("results:append", function (e) {
                        l.append(e.data), t.isOpen() && l.setClasses()
                    }), t.on("query", function (e) {
                        l.hideMessages(), l.showLoading(e)
                    }), t.on("select", function () {
                        t.isOpen() && (l.setClasses(), l.options.get("scrollAfterSelect") && l.highlightFirstItem())
                    }), t.on("unselect", function () {
                        t.isOpen() && (l.setClasses(), l.options.get("scrollAfterSelect") && l.highlightFirstItem())
                    }), t.on("open", function () {
                        l.$results.attr("aria-expanded", "true"), l.$results.attr("aria-hidden", "false"), l.setClasses(), l.ensureHighlightVisible()
                    }), t.on("close", function () {
                        l.$results.attr("aria-expanded", "false"), l.$results.attr("aria-hidden", "true"), l.$results.removeAttr("aria-activedescendant")
                    }), t.on("results:toggle", function () {
                        var e = l.getHighlightedResults();
                        0 !== e.length && e.trigger("mouseup")
                    }), t.on("results:select", function () {
                        var e = l.getHighlightedResults();
                        if (0 !== e.length) {
                            var t = f.GetData(e[0], "data");
                            "true" == e.attr("aria-selected") ? l.trigger("close", {}) : l.trigger("select", {
                                data: t
                            })
                        }
                    }), t.on("results:previous", function () {
                        var e = l.getHighlightedResults(),
                            t = l.$results.find("[aria-selected]"),
                            n = t.index(e);
                        if (!(n <= 0)) {
                            var r = n - 1;
                            0 === e.length && (r = 0);
                            var i = t.eq(r);
                            i.trigger("mouseenter");
                            var o = l.$results.offset().top,
                                s = i.offset().top,
                                a = l.$results.scrollTop() + (s - o);
                            0 === r ? l.$results.scrollTop(0) : s - o < 0 && l.$results.scrollTop(a)
                        }
                    }), t.on("results:next", function () {
                        var e = l.getHighlightedResults(),
                            t = l.$results.find("[aria-selected]"),
                            n = t.index(e) + 1;
                        if (!(n >= t.length)) {
                            var r = t.eq(n);
                            r.trigger("mouseenter");
                            var i = l.$results.offset().top + l.$results.outerHeight(!1),
                                o = r.offset().top + r.outerHeight(!1),
                                s = l.$results.scrollTop() + o - i;
                            0 === n ? l.$results.scrollTop(0) : i < o && l.$results.scrollTop(s)
                        }
                    }), t.on("results:focus", function (e) {
                        e.element.addClass("select2-results__option--highlighted")
                    }), t.on("results:message", function (e) {
                        l.displayMessage(e)
                    }), h.fn.mousewheel && this.$results.on("mousewheel", function (e) {
                        var t = l.$results.scrollTop(),
                            n = l.$results.get(0).scrollHeight - t + e.deltaY,
                            r = 0 < e.deltaY && t - e.deltaY <= 0,
                            i = e.deltaY < 0 && n <= l.$results.height();
                        r ? (l.$results.scrollTop(0), e.preventDefault(), e.stopPropagation()) : i && (l.$results.scrollTop(l.$results.get(0).scrollHeight - l.$results.height()), e.preventDefault(), e.stopPropagation())
                    }), this.$results.on("mouseup", ".select2-results__option[aria-selected]", function (e) {
                        var t = h(this),
                            n = f.GetData(this, "data");
                        "true" !== t.attr("aria-selected") ? l.trigger("select", {
                            originalEvent: e,
                            data: n
                        }) : l.options.get("multiple") ? l.trigger("unselect", {
                            originalEvent: e,
                            data: n
                        }) : l.trigger("close", {})
                    }), this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function (e) {
                        var t = f.GetData(this, "data");
                        l.getHighlightedResults().removeClass("select2-results__option--highlighted"), l.trigger("results:focus", {
                            data: t,
                            element: h(this)
                        })
                    })
                }, r.prototype.getHighlightedResults = function () {
                    return this.$results.find(".select2-results__option--highlighted")
                }, r.prototype.destroy = function () {
                    this.$results.remove()
                }, r.prototype.ensureHighlightVisible = function () {
                    var e = this.getHighlightedResults();
                    if (0 !== e.length) {
                        var t = this.$results.find("[aria-selected]").index(e),
                            n = this.$results.offset().top,
                            r = e.offset().top,
                            i = this.$results.scrollTop() + (r - n),
                            o = r - n;
                        i -= 2 * e.outerHeight(!1), t <= 2 ? this.$results.scrollTop(0) : (o > this.$results.outerHeight() || o < 0) && this.$results.scrollTop(i)
                    }
                }, r.prototype.template = function (e, t) {
                    var n = this.options.get("templateResult"),
                        r = this.options.get("escapeMarkup"),
                        i = n(e, t);
                    null == i ? t.style.display = "none" : "string" == typeof i ? t.innerHTML = r(i) : h(t).append(i)
                }, r
            }), e.define("select2/keys", [], function () {
                return {
                    BACKSPACE: 8,
                    TAB: 9,
                    ENTER: 13,
                    SHIFT: 16,
                    CTRL: 17,
                    ALT: 18,
                    ESC: 27,
                    SPACE: 32,
                    PAGE_UP: 33,
                    PAGE_DOWN: 34,
                    END: 35,
                    HOME: 36,
                    LEFT: 37,
                    UP: 38,
                    RIGHT: 39,
                    DOWN: 40,
                    DELETE: 46
                }
            }), e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function (n, r, i) {
                function o(e, t) {
                    this.$element = e, this.options = t, o.__super__.constructor.call(this)
                }
                return r.Extend(o, r.Observable), o.prototype.render = function () {
                    var e = n('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
                    return this._tabindex = 0, null != r.GetData(this.$element[0], "old-tabindex") ? this._tabindex = r.GetData(this.$element[0], "old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")), e.attr("title", this.$element.attr("title")), e.attr("tabindex", this._tabindex), e.attr("aria-disabled", "false"), this.$selection = e
                }, o.prototype.bind = function (e, t) {
                    var n = this,
                        r = e.id + "-results";
                    this.container = e, this.$selection.on("focus", function (e) {
                        n.trigger("focus", e)
                    }), this.$selection.on("blur", function (e) {
                        n._handleBlur(e)
                    }), this.$selection.on("keydown", function (e) {
                        n.trigger("keypress", e), e.which === i.SPACE && e.preventDefault()
                    }), e.on("results:focus", function (e) {
                        n.$selection.attr("aria-activedescendant", e.data._resultId)
                    }), e.on("selection:update", function (e) {
                        n.update(e.data)
                    }), e.on("open", function () {
                        n.$selection.attr("aria-expanded", "true"), n.$selection.attr("aria-owns", r), n._attachCloseHandler(e)
                    }), e.on("close", function () {
                        n.$selection.attr("aria-expanded", "false"), n.$selection.removeAttr("aria-activedescendant"), n.$selection.removeAttr("aria-owns"), n.$selection.trigger("focus"), n._detachCloseHandler(e)
                    }), e.on("enable", function () {
                        n.$selection.attr("tabindex", n._tabindex), n.$selection.attr("aria-disabled", "false")
                    }), e.on("disable", function () {
                        n.$selection.attr("tabindex", "-1"), n.$selection.attr("aria-disabled", "true")
                    })
                }, o.prototype._handleBlur = function (e) {
                    var t = this;
                    window.setTimeout(function () {
                        document.activeElement == t.$selection[0] || n.contains(t.$selection[0], document.activeElement) || t.trigger("blur", e)
                    }, 1)
                }, o.prototype._attachCloseHandler = function (e) {
                    n(document.body).on("mousedown.select2." + e.id, function (e) {
                        var t = n(e.target).closest(".select2");
                        n(".select2.select2-container--open").each(function () {
                            this != t[0] && r.GetData(this, "element").select2("close")
                        })
                    })
                }, o.prototype._detachCloseHandler = function (e) {
                    n(document.body).off("mousedown.select2." + e.id)
                }, o.prototype.position = function (e, t) {
                    t.find(".selection").append(e)
                }, o.prototype.destroy = function () {
                    this._detachCloseHandler(this.container)
                }, o.prototype.update = function (e) {
                    throw new Error("The `update` method must be defined in child classes.")
                }, o
            }), e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function (e, t, n, r) {
                function i() {
                    i.__super__.constructor.apply(this, arguments)
                }
                return n.Extend(i, t), i.prototype.render = function () {
                    var e = i.__super__.render.call(this);
                    return e.addClass("select2-selection--single"), e.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), e
                }, i.prototype.bind = function (t, e) {
                    var n = this;
                    i.__super__.bind.apply(this, arguments);
                    var r = t.id + "-container";
                    this.$selection.find(".select2-selection__rendered").attr("id", r).attr("role", "textbox").attr("aria-readonly", "true"), this.$selection.attr("aria-labelledby", r), this.$selection.on("mousedown", function (e) {
                        1 === e.which && n.trigger("toggle", {
                            originalEvent: e
                        })
                    }), this.$selection.on("focus", function (e) {}), this.$selection.on("blur", function (e) {}), t.on("focus", function (e) {
                        t.isOpen() || n.$selection.trigger("focus")
                    })
                }, i.prototype.clear = function () {
                    var e = this.$selection.find(".select2-selection__rendered");
                    e.empty(), e.removeAttr("title")
                }, i.prototype.display = function (e, t) {
                    var n = this.options.get("templateSelection");
                    return this.options.get("escapeMarkup")(n(e, t))
                }, i.prototype.selectionContainer = function () {
                    return e("<span></span>")
                }, i.prototype.update = function (e) {
                    if (0 !== e.length) {
                        var t = e[0],
                            n = this.$selection.find(".select2-selection__rendered"),
                            r = this.display(t, n);
                        n.empty().append(r);
                        var i = t.title || t.text;
                        i ? n.attr("title", i) : n.removeAttr("title")
                    } else this.clear()
                }, i
            }), e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function (i, e, l) {
                function n(e, t) {
                    n.__super__.constructor.apply(this, arguments)
                }
                return l.Extend(n, e), n.prototype.render = function () {
                    var e = n.__super__.render.call(this);
                    return e.addClass("select2-selection--multiple"), e.html('<ul class="select2-selection__rendered"></ul>'), e
                }, n.prototype.bind = function (e, t) {
                    var r = this;
                    n.__super__.bind.apply(this, arguments), this.$selection.on("click", function (e) {
                        r.trigger("toggle", {
                            originalEvent: e
                        })
                    }), this.$selection.on("click", ".select2-selection__choice__remove", function (e) {
                        if (!r.options.get("disabled")) {
                            var t = i(this).parent(),
                                n = l.GetData(t[0], "data");
                            r.trigger("unselect", {
                                originalEvent: e,
                                data: n
                            })
                        }
                    })
                }, n.prototype.clear = function () {
                    var e = this.$selection.find(".select2-selection__rendered");
                    e.empty(), e.removeAttr("title")
                }, n.prototype.display = function (e, t) {
                    var n = this.options.get("templateSelection");
                    return this.options.get("escapeMarkup")(n(e, t))
                }, n.prototype.selectionContainer = function () {
                    return i('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>')
                }, n.prototype.update = function (e) {
                    if (this.clear(), 0 !== e.length) {
                        for (var t = [], n = 0; n < e.length; n++) {
                            var r = e[n],
                                i = this.selectionContainer(),
                                o = this.display(r, i);
                            i.append(o);
                            var s = r.title || r.text;
                            s && i.attr("title", s), l.StoreData(i[0], "data", r), t.push(i)
                        }
                        var a = this.$selection.find(".select2-selection__rendered");
                        l.appendMany(a, t)
                    }
                }, n
            }), e.define("select2/selection/placeholder", ["../utils"], function (e) {
                function t(e, t, n) {
                    this.placeholder = this.normalizePlaceholder(n.get("placeholder")), e.call(this, t, n)
                }
                return t.prototype.normalizePlaceholder = function (e, t) {
                    return "string" == typeof t && (t = {
                        id: "",
                        text: t
                    }), t
                }, t.prototype.createPlaceholder = function (e, t) {
                    var n = this.selectionContainer();
                    return n.html(this.display(t)), n.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), n
                }, t.prototype.update = function (e, t) {
                    var n = 1 == t.length && t[0].id != this.placeholder.id;
                    if (1 < t.length || n) return e.call(this, t);
                    this.clear();
                    var r = this.createPlaceholder(this.placeholder);
                    this.$selection.find(".select2-selection__rendered").append(r)
                }, t
            }), e.define("select2/selection/allowClear", ["jquery", "../keys", "../utils"], function (i, r, a) {
                function e() {}
                return e.prototype.bind = function (e, t, n) {
                    var r = this;
                    e.call(this, t, n), null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."), this.$selection.on("mousedown", ".select2-selection__clear", function (e) {
                        r._handleClear(e)
                    }), t.on("keypress", function (e) {
                        r._handleKeyboardClear(e, t)
                    })
                }, e.prototype._handleClear = function (e, t) {
                    if (!this.options.get("disabled")) {
                        var n = this.$selection.find(".select2-selection__clear");
                        if (0 !== n.length) {
                            t.stopPropagation();
                            var r = a.GetData(n[0], "data"),
                                i = this.$element.val();
                            this.$element.val(this.placeholder.id);
                            var o = {
                                data: r
                            };
                            if (this.trigger("clear", o), o.prevented) this.$element.val(i);
                            else {
                                for (var s = 0; s < r.length; s++)
                                    if (o = {
                                            data: r[s]
                                        }, this.trigger("unselect", o), o.prevented) return void this.$element.val(i);
                                this.$element.trigger("change"), this.trigger("toggle", {})
                            }
                        }
                    }
                }, e.prototype._handleKeyboardClear = function (e, t, n) {
                    n.isOpen() || t.which != r.DELETE && t.which != r.BACKSPACE || this._handleClear(t)
                }, e.prototype.update = function (e, t) {
                    if (e.call(this, t), !(0 < this.$selection.find(".select2-selection__placeholder").length || 0 === t.length)) {
                        var n = this.options.get("translations").get("removeAllItems"),
                            r = i('<span class="select2-selection__clear" title="' + n() + '">&times;</span>');
                        a.StoreData(r[0], "data", t), this.$selection.find(".select2-selection__rendered").prepend(r)
                    }
                }, e
            }), e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function (r, a, l) {
                function e(e, t, n) {
                    e.call(this, t, n)
                }
                return e.prototype.render = function (e) {
                    var t = r('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>');
                    this.$searchContainer = t, this.$search = t.find("input");
                    var n = e.call(this);
                    return this._transferTabIndex(), n
                }, e.prototype.bind = function (e, t, n) {
                    var r = this,
                        i = t.id + "-results";
                    e.call(this, t, n), t.on("open", function () {
                        r.$search.attr("aria-controls", i), r.$search.trigger("focus")
                    }), t.on("close", function () {
                        r.$search.val(""), r.$search.removeAttr("aria-controls"), r.$search.removeAttr("aria-activedescendant"), r.$search.trigger("focus")
                    }), t.on("enable", function () {
                        r.$search.prop("disabled", !1), r._transferTabIndex()
                    }), t.on("disable", function () {
                        r.$search.prop("disabled", !0)
                    }), t.on("focus", function (e) {
                        r.$search.trigger("focus")
                    }), t.on("results:focus", function (e) {
                        e.data._resultId ? r.$search.attr("aria-activedescendant", e.data._resultId) : r.$search.removeAttr("aria-activedescendant")
                    }), this.$selection.on("focusin", ".select2-search--inline", function (e) {
                        r.trigger("focus", e)
                    }), this.$selection.on("focusout", ".select2-search--inline", function (e) {
                        r._handleBlur(e)
                    }), this.$selection.on("keydown", ".select2-search--inline", function (e) {
                        if (e.stopPropagation(), r.trigger("keypress", e), r._keyUpPrevented = e.isDefaultPrevented(), e.which === l.BACKSPACE && "" === r.$search.val()) {
                            var t = r.$searchContainer.prev(".select2-selection__choice");
                            if (0 < t.length) {
                                var n = a.GetData(t[0], "data");
                                r.searchRemoveChoice(n), e.preventDefault()
                            }
                        }
                    }), this.$selection.on("click", ".select2-search--inline", function (e) {
                        r.$search.val() && e.stopPropagation()
                    });
                    var o = document.documentMode,
                        s = o && o <= 11;
                    this.$selection.on("input.searchcheck", ".select2-search--inline", function (e) {
                        s ? r.$selection.off("input.search input.searchcheck") : r.$selection.off("keyup.search")
                    }), this.$selection.on("keyup.search input.search", ".select2-search--inline", function (e) {
                        if (s && "input" === e.type) r.$selection.off("input.search input.searchcheck");
                        else {
                            var t = e.which;
                            t != l.SHIFT && t != l.CTRL && t != l.ALT && t != l.TAB && r.handleSearch(e)
                        }
                    })
                }, e.prototype._transferTabIndex = function (e) {
                    this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1")
                }, e.prototype.createPlaceholder = function (e, t) {
                    this.$search.attr("placeholder", t.text)
                }, e.prototype.update = function (e, t) {
                    var n = this.$search[0] == document.activeElement;
                    this.$search.attr("placeholder", ""), e.call(this, t), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), n && this.$search.trigger("focus")
                }, e.prototype.handleSearch = function () {
                    if (this.resizeSearch(), !this._keyUpPrevented) {
                        var e = this.$search.val();
                        this.trigger("query", {
                            term: e
                        })
                    }
                    this._keyUpPrevented = !1
                }, e.prototype.searchRemoveChoice = function (e, t) {
                    this.trigger("unselect", {
                        data: t
                    }), this.$search.val(t.text), this.handleSearch()
                }, e.prototype.resizeSearch = function () {
                    this.$search.css("width", "25px");
                    var e = "";
                    "" !== this.$search.attr("placeholder") ? e = this.$selection.find(".select2-selection__rendered").width() : e = .75 * (this.$search.val().length + 1) + "em";
                    this.$search.css("width", e)
                }, e
            }), e.define("select2/selection/eventRelay", ["jquery"], function (s) {
                function e() {}
                return e.prototype.bind = function (e, t, n) {
                    var r = this,
                        i = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting", "clear", "clearing"],
                        o = ["opening", "closing", "selecting", "unselecting", "clearing"];
                    e.call(this, t, n), t.on("*", function (e, t) {
                        if (-1 !== s.inArray(e, i)) {
                            t = t || {};
                            var n = s.Event("select2:" + e, {
                                params: t
                            });
                            r.$element.trigger(n), -1 !== s.inArray(e, o) && (t.prevented = n.isDefaultPrevented())
                        }
                    })
                }, e
            }), e.define("select2/translation", ["jquery", "require"], function (t, n) {
                function r(e) {
                    this.dict = e || {}
                }
                return r.prototype.all = function () {
                    return this.dict
                }, r.prototype.get = function (e) {
                    return this.dict[e]
                }, r.prototype.extend = function (e) {
                    this.dict = t.extend({}, e.all(), this.dict)
                }, r._cache = {}, r.loadPath = function (e) {
                    if (!(e in r._cache)) {
                        var t = n(e);
                        r._cache[e] = t
                    }
                    return new r(r._cache[e])
                }, r
            }), e.define("select2/diacritics", [], function () {
                return {
                    "Ⓐ": "A",
                    "Ａ": "A",
                    "À": "A",
                    "Á": "A",
                    "Â": "A",
                    "Ầ": "A",
                    "Ấ": "A",
                    "Ẫ": "A",
                    "Ẩ": "A",
                    "Ã": "A",
                    "Ā": "A",
                    "Ă": "A",
                    "Ằ": "A",
                    "Ắ": "A",
                    "Ẵ": "A",
                    "Ẳ": "A",
                    "Ȧ": "A",
                    "Ǡ": "A",
                    "Ä": "A",
                    "Ǟ": "A",
                    "Ả": "A",
                    "Å": "A",
                    "Ǻ": "A",
                    "Ǎ": "A",
                    "Ȁ": "A",
                    "Ȃ": "A",
                    "Ạ": "A",
                    "Ậ": "A",
                    "Ặ": "A",
                    "Ḁ": "A",
                    "Ą": "A",
                    "Ⱥ": "A",
                    "Ɐ": "A",
                    "Ꜳ": "AA",
                    "Æ": "AE",
                    "Ǽ": "AE",
                    "Ǣ": "AE",
                    "Ꜵ": "AO",
                    "Ꜷ": "AU",
                    "Ꜹ": "AV",
                    "Ꜻ": "AV",
                    "Ꜽ": "AY",
                    "Ⓑ": "B",
                    "Ｂ": "B",
                    "Ḃ": "B",
                    "Ḅ": "B",
                    "Ḇ": "B",
                    "Ƀ": "B",
                    "Ƃ": "B",
                    "Ɓ": "B",
                    "Ⓒ": "C",
                    "Ｃ": "C",
                    "Ć": "C",
                    "Ĉ": "C",
                    "Ċ": "C",
                    "Č": "C",
                    "Ç": "C",
                    "Ḉ": "C",
                    "Ƈ": "C",
                    "Ȼ": "C",
                    "Ꜿ": "C",
                    "Ⓓ": "D",
                    "Ｄ": "D",
                    "Ḋ": "D",
                    "Ď": "D",
                    "Ḍ": "D",
                    "Ḑ": "D",
                    "Ḓ": "D",
                    "Ḏ": "D",
                    "Đ": "D",
                    "Ƌ": "D",
                    "Ɗ": "D",
                    "Ɖ": "D",
                    "Ꝺ": "D",
                    "Ǳ": "DZ",
                    "Ǆ": "DZ",
                    "ǲ": "Dz",
                    "ǅ": "Dz",
                    "Ⓔ": "E",
                    "Ｅ": "E",
                    "È": "E",
                    "É": "E",
                    "Ê": "E",
                    "Ề": "E",
                    "Ế": "E",
                    "Ễ": "E",
                    "Ể": "E",
                    "Ẽ": "E",
                    "Ē": "E",
                    "Ḕ": "E",
                    "Ḗ": "E",
                    "Ĕ": "E",
                    "Ė": "E",
                    "Ë": "E",
                    "Ẻ": "E",
                    "Ě": "E",
                    "Ȅ": "E",
                    "Ȇ": "E",
                    "Ẹ": "E",
                    "Ệ": "E",
                    "Ȩ": "E",
                    "Ḝ": "E",
                    "Ę": "E",
                    "Ḙ": "E",
                    "Ḛ": "E",
                    "Ɛ": "E",
                    "Ǝ": "E",
                    "Ⓕ": "F",
                    "Ｆ": "F",
                    "Ḟ": "F",
                    "Ƒ": "F",
                    "Ꝼ": "F",
                    "Ⓖ": "G",
                    "Ｇ": "G",
                    "Ǵ": "G",
                    "Ĝ": "G",
                    "Ḡ": "G",
                    "Ğ": "G",
                    "Ġ": "G",
                    "Ǧ": "G",
                    "Ģ": "G",
                    "Ǥ": "G",
                    "Ɠ": "G",
                    "Ꞡ": "G",
                    "Ᵹ": "G",
                    "Ꝿ": "G",
                    "Ⓗ": "H",
                    "Ｈ": "H",
                    "Ĥ": "H",
                    "Ḣ": "H",
                    "Ḧ": "H",
                    "Ȟ": "H",
                    "Ḥ": "H",
                    "Ḩ": "H",
                    "Ḫ": "H",
                    "Ħ": "H",
                    "Ⱨ": "H",
                    "Ⱶ": "H",
                    "Ɥ": "H",
                    "Ⓘ": "I",
                    "Ｉ": "I",
                    "Ì": "I",
                    "Í": "I",
                    "Î": "I",
                    "Ĩ": "I",
                    "Ī": "I",
                    "Ĭ": "I",
                    "İ": "I",
                    "Ï": "I",
                    "Ḯ": "I",
                    "Ỉ": "I",
                    "Ǐ": "I",
                    "Ȉ": "I",
                    "Ȋ": "I",
                    "Ị": "I",
                    "Į": "I",
                    "Ḭ": "I",
                    "Ɨ": "I",
                    "Ⓙ": "J",
                    "Ｊ": "J",
                    "Ĵ": "J",
                    "Ɉ": "J",
                    "Ⓚ": "K",
                    "Ｋ": "K",
                    "Ḱ": "K",
                    "Ǩ": "K",
                    "Ḳ": "K",
                    "Ķ": "K",
                    "Ḵ": "K",
                    "Ƙ": "K",
                    "Ⱪ": "K",
                    "Ꝁ": "K",
                    "Ꝃ": "K",
                    "Ꝅ": "K",
                    "Ꞣ": "K",
                    "Ⓛ": "L",
                    "Ｌ": "L",
                    "Ŀ": "L",
                    "Ĺ": "L",
                    "Ľ": "L",
                    "Ḷ": "L",
                    "Ḹ": "L",
                    "Ļ": "L",
                    "Ḽ": "L",
                    "Ḻ": "L",
                    "Ł": "L",
                    "Ƚ": "L",
                    "Ɫ": "L",
                    "Ⱡ": "L",
                    "Ꝉ": "L",
                    "Ꝇ": "L",
                    "Ꞁ": "L",
                    "Ǉ": "LJ",
                    "ǈ": "Lj",
                    "Ⓜ": "M",
                    "Ｍ": "M",
                    "Ḿ": "M",
                    "Ṁ": "M",
                    "Ṃ": "M",
                    "Ɱ": "M",
                    "Ɯ": "M",
                    "Ⓝ": "N",
                    "Ｎ": "N",
                    "Ǹ": "N",
                    "Ń": "N",
                    "Ñ": "N",
                    "Ṅ": "N",
                    "Ň": "N",
                    "Ṇ": "N",
                    "Ņ": "N",
                    "Ṋ": "N",
                    "Ṉ": "N",
                    "Ƞ": "N",
                    "Ɲ": "N",
                    "Ꞑ": "N",
                    "Ꞥ": "N",
                    "Ǌ": "NJ",
                    "ǋ": "Nj",
                    "Ⓞ": "O",
                    "Ｏ": "O",
                    "Ò": "O",
                    "Ó": "O",
                    "Ô": "O",
                    "Ồ": "O",
                    "Ố": "O",
                    "Ỗ": "O",
                    "Ổ": "O",
                    "Õ": "O",
                    "Ṍ": "O",
                    "Ȭ": "O",
                    "Ṏ": "O",
                    "Ō": "O",
                    "Ṑ": "O",
                    "Ṓ": "O",
                    "Ŏ": "O",
                    "Ȯ": "O",
                    "Ȱ": "O",
                    "Ö": "O",
                    "Ȫ": "O",
                    "Ỏ": "O",
                    "Ő": "O",
                    "Ǒ": "O",
                    "Ȍ": "O",
                    "Ȏ": "O",
                    "Ơ": "O",
                    "Ờ": "O",
                    "Ớ": "O",
                    "Ỡ": "O",
                    "Ở": "O",
                    "Ợ": "O",
                    "Ọ": "O",
                    "Ộ": "O",
                    "Ǫ": "O",
                    "Ǭ": "O",
                    "Ø": "O",
                    "Ǿ": "O",
                    "Ɔ": "O",
                    "Ɵ": "O",
                    "Ꝋ": "O",
                    "Ꝍ": "O",
                    "Œ": "OE",
                    "Ƣ": "OI",
                    "Ꝏ": "OO",
                    "Ȣ": "OU",
                    "Ⓟ": "P",
                    "Ｐ": "P",
                    "Ṕ": "P",
                    "Ṗ": "P",
                    "Ƥ": "P",
                    "Ᵽ": "P",
                    "Ꝑ": "P",
                    "Ꝓ": "P",
                    "Ꝕ": "P",
                    "Ⓠ": "Q",
                    "Ｑ": "Q",
                    "Ꝗ": "Q",
                    "Ꝙ": "Q",
                    "Ɋ": "Q",
                    "Ⓡ": "R",
                    "Ｒ": "R",
                    "Ŕ": "R",
                    "Ṙ": "R",
                    "Ř": "R",
                    "Ȑ": "R",
                    "Ȓ": "R",
                    "Ṛ": "R",
                    "Ṝ": "R",
                    "Ŗ": "R",
                    "Ṟ": "R",
                    "Ɍ": "R",
                    "Ɽ": "R",
                    "Ꝛ": "R",
                    "Ꞧ": "R",
                    "Ꞃ": "R",
                    "Ⓢ": "S",
                    "Ｓ": "S",
                    "ẞ": "S",
                    "Ś": "S",
                    "Ṥ": "S",
                    "Ŝ": "S",
                    "Ṡ": "S",
                    "Š": "S",
                    "Ṧ": "S",
                    "Ṣ": "S",
                    "Ṩ": "S",
                    "Ș": "S",
                    "Ş": "S",
                    "Ȿ": "S",
                    "Ꞩ": "S",
                    "Ꞅ": "S",
                    "Ⓣ": "T",
                    "Ｔ": "T",
                    "Ṫ": "T",
                    "Ť": "T",
                    "Ṭ": "T",
                    "Ț": "T",
                    "Ţ": "T",
                    "Ṱ": "T",
                    "Ṯ": "T",
                    "Ŧ": "T",
                    "Ƭ": "T",
                    "Ʈ": "T",
                    "Ⱦ": "T",
                    "Ꞇ": "T",
                    "Ꜩ": "TZ",
                    "Ⓤ": "U",
                    "Ｕ": "U",
                    "Ù": "U",
                    "Ú": "U",
                    "Û": "U",
                    "Ũ": "U",
                    "Ṹ": "U",
                    "Ū": "U",
                    "Ṻ": "U",
                    "Ŭ": "U",
                    "Ü": "U",
                    "Ǜ": "U",
                    "Ǘ": "U",
                    "Ǖ": "U",
                    "Ǚ": "U",
                    "Ủ": "U",
                    "Ů": "U",
                    "Ű": "U",
                    "Ǔ": "U",
                    "Ȕ": "U",
                    "Ȗ": "U",
                    "Ư": "U",
                    "Ừ": "U",
                    "Ứ": "U",
                    "Ữ": "U",
                    "Ử": "U",
                    "Ự": "U",
                    "Ụ": "U",
                    "Ṳ": "U",
                    "Ų": "U",
                    "Ṷ": "U",
                    "Ṵ": "U",
                    "Ʉ": "U",
                    "Ⓥ": "V",
                    "Ｖ": "V",
                    "Ṽ": "V",
                    "Ṿ": "V",
                    "Ʋ": "V",
                    "Ꝟ": "V",
                    "Ʌ": "V",
                    "Ꝡ": "VY",
                    "Ⓦ": "W",
                    "Ｗ": "W",
                    "Ẁ": "W",
                    "Ẃ": "W",
                    "Ŵ": "W",
                    "Ẇ": "W",
                    "Ẅ": "W",
                    "Ẉ": "W",
                    "Ⱳ": "W",
                    "Ⓧ": "X",
                    "Ｘ": "X",
                    "Ẋ": "X",
                    "Ẍ": "X",
                    "Ⓨ": "Y",
                    "Ｙ": "Y",
                    "Ỳ": "Y",
                    "Ý": "Y",
                    "Ŷ": "Y",
                    "Ỹ": "Y",
                    "Ȳ": "Y",
                    "Ẏ": "Y",
                    "Ÿ": "Y",
                    "Ỷ": "Y",
                    "Ỵ": "Y",
                    "Ƴ": "Y",
                    "Ɏ": "Y",
                    "Ỿ": "Y",
                    "Ⓩ": "Z",
                    "Ｚ": "Z",
                    "Ź": "Z",
                    "Ẑ": "Z",
                    "Ż": "Z",
                    "Ž": "Z",
                    "Ẓ": "Z",
                    "Ẕ": "Z",
                    "Ƶ": "Z",
                    "Ȥ": "Z",
                    "Ɀ": "Z",
                    "Ⱬ": "Z",
                    "Ꝣ": "Z",
                    "ⓐ": "a",
                    "ａ": "a",
                    "ẚ": "a",
                    "à": "a",
                    "á": "a",
                    "â": "a",
                    "ầ": "a",
                    "ấ": "a",
                    "ẫ": "a",
                    "ẩ": "a",
                    "ã": "a",
                    "ā": "a",
                    "ă": "a",
                    "ằ": "a",
                    "ắ": "a",
                    "ẵ": "a",
                    "ẳ": "a",
                    "ȧ": "a",
                    "ǡ": "a",
                    "ä": "a",
                    "ǟ": "a",
                    "ả": "a",
                    "å": "a",
                    "ǻ": "a",
                    "ǎ": "a",
                    "ȁ": "a",
                    "ȃ": "a",
                    "ạ": "a",
                    "ậ": "a",
                    "ặ": "a",
                    "ḁ": "a",
                    "ą": "a",
                    "ⱥ": "a",
                    "ɐ": "a",
                    "ꜳ": "aa",
                    "æ": "ae",
                    "ǽ": "ae",
                    "ǣ": "ae",
                    "ꜵ": "ao",
                    "ꜷ": "au",
                    "ꜹ": "av",
                    "ꜻ": "av",
                    "ꜽ": "ay",
                    "ⓑ": "b",
                    "ｂ": "b",
                    "ḃ": "b",
                    "ḅ": "b",
                    "ḇ": "b",
                    "ƀ": "b",
                    "ƃ": "b",
                    "ɓ": "b",
                    "ⓒ": "c",
                    "ｃ": "c",
                    "ć": "c",
                    "ĉ": "c",
                    "ċ": "c",
                    "č": "c",
                    "ç": "c",
                    "ḉ": "c",
                    "ƈ": "c",
                    "ȼ": "c",
                    "ꜿ": "c",
                    "ↄ": "c",
                    "ⓓ": "d",
                    "ｄ": "d",
                    "ḋ": "d",
                    "ď": "d",
                    "ḍ": "d",
                    "ḑ": "d",
                    "ḓ": "d",
                    "ḏ": "d",
                    "đ": "d",
                    "ƌ": "d",
                    "ɖ": "d",
                    "ɗ": "d",
                    "ꝺ": "d",
                    "ǳ": "dz",
                    "ǆ": "dz",
                    "ⓔ": "e",
                    "ｅ": "e",
                    "è": "e",
                    "é": "e",
                    "ê": "e",
                    "ề": "e",
                    "ế": "e",
                    "ễ": "e",
                    "ể": "e",
                    "ẽ": "e",
                    "ē": "e",
                    "ḕ": "e",
                    "ḗ": "e",
                    "ĕ": "e",
                    "ė": "e",
                    "ë": "e",
                    "ẻ": "e",
                    "ě": "e",
                    "ȅ": "e",
                    "ȇ": "e",
                    "ẹ": "e",
                    "ệ": "e",
                    "ȩ": "e",
                    "ḝ": "e",
                    "ę": "e",
                    "ḙ": "e",
                    "ḛ": "e",
                    "ɇ": "e",
                    "ɛ": "e",
                    "ǝ": "e",
                    "ⓕ": "f",
                    "ｆ": "f",
                    "ḟ": "f",
                    "ƒ": "f",
                    "ꝼ": "f",
                    "ⓖ": "g",
                    "ｇ": "g",
                    "ǵ": "g",
                    "ĝ": "g",
                    "ḡ": "g",
                    "ğ": "g",
                    "ġ": "g",
                    "ǧ": "g",
                    "ģ": "g",
                    "ǥ": "g",
                    "ɠ": "g",
                    "ꞡ": "g",
                    "ᵹ": "g",
                    "ꝿ": "g",
                    "ⓗ": "h",
                    "ｈ": "h",
                    "ĥ": "h",
                    "ḣ": "h",
                    "ḧ": "h",
                    "ȟ": "h",
                    "ḥ": "h",
                    "ḩ": "h",
                    "ḫ": "h",
                    "ẖ": "h",
                    "ħ": "h",
                    "ⱨ": "h",
                    "ⱶ": "h",
                    "ɥ": "h",
                    "ƕ": "hv",
                    "ⓘ": "i",
                    "ｉ": "i",
                    "ì": "i",
                    "í": "i",
                    "î": "i",
                    "ĩ": "i",
                    "ī": "i",
                    "ĭ": "i",
                    "ï": "i",
                    "ḯ": "i",
                    "ỉ": "i",
                    "ǐ": "i",
                    "ȉ": "i",
                    "ȋ": "i",
                    "ị": "i",
                    "į": "i",
                    "ḭ": "i",
                    "ɨ": "i",
                    "ı": "i",
                    "ⓙ": "j",
                    "ｊ": "j",
                    "ĵ": "j",
                    "ǰ": "j",
                    "ɉ": "j",
                    "ⓚ": "k",
                    "ｋ": "k",
                    "ḱ": "k",
                    "ǩ": "k",
                    "ḳ": "k",
                    "ķ": "k",
                    "ḵ": "k",
                    "ƙ": "k",
                    "ⱪ": "k",
                    "ꝁ": "k",
                    "ꝃ": "k",
                    "ꝅ": "k",
                    "ꞣ": "k",
                    "ⓛ": "l",
                    "ｌ": "l",
                    "ŀ": "l",
                    "ĺ": "l",
                    "ľ": "l",
                    "ḷ": "l",
                    "ḹ": "l",
                    "ļ": "l",
                    "ḽ": "l",
                    "ḻ": "l",
                    "ſ": "l",
                    "ł": "l",
                    "ƚ": "l",
                    "ɫ": "l",
                    "ⱡ": "l",
                    "ꝉ": "l",
                    "ꞁ": "l",
                    "ꝇ": "l",
                    "ǉ": "lj",
                    "ⓜ": "m",
                    "ｍ": "m",
                    "ḿ": "m",
                    "ṁ": "m",
                    "ṃ": "m",
                    "ɱ": "m",
                    "ɯ": "m",
                    "ⓝ": "n",
                    "ｎ": "n",
                    "ǹ": "n",
                    "ń": "n",
                    "ñ": "n",
                    "ṅ": "n",
                    "ň": "n",
                    "ṇ": "n",
                    "ņ": "n",
                    "ṋ": "n",
                    "ṉ": "n",
                    "ƞ": "n",
                    "ɲ": "n",
                    "ŉ": "n",
                    "ꞑ": "n",
                    "ꞥ": "n",
                    "ǌ": "nj",
                    "ⓞ": "o",
                    "ｏ": "o",
                    "ò": "o",
                    "ó": "o",
                    "ô": "o",
                    "ồ": "o",
                    "ố": "o",
                    "ỗ": "o",
                    "ổ": "o",
                    "õ": "o",
                    "ṍ": "o",
                    "ȭ": "o",
                    "ṏ": "o",
                    "ō": "o",
                    "ṑ": "o",
                    "ṓ": "o",
                    "ŏ": "o",
                    "ȯ": "o",
                    "ȱ": "o",
                    "ö": "o",
                    "ȫ": "o",
                    "ỏ": "o",
                    "ő": "o",
                    "ǒ": "o",
                    "ȍ": "o",
                    "ȏ": "o",
                    "ơ": "o",
                    "ờ": "o",
                    "ớ": "o",
                    "ỡ": "o",
                    "ở": "o",
                    "ợ": "o",
                    "ọ": "o",
                    "ộ": "o",
                    "ǫ": "o",
                    "ǭ": "o",
                    "ø": "o",
                    "ǿ": "o",
                    "ɔ": "o",
                    "ꝋ": "o",
                    "ꝍ": "o",
                    "ɵ": "o",
                    "œ": "oe",
                    "ƣ": "oi",
                    "ȣ": "ou",
                    "ꝏ": "oo",
                    "ⓟ": "p",
                    "ｐ": "p",
                    "ṕ": "p",
                    "ṗ": "p",
                    "ƥ": "p",
                    "ᵽ": "p",
                    "ꝑ": "p",
                    "ꝓ": "p",
                    "ꝕ": "p",
                    "ⓠ": "q",
                    "ｑ": "q",
                    "ɋ": "q",
                    "ꝗ": "q",
                    "ꝙ": "q",
                    "ⓡ": "r",
                    "ｒ": "r",
                    "ŕ": "r",
                    "ṙ": "r",
                    "ř": "r",
                    "ȑ": "r",
                    "ȓ": "r",
                    "ṛ": "r",
                    "ṝ": "r",
                    "ŗ": "r",
                    "ṟ": "r",
                    "ɍ": "r",
                    "ɽ": "r",
                    "ꝛ": "r",
                    "ꞧ": "r",
                    "ꞃ": "r",
                    "ⓢ": "s",
                    "ｓ": "s",
                    "ß": "s",
                    "ś": "s",
                    "ṥ": "s",
                    "ŝ": "s",
                    "ṡ": "s",
                    "š": "s",
                    "ṧ": "s",
                    "ṣ": "s",
                    "ṩ": "s",
                    "ș": "s",
                    "ş": "s",
                    "ȿ": "s",
                    "ꞩ": "s",
                    "ꞅ": "s",
                    "ẛ": "s",
                    "ⓣ": "t",
                    "ｔ": "t",
                    "ṫ": "t",
                    "ẗ": "t",
                    "ť": "t",
                    "ṭ": "t",
                    "ț": "t",
                    "ţ": "t",
                    "ṱ": "t",
                    "ṯ": "t",
                    "ŧ": "t",
                    "ƭ": "t",
                    "ʈ": "t",
                    "ⱦ": "t",
                    "ꞇ": "t",
                    "ꜩ": "tz",
                    "ⓤ": "u",
                    "ｕ": "u",
                    "ù": "u",
                    "ú": "u",
                    "û": "u",
                    "ũ": "u",
                    "ṹ": "u",
                    "ū": "u",
                    "ṻ": "u",
                    "ŭ": "u",
                    "ü": "u",
                    "ǜ": "u",
                    "ǘ": "u",
                    "ǖ": "u",
                    "ǚ": "u",
                    "ủ": "u",
                    "ů": "u",
                    "ű": "u",
                    "ǔ": "u",
                    "ȕ": "u",
                    "ȗ": "u",
                    "ư": "u",
                    "ừ": "u",
                    "ứ": "u",
                    "ữ": "u",
                    "ử": "u",
                    "ự": "u",
                    "ụ": "u",
                    "ṳ": "u",
                    "ų": "u",
                    "ṷ": "u",
                    "ṵ": "u",
                    "ʉ": "u",
                    "ⓥ": "v",
                    "ｖ": "v",
                    "ṽ": "v",
                    "ṿ": "v",
                    "ʋ": "v",
                    "ꝟ": "v",
                    "ʌ": "v",
                    "ꝡ": "vy",
                    "ⓦ": "w",
                    "ｗ": "w",
                    "ẁ": "w",
                    "ẃ": "w",
                    "ŵ": "w",
                    "ẇ": "w",
                    "ẅ": "w",
                    "ẘ": "w",
                    "ẉ": "w",
                    "ⱳ": "w",
                    "ⓧ": "x",
                    "ｘ": "x",
                    "ẋ": "x",
                    "ẍ": "x",
                    "ⓨ": "y",
                    "ｙ": "y",
                    "ỳ": "y",
                    "ý": "y",
                    "ŷ": "y",
                    "ỹ": "y",
                    "ȳ": "y",
                    "ẏ": "y",
                    "ÿ": "y",
                    "ỷ": "y",
                    "ẙ": "y",
                    "ỵ": "y",
                    "ƴ": "y",
                    "ɏ": "y",
                    "ỿ": "y",
                    "ⓩ": "z",
                    "ｚ": "z",
                    "ź": "z",
                    "ẑ": "z",
                    "ż": "z",
                    "ž": "z",
                    "ẓ": "z",
                    "ẕ": "z",
                    "ƶ": "z",
                    "ȥ": "z",
                    "ɀ": "z",
                    "ⱬ": "z",
                    "ꝣ": "z",
                    "Ά": "Α",
                    "Έ": "Ε",
                    "Ή": "Η",
                    "Ί": "Ι",
                    "Ϊ": "Ι",
                    "Ό": "Ο",
                    "Ύ": "Υ",
                    "Ϋ": "Υ",
                    "Ώ": "Ω",
                    "ά": "α",
                    "έ": "ε",
                    "ή": "η",
                    "ί": "ι",
                    "ϊ": "ι",
                    "ΐ": "ι",
                    "ό": "ο",
                    "ύ": "υ",
                    "ϋ": "υ",
                    "ΰ": "υ",
                    "ώ": "ω",
                    "ς": "σ",
                    "’": "'"
                }
            }), e.define("select2/data/base", ["../utils"], function (r) {
                function n(e, t) {
                    n.__super__.constructor.call(this)
                }
                return r.Extend(n, r.Observable), n.prototype.current = function (e) {
                    throw new Error("The `current` method must be defined in child classes.")
                }, n.prototype.query = function (e, t) {
                    throw new Error("The `query` method must be defined in child classes.")
                }, n.prototype.bind = function (e, t) {}, n.prototype.destroy = function () {}, n.prototype.generateResultId = function (e, t) {
                    var n = e.id + "-result-";
                    return n += r.generateChars(4), null != t.id ? n += "-" + t.id.toString() : n += "-" + r.generateChars(4), n
                }, n
            }), e.define("select2/data/select", ["./base", "../utils", "jquery"], function (e, a, l) {
                function n(e, t) {
                    this.$element = e, this.options = t, n.__super__.constructor.call(this)
                }
                return a.Extend(n, e), n.prototype.current = function (e) {
                    var n = [],
                        r = this;
                    this.$element.find(":selected").each(function () {
                        var e = l(this),
                            t = r.item(e);
                        n.push(t)
                    }), e(n)
                }, n.prototype.select = function (i) {
                    var o = this;
                    if (i.selected = !0, l(i.element).is("option")) return i.element.selected = !0, void this.$element.trigger("change");
                    if (this.$element.prop("multiple")) this.current(function (e) {
                        var t = [];
                        (i = [i]).push.apply(i, e);
                        for (var n = 0; n < i.length; n++) {
                            var r = i[n].id; - 1 === l.inArray(r, t) && t.push(r)
                        }
                        o.$element.val(t), o.$element.trigger("change")
                    });
                    else {
                        var e = i.id;
                        this.$element.val(e), this.$element.trigger("change")
                    }
                }, n.prototype.unselect = function (i) {
                    var o = this;
                    if (this.$element.prop("multiple")) {
                        if (i.selected = !1, l(i.element).is("option")) return i.element.selected = !1, void this.$element.trigger("change");
                        this.current(function (e) {
                            for (var t = [], n = 0; n < e.length; n++) {
                                var r = e[n].id;
                                r !== i.id && -1 === l.inArray(r, t) && t.push(r)
                            }
                            o.$element.val(t), o.$element.trigger("change")
                        })
                    }
                }, n.prototype.bind = function (e, t) {
                    var n = this;
                    (this.container = e).on("select", function (e) {
                        n.select(e.data)
                    }), e.on("unselect", function (e) {
                        n.unselect(e.data)
                    })
                }, n.prototype.destroy = function () {
                    this.$element.find("*").each(function () {
                        a.RemoveData(this)
                    })
                }, n.prototype.query = function (r, e) {
                    var i = [],
                        o = this;
                    this.$element.children().each(function () {
                        var e = l(this);
                        if (e.is("option") || e.is("optgroup")) {
                            var t = o.item(e),
                                n = o.matches(r, t);
                            null !== n && i.push(n)
                        }
                    }), e({
                        results: i
                    })
                }, n.prototype.addOptions = function (e) {
                    a.appendMany(this.$element, e)
                }, n.prototype.option = function (e) {
                    var t;
                    e.children ? (t = document.createElement("optgroup")).label = e.text : void 0 !== (t = document.createElement("option")).textContent ? t.textContent = e.text : t.innerText = e.text, void 0 !== e.id && (t.value = e.id), e.disabled && (t.disabled = !0), e.selected && (t.selected = !0), e.title && (t.title = e.title);
                    var n = l(t),
                        r = this._normalizeItem(e);
                    return r.element = t, a.StoreData(t, "data", r), n
                }, n.prototype.item = function (e) {
                    var t = {};
                    if (null != (t = a.GetData(e[0], "data"))) return t;
                    if (e.is("option")) t = {
                        id: e.val(),
                        text: e.text(),
                        disabled: e.prop("disabled"),
                        selected: e.prop("selected"),
                        title: e.prop("title")
                    };
                    else if (e.is("optgroup")) {
                        t = {
                            text: e.prop("label"),
                            children: [],
                            title: e.prop("title")
                        };
                        for (var n = e.children("option"), r = [], i = 0; i < n.length; i++) {
                            var o = l(n[i]),
                                s = this.item(o);
                            r.push(s)
                        }
                        t.children = r
                    }
                    return (t = this._normalizeItem(t)).element = e[0], a.StoreData(e[0], "data", t), t
                }, n.prototype._normalizeItem = function (e) {
                    e !== Object(e) && (e = {
                        id: e,
                        text: e
                    });
                    return null != (e = l.extend({}, {
                        text: ""
                    }, e)).id && (e.id = e.id.toString()), null != e.text && (e.text = e.text.toString()), null == e._resultId && e.id && null != this.container && (e._resultId = this.generateResultId(this.container, e)), l.extend({}, {
                        selected: !1,
                        disabled: !1
                    }, e)
                }, n.prototype.matches = function (e, t) {
                    return this.options.get("matcher")(e, t)
                }, n
            }), e.define("select2/data/array", ["./select", "../utils", "jquery"], function (e, f, g) {
                function r(e, t) {
                    this._dataToConvert = t.get("data") || [], r.__super__.constructor.call(this, e, t)
                }
                return f.Extend(r, e), r.prototype.bind = function (e, t) {
                    r.__super__.bind.call(this, e, t), this.addOptions(this.convertToOptions(this._dataToConvert))
                }, r.prototype.select = function (n) {
                    var e = this.$element.find("option").filter(function (e, t) {
                        return t.value == n.id.toString()
                    });
                    0 === e.length && (e = this.option(n), this.addOptions(e)), r.__super__.select.call(this, n)
                }, r.prototype.convertToOptions = function (e) {
                    var t = this,
                        n = this.$element.find("option"),
                        r = n.map(function () {
                            return t.item(g(this)).id
                        }).get(),
                        i = [];

                    function o(e) {
                        return function () {
                            return g(this).val() == e.id
                        }
                    }
                    for (var s = 0; s < e.length; s++) {
                        var a = this._normalizeItem(e[s]);
                        if (0 <= g.inArray(a.id, r)) {
                            var l = n.filter(o(a)),
                                c = this.item(l),
                                u = g.extend(!0, {}, a, c),
                                d = this.option(u);
                            l.replaceWith(d)
                        } else {
                            var p = this.option(a);
                            if (a.children) {
                                var h = this.convertToOptions(a.children);
                                f.appendMany(p, h)
                            }
                            i.push(p)
                        }
                    }
                    return i
                }, r
            }), e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function (e, t, o) {
                function n(e, t) {
                    this.ajaxOptions = this._applyDefaults(t.get("ajax")), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), n.__super__.constructor.call(this, e, t)
                }
                return t.Extend(n, e), n.prototype._applyDefaults = function (e) {
                    var t = {
                        data: function (e) {
                            return o.extend({}, e, {
                                q: e.term
                            })
                        },
                        transport: function (e, t, n) {
                            var r = o.ajax(e);
                            return r.then(t), r.fail(n), r
                        }
                    };
                    return o.extend({}, t, e, !0)
                }, n.prototype.processResults = function (e) {
                    return e
                }, n.prototype.query = function (n, r) {
                    var i = this;
                    null != this._request && (o.isFunction(this._request.abort) && this._request.abort(), this._request = null);
                    var t = o.extend({
                        type: "GET"
                    }, this.ajaxOptions);

                    function e() {
                        var e = t.transport(t, function (e) {
                            var t = i.processResults(e, n);
                            i.options.get("debug") && window.console && console.error && (t && t.results && o.isArray(t.results) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")), r(t)
                        }, function () {
                            "status" in e && (0 === e.status || "0" === e.status) || i.trigger("results:message", {
                                message: "errorLoading"
                            })
                        });
                        i._request = e
                    }
                    "function" == typeof t.url && (t.url = t.url.call(this.$element, n)), "function" == typeof t.data && (t.data = t.data.call(this.$element, n)), this.ajaxOptions.delay && null != n.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), this._queryTimeout = window.setTimeout(e, this.ajaxOptions.delay)) : e()
                }, n
            }), e.define("select2/data/tags", ["jquery"], function (u) {
                function e(e, t, n) {
                    var r = n.get("tags"),
                        i = n.get("createTag");
                    void 0 !== i && (this.createTag = i);
                    var o = n.get("insertTag");
                    if (void 0 !== o && (this.insertTag = o), e.call(this, t, n), u.isArray(r))
                        for (var s = 0; s < r.length; s++) {
                            var a = r[s],
                                l = this._normalizeItem(a),
                                c = this.option(l);
                            this.$element.append(c)
                        }
                }
                return e.prototype.query = function (e, c, u) {
                    var d = this;
                    this._removeOldTags(), null != c.term && null == c.page ? e.call(this, c, function e(t, n) {
                        for (var r = t.results, i = 0; i < r.length; i++) {
                            var o = r[i],
                                s = null != o.children && !e({
                                    results: o.children
                                }, !0);
                            if ((o.text || "").toUpperCase() === (c.term || "").toUpperCase() || s) return !n && (t.data = r, void u(t))
                        }
                        if (n) return !0;
                        var a = d.createTag(c);
                        if (null != a) {
                            var l = d.option(a);
                            l.attr("data-select2-tag", !0), d.addOptions([l]), d.insertTag(r, a)
                        }
                        t.results = r, u(t)
                    }) : e.call(this, c, u)
                }, e.prototype.createTag = function (e, t) {
                    var n = u.trim(t.term);
                    return "" === n ? null : {
                        id: n,
                        text: n
                    }
                }, e.prototype.insertTag = function (e, t, n) {
                    t.unshift(n)
                }, e.prototype._removeOldTags = function (e) {
                    this.$element.find("option[data-select2-tag]").each(function () {
                        this.selected || u(this).remove()
                    })
                }, e
            }), e.define("select2/data/tokenizer", ["jquery"], function (d) {
                function e(e, t, n) {
                    var r = n.get("tokenizer");
                    void 0 !== r && (this.tokenizer = r), e.call(this, t, n)
                }
                return e.prototype.bind = function (e, t, n) {
                    e.call(this, t, n), this.$search = t.dropdown.$search || t.selection.$search || n.find(".select2-search__field")
                }, e.prototype.query = function (e, t, n) {
                    var r = this;
                    t.term = t.term || "";
                    var i = this.tokenizer(t, this.options, function (e) {
                        var t = r._normalizeItem(e);
                        if (!r.$element.find("option").filter(function () {
                                return d(this).val() === t.id
                            }).length) {
                            var n = r.option(t);
                            n.attr("data-select2-tag", !0), r._removeOldTags(), r.addOptions([n])
                        }! function (e) {
                            r.trigger("select", {
                                data: e
                            })
                        }(t)
                    });
                    i.term !== t.term && (this.$search.length && (this.$search.val(i.term), this.$search.trigger("focus")), t.term = i.term), e.call(this, t, n)
                }, e.prototype.tokenizer = function (e, t, n, r) {
                    for (var i = n.get("tokenSeparators") || [], o = t.term, s = 0, a = this.createTag || function (e) {
                            return {
                                id: e.term,
                                text: e.term
                            }
                        }; s < o.length;) {
                        var l = o[s];
                        if (-1 !== d.inArray(l, i)) {
                            var c = o.substr(0, s),
                                u = a(d.extend({}, t, {
                                    term: c
                                }));
                            null != u ? (r(u), o = o.substr(s + 1) || "", s = 0) : s++
                        } else s++
                    }
                    return {
                        term: o
                    }
                }, e
            }), e.define("select2/data/minimumInputLength", [], function () {
                function e(e, t, n) {
                    this.minimumInputLength = n.get("minimumInputLength"), e.call(this, t, n)
                }
                return e.prototype.query = function (e, t, n) {
                    t.term = t.term || "", t.term.length < this.minimumInputLength ? this.trigger("results:message", {
                        message: "inputTooShort",
                        args: {
                            minimum: this.minimumInputLength,
                            input: t.term,
                            params: t
                        }
                    }) : e.call(this, t, n)
                }, e
            }), e.define("select2/data/maximumInputLength", [], function () {
                function e(e, t, n) {
                    this.maximumInputLength = n.get("maximumInputLength"), e.call(this, t, n)
                }
                return e.prototype.query = function (e, t, n) {
                    t.term = t.term || "", 0 < this.maximumInputLength && t.term.length > this.maximumInputLength ? this.trigger("results:message", {
                        message: "inputTooLong",
                        args: {
                            maximum: this.maximumInputLength,
                            input: t.term,
                            params: t
                        }
                    }) : e.call(this, t, n)
                }, e
            }), e.define("select2/data/maximumSelectionLength", [], function () {
                function e(e, t, n) {
                    this.maximumSelectionLength = n.get("maximumSelectionLength"), e.call(this, t, n)
                }
                return e.prototype.bind = function (e, t, n) {
                    var r = this;
                    e.call(this, t, n), t.on("select", function () {
                        r._checkIfMaximumSelected()
                    })
                }, e.prototype.query = function (e, t, n) {
                    var r = this;
                    this._checkIfMaximumSelected(function () {
                        e.call(r, t, n)
                    })
                }, e.prototype._checkIfMaximumSelected = function (e, n) {
                    var r = this;
                    this.current(function (e) {
                        var t = null != e ? e.length : 0;
                        0 < r.maximumSelectionLength && t >= r.maximumSelectionLength ? r.trigger("results:message", {
                            message: "maximumSelected",
                            args: {
                                maximum: r.maximumSelectionLength
                            }
                        }) : n && n()
                    })
                }, e
            }), e.define("select2/dropdown", ["jquery", "./utils"], function (t, e) {
                function n(e, t) {
                    this.$element = e, this.options = t, n.__super__.constructor.call(this)
                }
                return e.Extend(n, e.Observable), n.prototype.render = function () {
                    var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>');
                    return e.attr("dir", this.options.get("dir")), this.$dropdown = e
                }, n.prototype.bind = function () {}, n.prototype.position = function (e, t) {}, n.prototype.destroy = function () {
                    this.$dropdown.remove()
                }, n
            }), e.define("select2/dropdown/search", ["jquery", "../utils"], function (o, e) {
                function t() {}
                return t.prototype.render = function (e) {
                    var t = e.call(this),
                        n = o('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>');
                    return this.$searchContainer = n, this.$search = n.find("input"), t.prepend(n), t
                }, t.prototype.bind = function (e, t, n) {
                    var r = this,
                        i = t.id + "-results";
                    e.call(this, t, n), this.$search.on("keydown", function (e) {
                        r.trigger("keypress", e), r._keyUpPrevented = e.isDefaultPrevented()
                    }), this.$search.on("input", function (e) {
                        o(this).off("keyup")
                    }), this.$search.on("keyup input", function (e) {
                        r.handleSearch(e)
                    }), t.on("open", function () {
                        r.$search.attr("tabindex", 0), r.$search.attr("aria-controls", i), r.$search.trigger("focus"), window.setTimeout(function () {
                            r.$search.trigger("focus")
                        }, 0)
                    }), t.on("close", function () {
                        r.$search.attr("tabindex", -1), r.$search.removeAttr("aria-controls"), r.$search.removeAttr("aria-activedescendant"), r.$search.val(""), r.$search.trigger("blur")
                    }), t.on("focus", function () {
                        t.isOpen() || r.$search.trigger("focus")
                    }), t.on("results:all", function (e) {
                        null != e.query.term && "" !== e.query.term || (r.showSearch(e) ? r.$searchContainer.removeClass("select2-search--hide") : r.$searchContainer.addClass("select2-search--hide"))
                    }), t.on("results:focus", function (e) {
                        e.data._resultId ? r.$search.attr("aria-activedescendant", e.data._resultId) : r.$search.removeAttr("aria-activedescendant")
                    })
                }, t.prototype.handleSearch = function (e) {
                    if (!this._keyUpPrevented) {
                        var t = this.$search.val();
                        this.trigger("query", {
                            term: t
                        })
                    }
                    this._keyUpPrevented = !1
                }, t.prototype.showSearch = function (e, t) {
                    return !0
                }, t
            }), e.define("select2/dropdown/hidePlaceholder", [], function () {
                function e(e, t, n, r) {
                    this.placeholder = this.normalizePlaceholder(n.get("placeholder")), e.call(this, t, n, r)
                }
                return e.prototype.append = function (e, t) {
                    t.results = this.removePlaceholder(t.results), e.call(this, t)
                }, e.prototype.normalizePlaceholder = function (e, t) {
                    return "string" == typeof t && (t = {
                        id: "",
                        text: t
                    }), t
                }, e.prototype.removePlaceholder = function (e, t) {
                    for (var n = t.slice(0), r = t.length - 1; 0 <= r; r--) {
                        var i = t[r];
                        this.placeholder.id === i.id && n.splice(r, 1)
                    }
                    return n
                }, e
            }), e.define("select2/dropdown/infiniteScroll", ["jquery"], function (n) {
                function e(e, t, n, r) {
                    this.lastParams = {}, e.call(this, t, n, r), this.$loadingMore = this.createLoadingMore(), this.loading = !1
                }
                return e.prototype.append = function (e, t) {
                    this.$loadingMore.remove(), this.loading = !1, e.call(this, t), this.showLoadingMore(t) && (this.$results.append(this.$loadingMore), this.loadMoreIfNeeded())
                }, e.prototype.bind = function (e, t, n) {
                    var r = this;
                    e.call(this, t, n), t.on("query", function (e) {
                        r.lastParams = e, r.loading = !0
                    }), t.on("query:append", function (e) {
                        r.lastParams = e, r.loading = !0
                    }), this.$results.on("scroll", this.loadMoreIfNeeded.bind(this))
                }, e.prototype.loadMoreIfNeeded = function () {
                    var e = n.contains(document.documentElement, this.$loadingMore[0]);
                    if (!this.loading && e) {
                        var t = this.$results.offset().top + this.$results.outerHeight(!1);
                        this.$loadingMore.offset().top + this.$loadingMore.outerHeight(!1) <= t + 50 && this.loadMore()
                    }
                }, e.prototype.loadMore = function () {
                    this.loading = !0;
                    var e = n.extend({}, {
                        page: 1
                    }, this.lastParams);
                    e.page++, this.trigger("query:append", e)
                }, e.prototype.showLoadingMore = function (e, t) {
                    return t.pagination && t.pagination.more
                }, e.prototype.createLoadingMore = function () {
                    var e = n('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'),
                        t = this.options.get("translations").get("loadingMore");
                    return e.html(t(this.lastParams)), e
                }, e
            }), e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function (f, a) {
                function e(e, t, n) {
                    this.$dropdownParent = f(n.get("dropdownParent") || document.body), e.call(this, t, n)
                }
                return e.prototype.bind = function (e, t, n) {
                    var r = this;
                    e.call(this, t, n), t.on("open", function () {
                        r._showDropdown(), r._attachPositioningHandler(t), r._bindContainerResultHandlers(t)
                    }), t.on("close", function () {
                        r._hideDropdown(), r._detachPositioningHandler(t)
                    }), this.$dropdownContainer.on("mousedown", function (e) {
                        e.stopPropagation()
                    })
                }, e.prototype.destroy = function (e) {
                    e.call(this), this.$dropdownContainer.remove()
                }, e.prototype.position = function (e, t, n) {
                    t.attr("class", n.attr("class")), t.removeClass("select2"), t.addClass("select2-container--open"), t.css({
                        position: "absolute",
                        top: -999999
                    }), this.$container = n
                }, e.prototype.render = function (e) {
                    var t = f("<span></span>"),
                        n = e.call(this);
                    return t.append(n), this.$dropdownContainer = t
                }, e.prototype._hideDropdown = function (e) {
                    this.$dropdownContainer.detach()
                }, e.prototype._bindContainerResultHandlers = function (e, t) {
                    if (!this._containerResultsHandlersBound) {
                        var n = this;
                        t.on("results:all", function () {
                            n._positionDropdown(), n._resizeDropdown()
                        }), t.on("results:append", function () {
                            n._positionDropdown(), n._resizeDropdown()
                        }), t.on("results:message", function () {
                            n._positionDropdown(), n._resizeDropdown()
                        }), t.on("select", function () {
                            n._positionDropdown(), n._resizeDropdown()
                        }), t.on("unselect", function () {
                            n._positionDropdown(), n._resizeDropdown()
                        }), this._containerResultsHandlersBound = !0
                    }
                }, e.prototype._attachPositioningHandler = function (e, t) {
                    var n = this,
                        r = "scroll.select2." + t.id,
                        i = "resize.select2." + t.id,
                        o = "orientationchange.select2." + t.id,
                        s = this.$container.parents().filter(a.hasScroll);
                    s.each(function () {
                        a.StoreData(this, "select2-scroll-position", {
                            x: f(this).scrollLeft(),
                            y: f(this).scrollTop()
                        })
                    }), s.on(r, function (e) {
                        var t = a.GetData(this, "select2-scroll-position");
                        f(this).scrollTop(t.y)
                    }), f(window).on(r + " " + i + " " + o, function (e) {
                        n._positionDropdown(), n._resizeDropdown()
                    })
                }, e.prototype._detachPositioningHandler = function (e, t) {
                    var n = "scroll.select2." + t.id,
                        r = "resize.select2." + t.id,
                        i = "orientationchange.select2." + t.id;
                    this.$container.parents().filter(a.hasScroll).off(n), f(window).off(n + " " + r + " " + i)
                }, e.prototype._positionDropdown = function () {
                    var e = f(window),
                        t = this.$dropdown.hasClass("select2-dropdown--above"),
                        n = this.$dropdown.hasClass("select2-dropdown--below"),
                        r = null,
                        i = this.$container.offset();
                    i.bottom = i.top + this.$container.outerHeight(!1);
                    var o = {
                        height: this.$container.outerHeight(!1)
                    };
                    o.top = i.top, o.bottom = i.top + o.height;
                    var s = this.$dropdown.outerHeight(!1),
                        a = e.scrollTop(),
                        l = e.scrollTop() + e.height(),
                        c = a < i.top - s,
                        u = l > i.bottom + s,
                        d = {
                            left: i.left,
                            top: o.bottom
                        },
                        p = this.$dropdownParent;
                    "static" === p.css("position") && (p = p.offsetParent());
                    var h = p.offset();
                    d.top -= h.top, d.left -= h.left, t || n || (r = "below"), u || !c || t ? !c && u && t && (r = "below") : r = "above", ("above" == r || t && "below" !== r) && (d.top = o.top - h.top - s), null != r && (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + r), this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + r)), this.$dropdownContainer.css(d)
                }, e.prototype._resizeDropdown = function () {
                    var e = {
                        width: this.$container.outerWidth(!1) + "px"
                    };
                    this.options.get("dropdownAutoWidth") && (e.minWidth = e.width, e.position = "relative", e.width = "auto"), this.$dropdown.css(e)
                }, e.prototype._showDropdown = function (e) {
                    this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown()
                }, e
            }), e.define("select2/dropdown/minimumResultsForSearch", [], function () {
                function e(e, t, n, r) {
                    this.minimumResultsForSearch = n.get("minimumResultsForSearch"), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), e.call(this, t, n, r)
                }
                return e.prototype.showSearch = function (e, t) {
                    return !(function e(t) {
                        for (var n = 0, r = 0; r < t.length; r++) {
                            var i = t[r];
                            i.children ? n += e(i.children) : n++
                        }
                        return n
                    }(t.data.results) < this.minimumResultsForSearch) && e.call(this, t)
                }, e
            }), e.define("select2/dropdown/selectOnClose", ["../utils"], function (o) {
                function e() {}
                return e.prototype.bind = function (e, t, n) {
                    var r = this;
                    e.call(this, t, n), t.on("close", function (e) {
                        r._handleSelectOnClose(e)
                    })
                }, e.prototype._handleSelectOnClose = function (e, t) {
                    if (t && null != t.originalSelect2Event) {
                        var n = t.originalSelect2Event;
                        if ("select" === n._type || "unselect" === n._type) return
                    }
                    var r = this.getHighlightedResults();
                    if (!(r.length < 1)) {
                        var i = o.GetData(r[0], "data");
                        null != i.element && i.element.selected || null == i.element && i.selected || this.trigger("select", {
                            data: i
                        })
                    }
                }, e
            }), e.define("select2/dropdown/closeOnSelect", [], function () {
                function e() {}
                return e.prototype.bind = function (e, t, n) {
                    var r = this;
                    e.call(this, t, n), t.on("select", function (e) {
                        r._selectTriggered(e)
                    }), t.on("unselect", function (e) {
                        r._selectTriggered(e)
                    })
                }, e.prototype._selectTriggered = function (e, t) {
                    var n = t.originalEvent;
                    n && (n.ctrlKey || n.metaKey) || this.trigger("close", {
                        originalEvent: n,
                        originalSelect2Event: t
                    })
                }, e
            }), e.define("select2/i18n/en", [], function () {
                return {
                    errorLoading: function () {
                        return "The results could not be loaded."
                    },
                    inputTooLong: function (e) {
                        var t = e.input.length - e.maximum,
                            n = "Please delete " + t + " character";
                        return 1 != t && (n += "s"), n
                    },
                    inputTooShort: function (e) {
                        return "Please enter " + (e.minimum - e.input.length) + " or more characters"
                    },
                    loadingMore: function () {
                        return "Loading more results…"
                    },
                    maximumSelected: function (e) {
                        var t = "You can only select " + e.maximum + " item";
                        return 1 != e.maximum && (t += "s"), t
                    },
                    noResults: function () {
                        return "No results found"
                    },
                    searching: function () {
                        return "Searching…"
                    },
                    removeAllItems: function () {
                        return "Remove all items"
                    }
                }
            }), e.define("select2/defaults", ["jquery", "require", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./i18n/en"], function (c, u, d, p, h, f, g, m, v, y, s, t, _, $, w, b, A, x, D, S, E, C, O, T, q, L, I, j, e) {
                function n() {
                    this.reset()
                }
                return n.prototype.apply = function (e) {
                    if (null == (e = c.extend(!0, {}, this.defaults, e)).dataAdapter) {
                        if (null != e.ajax ? e.dataAdapter = w : null != e.data ? e.dataAdapter = $ : e.dataAdapter = _, 0 < e.minimumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, x)), 0 < e.maximumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, D)), 0 < e.maximumSelectionLength && (e.dataAdapter = y.Decorate(e.dataAdapter, S)), e.tags && (e.dataAdapter = y.Decorate(e.dataAdapter, b)), null == e.tokenSeparators && null == e.tokenizer || (e.dataAdapter = y.Decorate(e.dataAdapter, A)), null != e.query) {
                            var t = u(e.amdBase + "compat/query");
                            e.dataAdapter = y.Decorate(e.dataAdapter, t)
                        }
                        if (null != e.initSelection) {
                            var n = u(e.amdBase + "compat/initSelection");
                            e.dataAdapter = y.Decorate(e.dataAdapter, n)
                        }
                    }
                    if (null == e.resultsAdapter && (e.resultsAdapter = d, null != e.ajax && (e.resultsAdapter = y.Decorate(e.resultsAdapter, T)), null != e.placeholder && (e.resultsAdapter = y.Decorate(e.resultsAdapter, O)), e.selectOnClose && (e.resultsAdapter = y.Decorate(e.resultsAdapter, I))), null == e.dropdownAdapter) {
                        if (e.multiple) e.dropdownAdapter = E;
                        else {
                            var r = y.Decorate(E, C);
                            e.dropdownAdapter = r
                        }
                        if (0 !== e.minimumResultsForSearch && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, L)), e.closeOnSelect && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, j)), null != e.dropdownCssClass || null != e.dropdownCss || null != e.adaptDropdownCssClass) {
                            var i = u(e.amdBase + "compat/dropdownCss");
                            e.dropdownAdapter = y.Decorate(e.dropdownAdapter, i)
                        }
                        e.dropdownAdapter = y.Decorate(e.dropdownAdapter, q)
                    }
                    if (null == e.selectionAdapter) {
                        if (e.multiple ? e.selectionAdapter = h : e.selectionAdapter = p, null != e.placeholder && (e.selectionAdapter = y.Decorate(e.selectionAdapter, f)), e.allowClear && (e.selectionAdapter = y.Decorate(e.selectionAdapter, g)), e.multiple && (e.selectionAdapter = y.Decorate(e.selectionAdapter, m)), null != e.containerCssClass || null != e.containerCss || null != e.adaptContainerCssClass) {
                            var o = u(e.amdBase + "compat/containerCss");
                            e.selectionAdapter = y.Decorate(e.selectionAdapter, o)
                        }
                        e.selectionAdapter = y.Decorate(e.selectionAdapter, v)
                    }
                    e.language = this._resolveLanguage(e.language), e.language.push("en");
                    for (var s = [], a = 0; a < e.language.length; a++) {
                        var l = e.language[a]; - 1 === s.indexOf(l) && s.push(l)
                    }
                    return e.language = s, e.translations = this._processTranslations(e.language, e.debug), e
                }, n.prototype.reset = function () {
                    function a(e) {
                        return e.replace(/[^\u0000-\u007E]/g, function (e) {
                            return t[e] || e
                        })
                    }
                    this.defaults = {
                        amdBase: "./",
                        amdLanguageBase: "./i18n/",
                        closeOnSelect: !0,
                        debug: !1,
                        dropdownAutoWidth: !1,
                        escapeMarkup: y.escapeMarkup,
                        language: {},
                        matcher: function e(t, n) {
                            if ("" === c.trim(t.term)) return n;
                            if (n.children && 0 < n.children.length) {
                                for (var r = c.extend(!0, {}, n), i = n.children.length - 1; 0 <= i; i--) null == e(t, n.children[i]) && r.children.splice(i, 1);
                                return 0 < r.children.length ? r : e(t, r)
                            }
                            var o = a(n.text).toUpperCase(),
                                s = a(t.term).toUpperCase();
                            return -1 < o.indexOf(s) ? n : null
                        },
                        minimumInputLength: 0,
                        maximumInputLength: 0,
                        maximumSelectionLength: 0,
                        minimumResultsForSearch: 0,
                        selectOnClose: !1,
                        scrollAfterSelect: !1,
                        sorter: function (e) {
                            return e
                        },
                        templateResult: function (e) {
                            return e.text
                        },
                        templateSelection: function (e) {
                            return e.text
                        },
                        theme: "default",
                        width: "resolve"
                    }
                }, n.prototype.applyFromElement = function (e, t) {
                    var n = e.language,
                        r = this.defaults.language,
                        i = t.prop("lang"),
                        o = t.closest("[lang]").prop("lang"),
                        s = Array.prototype.concat.call(this._resolveLanguage(i), this._resolveLanguage(n), this._resolveLanguage(r), this._resolveLanguage(o));
                    return e.language = s, e
                }, n.prototype._resolveLanguage = function (e) {
                    if (!e) return [];
                    if (c.isEmptyObject(e)) return [];
                    if (c.isPlainObject(e)) return [e];
                    var t;
                    t = c.isArray(e) ? e : [e];
                    for (var n = [], r = 0; r < t.length; r++)
                        if (n.push(t[r]), "string" == typeof t[r] && 0 < t[r].indexOf("-")) {
                            var i = t[r].split("-")[0];
                            n.push(i)
                        } return n
                }, n.prototype._processTranslations = function (e, t) {
                    for (var n = new s, r = 0; r < e.length; r++) {
                        var i = new s,
                            o = e[r];
                        if ("string" == typeof o) try {
                            i = s.loadPath(o)
                        } catch (e) {
                            try {
                                o = this.defaults.amdLanguageBase + o, i = s.loadPath(o)
                            } catch (e) {
                                t && window.console && console.warn && console.warn('Select2: The language file for "' + o + '" could not be automatically loaded. A fallback will be used instead.')
                            }
                        } else i = c.isPlainObject(o) ? new s(o) : o;
                        n.extend(i)
                    }
                    return n
                }, n.prototype.set = function (e, t) {
                    var n = {};
                    n[c.camelCase(e)] = t;
                    var r = y._convertData(n);
                    c.extend(!0, this.defaults, r)
                }, new n
            }), e.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function (r, d, i, p) {
                function e(e, t) {
                    if (this.options = e, null != t && this.fromElement(t), null != t && (this.options = i.applyFromElement(this.options, t)), this.options = i.apply(this.options), t && t.is("input")) {
                        var n = r(this.get("amdBase") + "compat/inputData");
                        this.options.dataAdapter = p.Decorate(this.options.dataAdapter, n)
                    }
                }
                return e.prototype.fromElement = function (e) {
                    var t = ["select2"];
                    null == this.options.multiple && (this.options.multiple = e.prop("multiple")), null == this.options.disabled && (this.options.disabled = e.prop("disabled")), null == this.options.dir && (e.prop("dir") ? this.options.dir = e.prop("dir") : e.closest("[dir]").prop("dir") ? this.options.dir = e.closest("[dir]").prop("dir") : this.options.dir = "ltr"), e.prop("disabled", this.options.disabled), e.prop("multiple", this.options.multiple), p.GetData(e[0], "select2Tags") && (this.options.debug && window.console && console.warn && console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'), p.StoreData(e[0], "data", p.GetData(e[0], "select2Tags")), p.StoreData(e[0], "tags", !0)), p.GetData(e[0], "ajaxUrl") && (this.options.debug && window.console && console.warn && console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."), e.attr("ajax--url", p.GetData(e[0], "ajaxUrl")), p.StoreData(e[0], "ajax-Url", p.GetData(e[0], "ajaxUrl")));
                    var n = {};

                    function r(e, t) {
                        return t.toUpperCase()
                    }
                    for (var i = 0; i < e[0].attributes.length; i++) {
                        var o = e[0].attributes[i].name,
                            s = "data-";
                        if (o.substr(0, s.length) == s) {
                            var a = o.substring(s.length),
                                l = p.GetData(e[0], a);
                            n[a.replace(/-([a-z])/g, r)] = l
                        }
                    }
                    d.fn.jquery && "1." == d.fn.jquery.substr(0, 2) && e[0].dataset && (n = d.extend(!0, {}, e[0].dataset, n));
                    var c = d.extend(!0, {}, p.GetData(e[0]), n);
                    for (var u in c = p._convertData(c)) - 1 < d.inArray(u, t) || (d.isPlainObject(this.options[u]) ? d.extend(this.options[u], c[u]) : this.options[u] = c[u]);
                    return this
                }, e.prototype.get = function (e) {
                    return this.options[e]
                }, e.prototype.set = function (e, t) {
                    this.options[e] = t
                }, e
            }), e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function (i, c, u, r) {
                var d = function (e, t) {
                    null != u.GetData(e[0], "select2") && u.GetData(e[0], "select2").destroy(), this.$element = e, this.id = this._generateId(e), t = t || {}, this.options = new c(t, e), d.__super__.constructor.call(this);
                    var n = e.attr("tabindex") || 0;
                    u.StoreData(e[0], "old-tabindex", n), e.attr("tabindex", "-1");
                    var r = this.options.get("dataAdapter");
                    this.dataAdapter = new r(e, this.options);
                    var i = this.render();
                    this._placeContainer(i);
                    var o = this.options.get("selectionAdapter");
                    this.selection = new o(e, this.options), this.$selection = this.selection.render(), this.selection.position(this.$selection, i);
                    var s = this.options.get("dropdownAdapter");
                    this.dropdown = new s(e, this.options), this.$dropdown = this.dropdown.render(), this.dropdown.position(this.$dropdown, i);
                    var a = this.options.get("resultsAdapter");
                    this.results = new a(e, this.options, this.dataAdapter), this.$results = this.results.render(), this.results.position(this.$results, this.$dropdown);
                    var l = this;
                    this._bindAdapters(), this._registerDomEvents(), this._registerDataEvents(), this._registerSelectionEvents(), this._registerDropdownEvents(), this._registerResultsEvents(), this._registerEvents(), this.dataAdapter.current(function (e) {
                        l.trigger("selection:update", {
                            data: e
                        })
                    }), e.addClass("select2-hidden-accessible"), e.attr("aria-hidden", "true"), this._syncAttributes(), u.StoreData(e[0], "select2", this), e.data("select2", this)
                };
                return u.Extend(d, u.Observable), d.prototype._generateId = function (e) {
                    return "select2-" + (null != e.attr("id") ? e.attr("id") : null != e.attr("name") ? e.attr("name") + "-" + u.generateChars(2) : u.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "")
                }, d.prototype._placeContainer = function (e) {
                    e.insertAfter(this.$element);
                    var t = this._resolveWidth(this.$element, this.options.get("width"));
                    null != t && e.css("width", t)
                }, d.prototype._resolveWidth = function (e, t) {
                    var n = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                    if ("resolve" == t) {
                        var r = this._resolveWidth(e, "style");
                        return null != r ? r : this._resolveWidth(e, "element")
                    }
                    if ("element" == t) {
                        var i = e.outerWidth(!1);
                        return i <= 0 ? "auto" : i + "px"
                    }
                    if ("style" != t) return "computedstyle" != t ? t : window.getComputedStyle(e[0]).width;
                    var o = e.attr("style");
                    if ("string" != typeof o) return null;
                    for (var s = o.split(";"), a = 0, l = s.length; a < l; a += 1) {
                        var c = s[a].replace(/\s/g, "").match(n);
                        if (null !== c && 1 <= c.length) return c[1]
                    }
                    return null
                }, d.prototype._bindAdapters = function () {
                    this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container)
                }, d.prototype._registerDomEvents = function () {
                    var t = this;
                    this.$element.on("change.select2", function () {
                        t.dataAdapter.current(function (e) {
                            t.trigger("selection:update", {
                                data: e
                            })
                        })
                    }), this.$element.on("focus.select2", function (e) {
                        t.trigger("focus", e)
                    }), this._syncA = u.bind(this._syncAttributes, this), this._syncS = u.bind(this._syncSubtree, this), this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
                    var e = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                    null != e ? (this._observer = new e(function (e) {
                        i.each(e, t._syncA), i.each(e, t._syncS)
                    }), this._observer.observe(this.$element[0], {
                        attributes: !0,
                        childList: !0,
                        subtree: !1
                    })) : this.$element[0].addEventListener && (this.$element[0].addEventListener("DOMAttrModified", t._syncA, !1), this.$element[0].addEventListener("DOMNodeInserted", t._syncS, !1), this.$element[0].addEventListener("DOMNodeRemoved", t._syncS, !1))
                }, d.prototype._registerDataEvents = function () {
                    var n = this;
                    this.dataAdapter.on("*", function (e, t) {
                        n.trigger(e, t)
                    })
                }, d.prototype._registerSelectionEvents = function () {
                    var n = this,
                        r = ["toggle", "focus"];
                    this.selection.on("toggle", function () {
                        n.toggleDropdown()
                    }), this.selection.on("focus", function (e) {
                        n.focus(e)
                    }), this.selection.on("*", function (e, t) {
                        -1 === i.inArray(e, r) && n.trigger(e, t)
                    })
                }, d.prototype._registerDropdownEvents = function () {
                    var n = this;
                    this.dropdown.on("*", function (e, t) {
                        n.trigger(e, t)
                    })
                }, d.prototype._registerResultsEvents = function () {
                    var n = this;
                    this.results.on("*", function (e, t) {
                        n.trigger(e, t)
                    })
                }, d.prototype._registerEvents = function () {
                    var n = this;
                    this.on("open", function () {
                        n.$container.addClass("select2-container--open")
                    }), this.on("close", function () {
                        n.$container.removeClass("select2-container--open")
                    }), this.on("enable", function () {
                        n.$container.removeClass("select2-container--disabled")
                    }), this.on("disable", function () {
                        n.$container.addClass("select2-container--disabled")
                    }), this.on("blur", function () {
                        n.$container.removeClass("select2-container--focus")
                    }), this.on("query", function (t) {
                        n.isOpen() || n.trigger("open", {}), this.dataAdapter.query(t, function (e) {
                            n.trigger("results:all", {
                                data: e,
                                query: t
                            })
                        })
                    }), this.on("query:append", function (t) {
                        this.dataAdapter.query(t, function (e) {
                            n.trigger("results:append", {
                                data: e,
                                query: t
                            })
                        })
                    }), this.on("keypress", function (e) {
                        var t = e.which;
                        n.isOpen() ? t === r.ESC || t === r.TAB || t === r.UP && e.altKey ? (n.close(), e.preventDefault()) : t === r.ENTER ? (n.trigger("results:select", {}), e.preventDefault()) : t === r.SPACE && e.ctrlKey ? (n.trigger("results:toggle", {}), e.preventDefault()) : t === r.UP ? (n.trigger("results:previous", {}), e.preventDefault()) : t === r.DOWN && (n.trigger("results:next", {}), e.preventDefault()) : (t === r.ENTER || t === r.SPACE || t === r.DOWN && e.altKey) && (n.open(), e.preventDefault())
                    })
                }, d.prototype._syncAttributes = function () {
                    this.options.set("disabled", this.$element.prop("disabled")), this.options.get("disabled") ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {})
                }, d.prototype._syncSubtree = function (e, t) {
                    var n = !1,
                        r = this;
                    if (!e || !e.target || "OPTION" === e.target.nodeName || "OPTGROUP" === e.target.nodeName) {
                        if (t)
                            if (t.addedNodes && 0 < t.addedNodes.length)
                                for (var i = 0; i < t.addedNodes.length; i++) {
                                    t.addedNodes[i].selected && (n = !0)
                                } else t.removedNodes && 0 < t.removedNodes.length && (n = !0);
                            else n = !0;
                        n && this.dataAdapter.current(function (e) {
                            r.trigger("selection:update", {
                                data: e
                            })
                        })
                    }
                }, d.prototype.trigger = function (e, t) {
                    var n = d.__super__.trigger,
                        r = {
                            open: "opening",
                            close: "closing",
                            select: "selecting",
                            unselect: "unselecting",
                            clear: "clearing"
                        };
                    if (void 0 === t && (t = {}), e in r) {
                        var i = r[e],
                            o = {
                                prevented: !1,
                                name: e,
                                args: t
                            };
                        if (n.call(this, i, o), o.prevented) return void(t.prevented = !0)
                    }
                    n.call(this, e, t)
                }, d.prototype.toggleDropdown = function () {
                    this.options.get("disabled") || (this.isOpen() ? this.close() : this.open())
                }, d.prototype.open = function () {
                    this.isOpen() || this.trigger("query", {})
                }, d.prototype.close = function () {
                    this.isOpen() && this.trigger("close", {})
                }, d.prototype.isOpen = function () {
                    return this.$container.hasClass("select2-container--open")
                }, d.prototype.hasFocus = function () {
                    return this.$container.hasClass("select2-container--focus")
                }, d.prototype.focus = function (e) {
                    this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}))
                }, d.prototype.enable = function (e) {
                    this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'), null != e && 0 !== e.length || (e = [!0]);
                    var t = !e[0];
                    this.$element.prop("disabled", t)
                }, d.prototype.data = function () {
                    this.options.get("debug") && 0 < arguments.length && window.console && console.warn && console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
                    var t = [];
                    return this.dataAdapter.current(function (e) {
                        t = e
                    }), t
                }, d.prototype.val = function (e) {
                    if (this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'), null == e || 0 === e.length) return this.$element.val();
                    var t = e[0];
                    i.isArray(t) && (t = i.map(t, function (e) {
                        return e.toString()
                    })), this.$element.val(t).trigger("change")
                }, d.prototype.destroy = function () {
                    this.$container.remove(), this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA), null != this._observer ? (this._observer.disconnect(), this._observer = null) : this.$element[0].removeEventListener && (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1), this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1), this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)), this._syncA = null, this._syncS = null, this.$element.off(".select2"), this.$element.attr("tabindex", u.GetData(this.$element[0], "old-tabindex")), this.$element.removeClass("select2-hidden-accessible"), this.$element.attr("aria-hidden", "false"), u.RemoveData(this.$element[0]), this.$element.removeData("select2"), this.dataAdapter.destroy(), this.selection.destroy(), this.dropdown.destroy(), this.results.destroy(), this.dataAdapter = null, this.selection = null, this.dropdown = null, this.results = null
                }, d.prototype.render = function () {
                    var e = i('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
                    return e.attr("dir", this.options.get("dir")), this.$container = e, this.$container.addClass("select2-container--" + this.options.get("theme")), u.StoreData(e[0], "element", this.$element), e
                }, d
            }), e.define("jquery-mousewheel", ["jquery"], function (e) {
                return e
            }), e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults", "./select2/utils"], function (i, e, o, t, s) {
                if (null == i.fn.select2) {
                    var a = ["open", "close", "destroy"];
                    i.fn.select2 = function (t) {
                        if ("object" == typeof (t = t || {})) return this.each(function () {
                            var e = i.extend(!0, {}, t);
                            new o(i(this), e)
                        }), this;
                        if ("string" != typeof t) throw new Error("Invalid arguments for Select2: " + t);
                        var n, r = Array.prototype.slice.call(arguments, 1);
                        return this.each(function () {
                            var e = s.GetData(this, "select2");
                            null == e && window.console && console.error && console.error("The select2('" + t + "') method was called on an element that is not using Select2."), n = e[t].apply(e, r)
                        }), -1 < i.inArray(t, a) ? this : n
                    }
                }
                return null == i.fn.select2.defaults && (i.fn.select2.defaults = t), o
            }), {
                define: e.define,
                require: e.require
            }
        }(),
        t = e.require("jquery.select2");
    return u.fn.select2.amd = e, t
});

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
( function() {
    var isIe = /(trident|msie)/i.test( navigator.userAgent );

    if ( isIe && document.getElementById && window.addEventListener ) {
        window.addEventListener( 'hashchange', function() {
            var id = location.hash.substring( 1 ),
                element;

            if ( ! ( /^[A-z0-9_-]+$/.test( id ) ) ) {
                return;
            }

            element = document.getElementById( id );

            if ( element ) {
                if ( ! ( /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) ) {
                    element.tabIndex = -1;
                }

                element.focus();
            }
        }, false );
    }
} )();
! function (i) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
}(function (i) {
    "use strict";
    var e = window.Slick || {};
    (e = function () {
        var e = 0;
        return function (t, o) {
            var s, n = this;
            n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: i(t),
                appendDots: i(t),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function (e, t) {
                    /*
                         _ _      _       _
                     ___| (_) ___| | __  (_)___
                    / __| | |/ __| |/ /  | / __|
                    \__ \ | | (__|   < _ | \__ \
                    |___/_|_|\___|_|\_(_)/ |___/
                                       |__/

                     Version: 1.8.1
                      Author: Ken Wheeler
                     Website: http://kenwheeler.github.io
                        Docs: http://kenwheeler.github.io/slick
                        Repo: http://github.com/kenwheeler/slick
                      Issues: http://github.com/kenwheeler/slick/issues

                     */
                    /* global window, document, define, jQuery, setInterval, clearInterval */
                    ;
                    (function (factory) {
                        'use strict';
                        if (typeof define === 'function' && define.amd) {
                            define(['jquery'], factory);
                        } else if (typeof exports !== 'undefined') {
                            module.exports = factory(require('jquery'));
                        } else {
                            factory(jQuery);
                        }

                    }(function ($) {
                        'use strict';
                        var Slick = window.Slick || {};

                        Slick = (function () {

                            var instanceUid = 0;

                            function Slick(element, settings) {

                                var _ = this,
                                    dataSettings;

                                _.defaults = {
                                    accessibility: true,
                                    adaptiveHeight: false,
                                    appendArrows: $(element),
                                    appendDots: $(element),
                                    arrows: true,
                                    asNavFor: null,
                                    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                                    nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                                    autoplay: false,
                                    autoplaySpeed: 3000,
                                    centerMode: false,
                                    centerPadding: '50px',
                                    cssEase: 'ease',
                                    customPaging: function (slider, i) {
                                        return $('<button type="button" />').text(i + 1);
                                    },
                                    dots: false,
                                    dotsClass: 'slick-dots',
                                    draggable: true,
                                    easing: 'linear',
                                    edgeFriction: 0.35,
                                    fade: false,
                                    focusOnSelect: false,
                                    focusOnChange: false,
                                    infinite: true,
                                    initialSlide: 0,
                                    lazyLoad: 'ondemand',
                                    mobileFirst: false,
                                    pauseOnHover: true,
                                    pauseOnFocus: true,
                                    pauseOnDotsHover: false,
                                    respondTo: 'window',
                                    responsive: null,
                                    rows: 1,
                                    rtl: false,
                                    slide: '',
                                    slidesPerRow: 1,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    speed: 500,
                                    swipe: true,
                                    swipeToSlide: false,
                                    touchMove: true,
                                    touchThreshold: 5,
                                    useCSS: true,
                                    useTransform: true,
                                    variableWidth: false,
                                    vertical: false,
                                    verticalSwiping: false,
                                    waitForAnimate: true,
                                    zIndex: 1000
                                };

                                _.initials = {
                                    animating: false,
                                    dragging: false,
                                    autoPlayTimer: null,
                                    currentDirection: 0,
                                    currentLeft: null,
                                    currentSlide: 0,
                                    direction: 1,
                                    $dots: null,
                                    listWidth: null,
                                    listHeight: null,
                                    loadIndex: 0,
                                    $nextArrow: null,
                                    $prevArrow: null,
                                    scrolling: false,
                                    slideCount: null,
                                    slideWidth: null,
                                    $slideTrack: null,
                                    $slides: null,
                                    sliding: false,
                                    slideOffset: 0,
                                    swipeLeft: null,
                                    swiping: false,
                                    $list: null,
                                    touchObject: {},
                                    transformsEnabled: false,
                                    unslicked: false
                                };

                                $.extend(_, _.initials);

                                _.activeBreakpoint = null;
                                _.animType = null;
                                _.animProp = null;
                                _.breakpoints = [];
                                _.breakpointSettings = [];
                                _.cssTransitions = false;
                                _.focussed = false;
                                _.interrupted = false;
                                _.hidden = 'hidden';
                                _.paused = true;
                                _.positionProp = null;
                                _.respondTo = null;
                                _.rowCount = 1;
                                _.shouldClick = true;
                                _.$slider = $(element);
                                _.$slidesCache = null;
                                _.transformType = null;
                                _.transitionType = null;
                                _.visibilityChange = 'visibilitychange';
                                _.windowWidth = 0;
                                _.windowTimer = null;

                                dataSettings = $(element).data('slick') || {};

                                _.options = $.extend({}, _.defaults, settings, dataSettings);

                                _.currentSlide = _.options.initialSlide;

                                _.originalSettings = _.options;

                                if (typeof document.mozHidden !== 'undefined') {
                                    _.hidden = 'mozHidden';
                                    _.visibilityChange = 'mozvisibilitychange';
                                } else if (typeof document.webkitHidden !== 'undefined') {
                                    _.hidden = 'webkitHidden';
                                    _.visibilityChange = 'webkitvisibilitychange';
                                }

                                _.autoPlay = $.proxy(_.autoPlay, _);
                                _.autoPlayClear = $.proxy(_.autoPlayClear, _);
                                _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
                                _.changeSlide = $.proxy(_.changeSlide, _);
                                _.clickHandler = $.proxy(_.clickHandler, _);
                                _.selectHandler = $.proxy(_.selectHandler, _);
                                _.setPosition = $.proxy(_.setPosition, _);
                                _.swipeHandler = $.proxy(_.swipeHandler, _);
                                _.dragHandler = $.proxy(_.dragHandler, _);
                                _.keyHandler = $.proxy(_.keyHandler, _);

                                _.instanceUid = instanceUid++;

                                // A simple way to check for HTML strings
                                // Strict HTML recognition (must start with <)
                                // Extracted from jQuery v1.11 source
                                _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


                                _.registerBreakpoints();
                                _.init(true);

                            }

                            return Slick;

                        }());

                        Slick.prototype.activateADA = function () {
                            var _ = this;

                            _.$slideTrack.find('.slick-active').attr({
                                'aria-hidden': 'false'
                            }).find('a, input, button, select').attr({
                                'tabindex': '0'
                            });

                        };

                        Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {

                            var _ = this;

                            if (typeof (index) === 'boolean') {
                                addBefore = index;
                                index = null;
                            } else if (index < 0 || (index >= _.slideCount)) {
                                return false;
                            }

                            _.unload();

                            if (typeof (index) === 'number') {
                                if (index === 0 && _.$slides.length === 0) {
                                    $(markup).appendTo(_.$slideTrack);
                                } else if (addBefore) {
                                    $(markup).insertBefore(_.$slides.eq(index));
                                } else {
                                    $(markup).insertAfter(_.$slides.eq(index));
                                }
                            } else {
                                if (addBefore === true) {
                                    $(markup).prependTo(_.$slideTrack);
                                } else {
                                    $(markup).appendTo(_.$slideTrack);
                                }
                            }

                            _.$slides = _.$slideTrack.children(this.options.slide);

                            _.$slideTrack.children(this.options.slide).detach();

                            _.$slideTrack.append(_.$slides);

                            _.$slides.each(function (index, element) {
                                $(element).attr('data-slick-index', index);
                            });

                            _.$slidesCache = _.$slides;

                            _.reinit();

                        };

                        Slick.prototype.animateHeight = function () {
                            var _ = this;
                            if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
                                var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
                                _.$list.animate({
                                    height: targetHeight
                                }, _.options.speed);
                            }
                        };

                        Slick.prototype.animateSlide = function (targetLeft, callback) {

                            var animProps = {},
                                _ = this;

                            _.animateHeight();

                            if (_.options.rtl === true && _.options.vertical === false) {
                                targetLeft = -targetLeft;
                            }
                            if (_.transformsEnabled === false) {
                                if (_.options.vertical === false) {
                                    _.$slideTrack.animate({
                                        left: targetLeft
                                    }, _.options.speed, _.options.easing, callback);
                                } else {
                                    _.$slideTrack.animate({
                                        top: targetLeft
                                    }, _.options.speed, _.options.easing, callback);
                                }

                            } else {

                                if (_.cssTransitions === false) {
                                    if (_.options.rtl === true) {
                                        _.currentLeft = -(_.currentLeft);
                                    }
                                    $({
                                        animStart: _.currentLeft
                                    }).animate({
                                        animStart: targetLeft
                                    }, {
                                        duration: _.options.speed,
                                        easing: _.options.easing,
                                        step: function (now) {
                                            now = Math.ceil(now);
                                            if (_.options.vertical === false) {
                                                animProps[_.animType] = 'translate(' +
                                                    now + 'px, 0px)';
                                                _.$slideTrack.css(animProps);
                                            } else {
                                                animProps[_.animType] = 'translate(0px,' +
                                                    now + 'px)';
                                                _.$slideTrack.css(animProps);
                                            }
                                        },
                                        complete: function () {
                                            if (callback) {
                                                callback.call();
                                            }
                                        }
                                    });

                                } else {

                                    _.applyTransition();
                                    targetLeft = Math.ceil(targetLeft);

                                    if (_.options.vertical === false) {
                                        animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                                    } else {
                                        animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                                    }
                                    _.$slideTrack.css(animProps);

                                    if (callback) {
                                        setTimeout(function () {

                                            _.disableTransition();

                                            callback.call();
                                        }, _.options.speed);
                                    }

                                }

                            }

                        };

                        Slick.prototype.getNavTarget = function () {

                            var _ = this,
                                asNavFor = _.options.asNavFor;

                            if (asNavFor && asNavFor !== null) {
                                asNavFor = $(asNavFor).not(_.$slider);
                            }

                            return asNavFor;

                        };

                        Slick.prototype.asNavFor = function (index) {

                            var _ = this,
                                asNavFor = _.getNavTarget();

                            if (asNavFor !== null && typeof asNavFor === 'object') {
                                asNavFor.each(function () {
                                    var target = $(this).slick('getSlick');
                                    if (!target.unslicked) {
                                        target.slideHandler(index, true);
                                    }
                                });
                            }

                        };

                        Slick.prototype.applyTransition = function (slide) {

                            var _ = this,
                                transition = {};

                            if (_.options.fade === false) {
                                transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
                            } else {
                                transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
                            }

                            if (_.options.fade === false) {
                                _.$slideTrack.css(transition);
                            } else {
                                _.$slides.eq(slide).css(transition);
                            }

                        };

                        Slick.prototype.autoPlay = function () {

                            var _ = this;

                            _.autoPlayClear();

                            if (_.slideCount > _.options.slidesToShow) {
                                _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
                            }

                        };

                        Slick.prototype.autoPlayClear = function () {

                            var _ = this;

                            if (_.autoPlayTimer) {
                                clearInterval(_.autoPlayTimer);
                            }

                        };

                        Slick.prototype.autoPlayIterator = function () {

                            var _ = this,
                                slideTo = _.currentSlide + _.options.slidesToScroll;

                            if (!_.paused && !_.interrupted && !_.focussed) {

                                if (_.options.infinite === false) {

                                    if (_.direction === 1 && (_.currentSlide + 1) === (_.slideCount - 1)) {
                                        _.direction = 0;
                                    } else if (_.direction === 0) {

                                        slideTo = _.currentSlide - _.options.slidesToScroll;

                                        if (_.currentSlide - 1 === 0) {
                                            _.direction = 1;
                                        }

                                    }

                                }

                                _.slideHandler(slideTo);

                            }

                        };

                        Slick.prototype.buildArrows = function () {

                            var _ = this;

                            if (_.options.arrows === true) {

                                _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
                                _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

                                if (_.slideCount > _.options.slidesToShow) {

                                    _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                                    _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                                    if (_.htmlExpr.test(_.options.prevArrow)) {
                                        _.$prevArrow.prependTo(_.options.appendArrows);
                                    }

                                    if (_.htmlExpr.test(_.options.nextArrow)) {
                                        _.$nextArrow.appendTo(_.options.appendArrows);
                                    }

                                    if (_.options.infinite !== true) {
                                        _.$prevArrow
                                            .addClass('slick-disabled')
                                            .attr('aria-disabled', 'true');
                                    }

                                } else {

                                    _.$prevArrow.add(_.$nextArrow)

                                        .addClass('slick-hidden')
                                        .attr({
                                            'aria-disabled': 'true',
                                            'tabindex': '-1'
                                        });

                                }

                            }

                        };

                        Slick.prototype.buildDots = function () {

                            var _ = this,
                                i, dot;

                            if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

                                _.$slider.addClass('slick-dotted');

                                dot = $('<ul />').addClass(_.options.dotsClass);

                                for (i = 0; i <= _.getDotCount(); i += 1) {
                                    dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
                                }

                                _.$dots = dot.appendTo(_.options.appendDots);

                                _.$dots.find('li').first().addClass('slick-active');

                            }

                        };

                        Slick.prototype.buildOut = function () {

                            var _ = this;

                            _.$slides =
                                _.$slider
                                .children(_.options.slide + ':not(.slick-cloned)')
                                .addClass('slick-slide');

                            _.slideCount = _.$slides.length;

                            _.$slides.each(function (index, element) {
                                $(element)
                                    .attr('data-slick-index', index)
                                    .data('originalStyling', $(element).attr('style') || '');
                            });

                            _.$slider.addClass('slick-slider');

                            _.$slideTrack = (_.slideCount === 0) ?
                                $('<div class="slick-track"/>').appendTo(_.$slider) :
                                _.$slides.wrapAll('<div class="slick-track"/>').parent();

                            _.$list = _.$slideTrack.wrap(
                                '<div class="slick-list"/>').parent();
                            _.$slideTrack.css('opacity', 0);

                            if (_.options.centerMode === true || _.options.swipeToSlide === true) {
                                _.options.slidesToScroll = 1;
                            }

                            $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

                            _.setupInfinite();

                            _.buildArrows();

                            _.buildDots();

                            _.updateDots();


                            _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

                            if (_.options.draggable === true) {
                                _.$list.addClass('draggable');
                            }

                        };

                        Slick.prototype.buildRows = function () {

                            var _ = this,
                                a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;

                            newSlides = document.createDocumentFragment();
                            originalSlides = _.$slider.children();

                            if (_.options.rows > 0) {

                                slidesPerSection = _.options.slidesPerRow * _.options.rows;
                                numOfSlides = Math.ceil(
                                    originalSlides.length / slidesPerSection
                                );

                                for (a = 0; a < numOfSlides; a++) {
                                    var slide = document.createElement('div');
                                    for (b = 0; b < _.options.rows; b++) {
                                        var row = document.createElement('div');
                                        for (c = 0; c < _.options.slidesPerRow; c++) {
                                            var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                                            if (originalSlides.get(target)) {
                                                row.appendChild(originalSlides.get(target));
                                            }
                                        }
                                        slide.appendChild(row);
                                    }
                                    newSlides.appendChild(slide);
                                }

                                _.$slider.empty().append(newSlides);
                                _.$slider.children().children().children()
                                    .css({
                                        'width': (100 / _.options.slidesPerRow) + '%',
                                        'display': 'inline-block'
                                    });

                            }

                        };

                        Slick.prototype.checkResponsive = function (initial, forceUpdate) {

                            var _ = this,
                                breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
                            var sliderWidth = _.$slider.width();
                            var windowWidth = window.innerWidth || $(window).width();

                            if (_.respondTo === 'window') {
                                respondToWidth = windowWidth;
                            } else if (_.respondTo === 'slider') {
                                respondToWidth = sliderWidth;
                            } else if (_.respondTo === 'min') {
                                respondToWidth = Math.min(windowWidth, sliderWidth);
                            }

                            if (_.options.responsive &&
                                _.options.responsive.length &&
                                _.options.responsive !== null) {

                                targetBreakpoint = null;

                                for (breakpoint in _.breakpoints) {
                                    if (_.breakpoints.hasOwnProperty(breakpoint)) {
                                        if (_.originalSettings.mobileFirst === false) {
                                            if (respondToWidth < _.breakpoints[breakpoint]) {
                                                targetBreakpoint = _.breakpoints[breakpoint];
                                            }
                                        } else {
                                            if (respondToWidth > _.breakpoints[breakpoint]) {
                                                targetBreakpoint = _.breakpoints[breakpoint];
                                            }
                                        }
                                    }
                                }

                                if (targetBreakpoint !== null) {
                                    if (_.activeBreakpoint !== null) {
                                        if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                                            _.activeBreakpoint =
                                                targetBreakpoint;
                                            if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                                                _.unslick(targetBreakpoint);
                                            } else {
                                                _.options = $.extend({}, _.originalSettings,
                                                    _.breakpointSettings[
                                                        targetBreakpoint]);
                                                if (initial === true) {
                                                    _.currentSlide = _.options.initialSlide;
                                                }
                                                _.refresh(initial);
                                            }
                                            triggerBreakpoint = targetBreakpoint;
                                        }
                                    } else {
                                        _.activeBreakpoint = targetBreakpoint;
                                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                                            _.unslick(targetBreakpoint);
                                        } else {
                                            _.options = $.extend({}, _.originalSettings,
                                                _.breakpointSettings[
                                                    targetBreakpoint]);
                                            if (initial === true) {
                                                _.currentSlide = _.options.initialSlide;
                                            }
                                            _.refresh(initial);
                                        }
                                        triggerBreakpoint = targetBreakpoint;
                                    }
                                } else {
                                    if (_.activeBreakpoint !== null) {
                                        _.activeBreakpoint = null;
                                        _.options = _.originalSettings;
                                        if (initial === true) {
                                            _.currentSlide = _.options.initialSlide;
                                        }
                                        _.refresh(initial);
                                        triggerBreakpoint = targetBreakpoint;
                                    }
                                }

                                // only trigger breakpoints during an actual break. not on initialize.
                                if (!initial && triggerBreakpoint !== false) {
                                    _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
                                }
                            }

                        };

                        Slick.prototype.changeSlide = function (event, dontAnimate) {

                            var _ = this,
                                $target = $(event.currentTarget),
                                indexOffset, slideOffset, unevenOffset;

                            // If target is a link, prevent default action.
                            if ($target.is('a')) {
                                event.preventDefault();
                            }

                            // If target is not the <li> element (ie: a child), find the <li>.
                            if (!$target.is('li')) {
                                $target = $target.closest('li');
                            }

                            unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
                            indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

                            switch (event.data.message) {

                                case 'previous':
                                    slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                                    if (_.slideCount > _.options.slidesToShow) {
                                        _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                                    }
                                    break;

                                case 'next':
                                    slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                                    if (_.slideCount > _.options.slidesToShow) {
                                        _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                                    }
                                    break;

                                case 'index':
                                    var index = event.data.index === 0 ? 0 :
                                        event.data.index || $target.index() * _.options.slidesToScroll;

                                    _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                                    $target.children().trigger('focus');
                                    break;

                                default:
                                    return;
                            }

                        };

                        Slick.prototype.checkNavigable = function (index) {

                            var _ = this,
                                navigables, prevNavigable;

                            navigables = _.getNavigableIndexes();
                            prevNavigable = 0;
                            if (index > navigables[navigables.length - 1]) {
                                index = navigables[navigables.length - 1];
                            } else {
                                for (var n in navigables) {
                                    if (index < navigables[n]) {
                                        index = prevNavigable;
                                        break;
                                    }
                                    prevNavigable = navigables[n];
                                }
                            }

                            return index;
                        };

                        Slick.prototype.cleanUpEvents = function () {

                            var _ = this;

                            if (_.options.dots && _.$dots !== null) {

                                $('li', _.$dots)
                                    .off('click.slick', _.changeSlide)
                                    .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                                    .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

                                if (_.options.accessibility === true) {
                                    _.$dots.off('keydown.slick', _.keyHandler);
                                }
                            }

                            _.$slider.off('focus.slick blur.slick');

                            if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
                                _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
                                _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

                                if (_.options.accessibility === true) {
                                    _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                                    _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
                                }
                            }

                            _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
                            _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
                            _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
                            _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

                            _.$list.off('click.slick', _.clickHandler);

                            $(document).off(_.visibilityChange, _.visibility);

                            _.cleanUpSlideEvents();

                            if (_.options.accessibility === true) {
                                _.$list.off('keydown.slick', _.keyHandler);
                            }

                            if (_.options.focusOnSelect === true) {
                                $(_.$slideTrack).children().off('click.slick', _.selectHandler);
                            }

                            $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

                            $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

                            $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

                            $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

                        };

                        Slick.prototype.cleanUpSlideEvents = function () {

                            var _ = this;

                            _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
                            _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

                        };

                        Slick.prototype.cleanUpRows = function () {

                            var _ = this,
                                originalSlides;

                            if (_.options.rows > 0) {
                                originalSlides = _.$slides.children().children();
                                originalSlides.removeAttr('style');
                                _.$slider.empty().append(originalSlides);
                            }

                        };

                        Slick.prototype.clickHandler = function (event) {

                            var _ = this;

                            if (_.shouldClick === false) {
                                event.stopImmediatePropagation();
                                event.stopPropagation();
                                event.preventDefault();
                            }

                        };

                        Slick.prototype.destroy = function (refresh) {

                            var _ = this;

                            _.autoPlayClear();

                            _.touchObject = {};

                            _.cleanUpEvents();

                            $('.slick-cloned', _.$slider).detach();

                            if (_.$dots) {
                                _.$dots.remove();
                            }

                            if (_.$prevArrow && _.$prevArrow.length) {

                                _.$prevArrow
                                    .removeClass('slick-disabled slick-arrow slick-hidden')
                                    .removeAttr('aria-hidden aria-disabled tabindex')
                                    .css('display', '');

                                if (_.htmlExpr.test(_.options.prevArrow)) {
                                    _.$prevArrow.remove();
                                }
                            }

                            if (_.$nextArrow && _.$nextArrow.length) {

                                _.$nextArrow
                                    .removeClass('slick-disabled slick-arrow slick-hidden')
                                    .removeAttr('aria-hidden aria-disabled tabindex')
                                    .css('display', '');

                                if (_.htmlExpr.test(_.options.nextArrow)) {
                                    _.$nextArrow.remove();
                                }
                            }


                            if (_.$slides) {

                                _.$slides
                                    .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                                    .removeAttr('aria-hidden')
                                    .removeAttr('data-slick-index')
                                    .each(function () {
                                        $(this).attr('style', $(this).data('originalStyling'));
                                    });

                                _.$slideTrack.children(this.options.slide).detach();

                                _.$slideTrack.detach();

                                _.$list.detach();

                                _.$slider.append(_.$slides);
                            }

                            _.cleanUpRows();

                            _.$slider.removeClass('slick-slider');
                            _.$slider.removeClass('slick-initialized');
                            _.$slider.removeClass('slick-dotted');

                            _.unslicked = true;

                            if (!refresh) {
                                _.$slider.trigger('destroy', [_]);
                            }

                        };

                        Slick.prototype.disableTransition = function (slide) {

                            var _ = this,
                                transition = {};

                            transition[_.transitionType] = '';

                            if (_.options.fade === false) {
                                _.$slideTrack.css(transition);
                            } else {
                                _.$slides.eq(slide).css(transition);
                            }

                        };

                        Slick.prototype.fadeSlide = function (slideIndex, callback) {

                            var _ = this;

                            if (_.cssTransitions === false) {

                                _.$slides.eq(slideIndex).css({
                                    zIndex: _.options.zIndex
                                });

                                _.$slides.eq(slideIndex).animate({
                                    opacity: 1
                                }, _.options.speed, _.options.easing, callback);

                            } else {

                                _.applyTransition(slideIndex);

                                _.$slides.eq(slideIndex).css({
                                    opacity: 1,
                                    zIndex: _.options.zIndex
                                });

                                if (callback) {
                                    setTimeout(function () {

                                        _.disableTransition(slideIndex);

                                        callback.call();
                                    }, _.options.speed);
                                }

                            }

                        };

                        Slick.prototype.fadeSlideOut = function (slideIndex) {

                            var _ = this;

                            if (_.cssTransitions === false) {

                                _.$slides.eq(slideIndex).animate({
                                    opacity: 0,
                                    zIndex: _.options.zIndex - 2
                                }, _.options.speed, _.options.easing);

                            } else {

                                _.applyTransition(slideIndex);

                                _.$slides.eq(slideIndex).css({
                                    opacity: 0,
                                    zIndex: _.options.zIndex - 2
                                });

                            }

                        };

                        Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {

                            var _ = this;

                            if (filter !== null) {

                                _.$slidesCache = _.$slides;

                                _.unload();

                                _.$slideTrack.children(this.options.slide).detach();

                                _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

                                _.reinit();

                            }

                        };

                        Slick.prototype.focusHandler = function () {

                            var _ = this;

                            _.$slider
                                .off('focus.slick blur.slick')
                                .on('focus.slick blur.slick', '*', function (event) {

                                    event.stopImmediatePropagation();
                                    var $sf = $(this);

                                    setTimeout(function () {

                                        if (_.options.pauseOnFocus) {
                                            _.focussed = $sf.is(':focus');
                                            _.autoPlay();
                                        }

                                    }, 0);

                                });
                        };

                        Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {

                            var _ = this;
                            return _.currentSlide;

                        };

                        Slick.prototype.getDotCount = function () {

                            var _ = this;

                            var breakPoint = 0;
                            var counter = 0;
                            var pagerQty = 0;

                            if (_.options.infinite === true) {
                                if (_.slideCount <= _.options.slidesToShow) {
                                    ++pagerQty;
                                } else {
                                    while (breakPoint < _.slideCount) {
                                        ++pagerQty;
                                        breakPoint = counter + _.options.slidesToScroll;
                                        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                                    }
                                }
                            } else if (_.options.centerMode === true) {
                                pagerQty = _.slideCount;
                            } else if (!_.options.asNavFor) {
                                pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
                            } else {
                                while (breakPoint < _.slideCount) {
                                    ++pagerQty;
                                    breakPoint = counter + _.options.slidesToScroll;
                                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                                }
                            }

                            return pagerQty - 1;

                        };

                        Slick.prototype.getLeft = function (slideIndex) {

                            var _ = this,
                                targetLeft,
                                verticalHeight,
                                verticalOffset = 0,
                                targetSlide,
                                coef;

                            _.slideOffset = 0;
                            verticalHeight = _.$slides.first().outerHeight(true);

                            if (_.options.infinite === true) {
                                if (_.slideCount > _.options.slidesToShow) {
                                    _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                                    coef = -1

                                    if (_.options.vertical === true && _.options.centerMode === true) {
                                        if (_.options.slidesToShow === 2) {
                                            coef = -1.5;
                                        } else if (_.options.slidesToShow === 1) {
                                            coef = -2
                                        }
                                    }
                                    verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
                                }
                                if (_.slideCount % _.options.slidesToScroll !== 0) {
                                    if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                                        if (slideIndex > _.slideCount) {
                                            _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                                            verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                                        } else {
                                            _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                                            verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                                        }
                                    }
                                }
                            } else {
                                if (slideIndex + _.options.slidesToShow > _.slideCount) {
                                    _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                                    verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
                                }
                            }

                            if (_.slideCount <= _.options.slidesToShow) {
                                _.slideOffset = 0;
                                verticalOffset = 0;
                            }

                            if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
                                _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
                            } else if (_.options.centerMode === true && _.options.infinite === true) {
                                _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
                            } else if (_.options.centerMode === true) {
                                _.slideOffset = 0;
                                _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
                            }

                            if (_.options.vertical === false) {
                                targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
                            } else {
                                targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
                            }

                            if (_.options.variableWidth === true) {

                                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                                } else {
                                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
                                }

                                if (_.options.rtl === true) {
                                    if (targetSlide[0]) {
                                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                                    } else {
                                        targetLeft = 0;
                                    }
                                } else {
                                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                                }

                                if (_.options.centerMode === true) {
                                    if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                                        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                                    } else {
                                        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                                    }

                                    if (_.options.rtl === true) {
                                        if (targetSlide[0]) {
                                            targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                                        } else {
                                            targetLeft = 0;
                                        }
                                    } else {
                                        targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                                    }

                                    targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
                                }
                            }

                            return targetLeft;

                        };

                        Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {

                            var _ = this;

                            return _.options[option];

                        };

                        Slick.prototype.getNavigableIndexes = function () {

                            var _ = this,
                                breakPoint = 0,
                                counter = 0,
                                indexes = [],
                                max;

                            if (_.options.infinite === false) {
                                max = _.slideCount;
                            } else {
                                breakPoint = _.options.slidesToScroll * -1;
                                counter = _.options.slidesToScroll * -1;
                                max = _.slideCount * 2;
                            }

                            while (breakPoint < max) {
                                indexes.push(breakPoint);
                                breakPoint = counter + _.options.slidesToScroll;
                                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                            }

                            return indexes;

                        };

                        Slick.prototype.getSlick = function () {

                            return this;

                        };

                        Slick.prototype.getSlideCount = function () {

                            var _ = this,
                                slidesTraversed, swipedSlide, centerOffset;

                            centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

                            if (_.options.swipeToSlide === true) {
                                _.$slideTrack.find('.slick-slide').each(function (index, slide) {
                                    if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                                        swipedSlide = slide;
                                        return false;
                                    }
                                });

                                slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

                                return slidesTraversed;

                            } else {
                                return _.options.slidesToScroll;
                            }

                        };

                        Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {

                            var _ = this;

                            _.changeSlide({
                                data: {
                                    message: 'index',
                                    index: parseInt(slide)
                                }
                            }, dontAnimate);

                        };

                        Slick.prototype.init = function (creation) {

                            var _ = this;

                            if (!$(_.$slider).hasClass('slick-initialized')) {

                                $(_.$slider).addClass('slick-initialized');

                                _.buildRows();
                                _.buildOut();
                                _.setProps();
                                _.startLoad();
                                _.loadSlider();
                                _.initializeEvents();
                                _.updateArrows();
                                _.updateDots();
                                _.checkResponsive(true);
                                _.focusHandler();

                            }

                            if (creation) {
                                _.$slider.trigger('init', [_]);
                            }

                            if (_.options.accessibility === true) {
                                _.initADA();
                            }

                            if (_.options.autoplay) {

                                _.paused = false;
                                _.autoPlay();

                            }

                        };

                        Slick.prototype.initADA = function () {
                            var _ = this,
                                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                                tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
                                    return (val >= 0) && (val < _.slideCount);
                                });

                            _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
                                'aria-hidden': 'true',
                                'tabindex': '-1'
                            }).find('a, input, button, select').attr({
                                'tabindex': '-1'
                            });

                            if (_.$dots !== null) {
                                _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
                                    var slideControlIndex = tabControlIndexes.indexOf(i);

                                    $(this).attr({
                                        'role': 'tabpanel',
                                        'id': 'slick-slide' + _.instanceUid + i,
                                        'tabindex': -1
                                    });

                                    if (slideControlIndex !== -1) {
                                        var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                                        if ($('#' + ariaButtonControl).length) {
                                            $(this).attr({
                                                'aria-describedby': ariaButtonControl
                                            });
                                        }
                                    }
                                });

                                _.$dots.attr('role', 'tablist').find('li').each(function (i) {
                                    var mappedSlideIndex = tabControlIndexes[i];

                                    $(this).attr({
                                        'role': 'presentation'
                                    });

                                    $(this).find('button').first().attr({
                                        'role': 'tab',
                                        'id': 'slick-slide-control' + _.instanceUid + i,
                                        'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                                        'aria-label': (i + 1) + ' of ' + numDotGroups,
                                        'aria-selected': null,
                                        'tabindex': '-1'
                                    });

                                }).eq(_.currentSlide).find('button').attr({
                                    'aria-selected': 'true',
                                    'tabindex': '0'
                                }).end();
                            }

                            for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
                                if (_.options.focusOnChange) {
                                    _.$slides.eq(i).attr({
                                        'tabindex': '0'
                                    });
                                } else {
                                    _.$slides.eq(i).removeAttr('tabindex');
                                }
                            }

                            _.activateADA();

                        };

                        Slick.prototype.initArrowEvents = function () {

                            var _ = this;

                            if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
                                _.$prevArrow
                                    .off('click.slick')
                                    .on('click.slick', {
                                        message: 'previous'
                                    }, _.changeSlide);
                                _.$nextArrow
                                    .off('click.slick')
                                    .on('click.slick', {
                                        message: 'next'
                                    }, _.changeSlide);

                                if (_.options.accessibility === true) {
                                    _.$prevArrow.on('keydown.slick', _.keyHandler);
                                    _.$nextArrow.on('keydown.slick', _.keyHandler);
                                }
                            }

                        };

                        Slick.prototype.initDotEvents = function () {

                            var _ = this;

                            if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
                                $('li', _.$dots).on('click.slick', {
                                    message: 'index'
                                }, _.changeSlide);

                                if (_.options.accessibility === true) {
                                    _.$dots.on('keydown.slick', _.keyHandler);
                                }
                            }

                            if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

                                $('li', _.$dots)
                                    .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                                    .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

                            }

                        };

                        Slick.prototype.initSlideEvents = function () {

                            var _ = this;

                            if (_.options.pauseOnHover) {

                                _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
                                _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

                            }

                        };

                        Slick.prototype.initializeEvents = function () {

                            var _ = this;

                            _.initArrowEvents();

                            _.initDotEvents();
                            _.initSlideEvents();

                            _.$list.on('touchstart.slick mousedown.slick', {
                                action: 'start'
                            }, _.swipeHandler);
                            _.$list.on('touchmove.slick mousemove.slick', {
                                action: 'move'
                            }, _.swipeHandler);
                            _.$list.on('touchend.slick mouseup.slick', {
                                action: 'end'
                            }, _.swipeHandler);
                            _.$list.on('touchcancel.slick mouseleave.slick', {
                                action: 'end'
                            }, _.swipeHandler);

                            _.$list.on('click.slick', _.clickHandler);

                            $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

                            if (_.options.accessibility === true) {
                                _.$list.on('keydown.slick', _.keyHandler);
                            }

                            if (_.options.focusOnSelect === true) {
                                $(_.$slideTrack).children().on('click.slick', _.selectHandler);
                            }

                            $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

                            $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

                            $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

                            $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
                            $(_.setPosition);

                        };

                        Slick.prototype.initUI = function () {

                            var _ = this;

                            if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

                                _.$prevArrow.show();
                                _.$nextArrow.show();

                            }

                            if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

                                _.$dots.show();

                            }

                        };

                        Slick.prototype.keyHandler = function (event) {

                            var _ = this;
                            //Dont slide if the cursor is inside the form fields and arrow keys are pressed
                            if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
                                if (event.keyCode === 37 && _.options.accessibility === true) {
                                    _.changeSlide({
                                        data: {
                                            message: _.options.rtl === true ? 'next' : 'previous'
                                        }
                                    });
                                } else if (event.keyCode === 39 && _.options.accessibility === true) {
                                    _.changeSlide({
                                        data: {
                                            message: _.options.rtl === true ? 'previous' : 'next'
                                        }
                                    });
                                }
                            }

                        };

                        Slick.prototype.lazyLoad = function () {

                            var _ = this,
                                loadRange, cloneRange, rangeStart, rangeEnd;

                            function loadImages(imagesScope) {

                                $('img[data-lazy]', imagesScope).each(function () {

                                    var image = $(this),
                                        imageSource = $(this).attr('data-lazy'),
                                        imageSrcSet = $(this).attr('data-srcset'),
                                        imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                                        imageToLoad = document.createElement('img');

                                    imageToLoad.onload = function () {

                                        image
                                            .animate({
                                                opacity: 0
                                            }, 100, function () {

                                                if (imageSrcSet) {
                                                    image
                                                        .attr('srcset', imageSrcSet);

                                                    if (imageSizes) {
                                                        image
                                                            .attr('sizes', imageSizes);
                                                    }
                                                }

                                                image
                                                    .attr('src', imageSource)
                                                    .animate({
                                                        opacity: 1
                                                    }, 200, function () {
                                                        image
                                                            .removeAttr('data-lazy data-srcset data-sizes')
                                                            .removeClass('slick-loading');
                                                    });
                                                _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                                            });

                                    };

                                    imageToLoad.onerror = function () {

                                        image
                                            .removeAttr('data-lazy')
                                            .removeClass('slick-loading')
                                            .addClass('slick-lazyload-error');

                                        _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                                    };

                                    imageToLoad.src = imageSource;

                                });

                            }

                            if (_.options.centerMode === true) {
                                if (_.options.infinite === true) {
                                    rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                                    rangeEnd = rangeStart + _.options.slidesToShow + 2;
                                } else {
                                    rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                                    rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
                                }
                            } else {
                                rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
                                rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
                                if (_.options.fade === true) {
                                    if (rangeStart > 0) rangeStart--;
                                    if (rangeEnd <= _.slideCount) rangeEnd++;
                                }
                            }

                            loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

                            if (_.options.lazyLoad === 'anticipated') {
                                var prevSlide = rangeStart - 1,
                                    nextSlide = rangeEnd,
                                    $slides = _.$slider.find('.slick-slide');

                                for (var i = 0; i < _.options.slidesToScroll; i++) {
                                    if (prevSlide < 0) prevSlide = _.slideCount - 1;
                                    loadRange = loadRange.add($slides.eq(prevSlide));
                                    loadRange = loadRange.add($slides.eq(nextSlide));
                                    prevSlide--;
                                    nextSlide++;
                                }
                            }

                            loadImages(loadRange);

                            if (_.slideCount <= _.options.slidesToShow) {
                                cloneRange = _.$slider.find('.slick-slide');
                                loadImages(cloneRange);
                            } else
                            if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
                                cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
                                loadImages(cloneRange);
                            } else if (_.currentSlide === 0) {
                                cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
                                loadImages(cloneRange);
                            }

                        };

                        Slick.prototype.loadSlider = function () {

                            var _ = this;

                            _.setPosition();

                            _.$slideTrack.css({
                                opacity: 1
                            });

                            _.$slider.removeClass('slick-loading');

                            _.initUI();

                            if (_.options.lazyLoad === 'progressive') {
                                _.progressiveLazyLoad();
                            }

                        };

                        Slick.prototype.next = Slick.prototype.slickNext = function () {

                            var _ = this;

                            _.changeSlide({
                                data: {
                                    message: 'next'
                                }
                            });

                        };

                        Slick.prototype.orientationChange = function () {

                            var _ = this;

                            _.checkResponsive();
                            _.setPosition();

                        };

                        Slick.prototype.pause = Slick.prototype.slickPause = function () {

                            var _ = this;

                            _.autoPlayClear();
                            _.paused = true;

                        };

                        Slick.prototype.play = Slick.prototype.slickPlay = function () {

                            var _ = this;

                            _.autoPlay();
                            _.options.autoplay = true;
                            _.paused = false;
                            _.focussed = false;
                            _.interrupted = false;

                        };

                        Slick.prototype.postSlide = function (index) {

                            var _ = this;

                            if (!_.unslicked) {

                                _.$slider.trigger('afterChange', [_, index]);

                                _.animating = false;

                                if (_.slideCount > _.options.slidesToShow) {
                                    _.setPosition();
                                }

                                _.swipeLeft = null;

                                if (_.options.autoplay) {
                                    _.autoPlay();
                                }

                                if (_.options.accessibility === true) {
                                    _.initADA();

                                    if (_.options.focusOnChange) {
                                        var $currentSlide = $(_.$slides.get(_.currentSlide));
                                        $currentSlide.attr('tabindex', 0).focus();
                                    }
                                }

                            }

                        };

                        Slick.prototype.prev = Slick.prototype.slickPrev = function () {

                            var _ = this;

                            _.changeSlide({
                                data: {
                                    message: 'previous'
                                }
                            });

                        };

                        Slick.prototype.preventDefault = function (event) {

                            event.preventDefault();

                        };

                        Slick.prototype.progressiveLazyLoad = function (tryCount) {

                            tryCount = tryCount || 1;

                            var _ = this,
                                $imgsToLoad = $('img[data-lazy]', _.$slider),
                                image,
                                imageSource,
                                imageSrcSet,
                                imageSizes,
                                imageToLoad;

                            if ($imgsToLoad.length) {

                                image = $imgsToLoad.first();
                                imageSource = image.attr('data-lazy');
                                imageSrcSet = image.attr('data-srcset');
                                imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
                                imageToLoad = document.createElement('img');

                                imageToLoad.onload = function () {

                                    if (imageSrcSet) {
                                        image
                                            .attr('srcset', imageSrcSet);

                                        if (imageSizes) {
                                            image
                                                .attr('sizes', imageSizes);
                                        }
                                    }

                                    image
                                        .attr('src', imageSource)
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');

                                    if (_.options.adaptiveHeight === true) {
                                        _.setPosition();
                                    }

                                    _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                                    _.progressiveLazyLoad();

                                };

                                imageToLoad.onerror = function () {

                                    if (tryCount < 3) {

                                        /**
                                         * try to load the image 3 times,
                                         * leave a slight delay so we don't get
                                         * servers blocking the request.
                                         */
                                        setTimeout(function () {
                                            _.progressiveLazyLoad(tryCount + 1);
                                        }, 500);

                                    } else {

                                        image
                                            .removeAttr('data-lazy')
                                            .removeClass('slick-loading')
                                            .addClass('slick-lazyload-error');

                                        _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                                        _.progressiveLazyLoad();

                                    }

                                };

                                imageToLoad.src = imageSource;

                            } else {

                                _.$slider.trigger('allImagesLoaded', [_]);

                            }

                        };

                        Slick.prototype.refresh = function (initializing) {

                            var _ = this,
                                currentSlide, lastVisibleIndex;

                            lastVisibleIndex = _.slideCount - _.options.slidesToShow;

                            // in non-infinite sliders, we don't want to go past the
                            // last visible index.
                            if (!_.options.infinite && (_.currentSlide > lastVisibleIndex)) {
                                _.currentSlide = lastVisibleIndex;
                            }

                            // if less slides than to show, go to start.
                            if (_.slideCount <= _.options.slidesToShow) {
                                _.currentSlide = 0;

                            }

                            currentSlide = _.currentSlide;

                            _.destroy(true);

                            $.extend(_, _.initials, {
                                currentSlide: currentSlide
                            });

                            _.init();

                            if (!initializing) {

                                _.changeSlide({
                                    data: {
                                        message: 'index',
                                        index: currentSlide
                                    }
                                }, false);

                            }

                        };

                        Slick.prototype.registerBreakpoints = function () {

                            var _ = this,
                                breakpoint, currentBreakpoint, l,
                                responsiveSettings = _.options.responsive || null;

                            if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {

                                _.respondTo = _.options.respondTo || 'window';

                                for (breakpoint in responsiveSettings) {

                                    l = _.breakpoints.length - 1;

                                    if (responsiveSettings.hasOwnProperty(breakpoint)) {
                                        currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                                        // loop through the breakpoints and cut out any existing
                                        // ones with the same breakpoint number, we don't want dupes.
                                        while (l >= 0) {
                                            if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                                                _.breakpoints.splice(l, 1);
                                            }
                                            l--;
                                        }

                                        _.breakpoints.push(currentBreakpoint);
                                        _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                                    }

                                }

                                _.breakpoints.sort(function (a, b) {
                                    return (_.options.mobileFirst) ? a - b : b - a;
                                });

                            }

                        };

                        Slick.prototype.reinit = function () {

                            var _ = this;

                            _.$slides =
                                _.$slideTrack
                                .children(_.options.slide)
                                .addClass('slick-slide');

                            _.slideCount = _.$slides.length;

                            if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
                                _.currentSlide = _.currentSlide - _.options.slidesToScroll;
                            }

                            if (_.slideCount <= _.options.slidesToShow) {
                                _.currentSlide = 0;
                            }

                            _.registerBreakpoints();

                            _.setProps();
                            _.setupInfinite();
                            _.buildArrows();
                            _.updateArrows();
                            _.initArrowEvents();
                            _.buildDots();
                            _.updateDots();
                            _.initDotEvents();
                            _.cleanUpSlideEvents();
                            _.initSlideEvents();

                            _.checkResponsive(false, true);

                            if (_.options.focusOnSelect === true) {
                                $(_.$slideTrack).children().on('click.slick', _.selectHandler);
                            }

                            _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

                            _.setPosition();
                            _.focusHandler();

                            _.paused = !_.options.autoplay;
                            _.autoPlay();

                            _.$slider.trigger('reInit', [_]);

                        };

                        Slick.prototype.resize = function () {

                            var _ = this;

                            if ($(window).width() !== _.windowWidth) {
                                clearTimeout(_.windowDelay);
                                _.windowDelay = window.setTimeout(function () {
                                    _.windowWidth = $(window).width();
                                    _.checkResponsive();
                                    if (!_.unslicked) {
                                        _.setPosition();
                                    }
                                }, 50);
                            }
                        };

                        Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {

                            var _ = this;

                            if (typeof (index) === 'boolean') {
                                removeBefore = index;
                                index = removeBefore === true ? 0 : _.slideCount - 1;
                            } else {
                                index = removeBefore === true ? --index : index;
                            }

                            if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
                                return false;
                            }

                            _.unload();

                            if (removeAll === true) {
                                _.$slideTrack.children().remove();
                            } else {
                                _.$slideTrack.children(this.options.slide).eq(index).remove();
                            }

                            _.$slides = _.$slideTrack.children(this.options.slide);

                            _.$slideTrack.children(this.options.slide).detach();

                            _.$slideTrack.append(_.$slides);

                            _.$slidesCache = _.$slides;

                            _.reinit();

                        };

                        Slick.prototype.setCSS = function (position) {

                            var _ = this,
                                positionProps = {},
                                x, y;

                            if (_.options.rtl === true) {
                                position = -position;
                            }
                            x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
                            y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

                            positionProps[_.positionProp] = position;

                            if (_.transformsEnabled === false) {
                                _.$slideTrack.css(positionProps);
                            } else {
                                positionProps = {};
                                if (_.cssTransitions === false) {
                                    positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                                    _.$slideTrack.css(positionProps);
                                } else {
                                    positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                                    _.$slideTrack.css(positionProps);
                                }
                            }

                        };

                        Slick.prototype.setDimensions = function () {

                            var _ = this;

                            if (_.options.vertical === false) {
                                if (_.options.centerMode === true) {
                                    _.$list.css({
                                        padding: ('0px ' + _.options.centerPadding)
                                    });
                                }
                            } else {
                                _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
                                if (_.options.centerMode === true) {
                                    _.$list.css({
                                        padding: (_.options.centerPadding + ' 0px')
                                    });
                                }
                            }

                            _.listWidth = _.$list.width();
                            _.listHeight = _.$list.height();


                            if (_.options.vertical === false && _.options.variableWidth === false) {
                                _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
                                _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

                            } else if (_.options.variableWidth === true) {
                                _.$slideTrack.width(5000 * _.slideCount);
                            } else {
                                _.slideWidth = Math.ceil(_.listWidth);
                                _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
                            }

                            var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
                            if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

                        };

                        Slick.prototype.setFade = function () {

                            var _ = this,
                                targetLeft;

                            _.$slides.each(function (index, element) {
                                targetLeft = (_.slideWidth * index) * -1;
                                if (_.options.rtl === true) {
                                    $(element).css({
                                        position: 'relative',
                                        right: targetLeft,
                                        top: 0,
                                        zIndex: _.options.zIndex - 2,
                                        opacity: 0
                                    });
                                } else {
                                    $(element).css({
                                        position: 'relative',
                                        left: targetLeft,
                                        top: 0,
                                        zIndex: _.options.zIndex - 2,
                                        opacity: 0
                                    });
                                }
                            });

                            _.$slides.eq(_.currentSlide).css({
                                zIndex: _.options.zIndex - 1,
                                opacity: 1
                            });

                        };

                        Slick.prototype.setHeight = function () {

                            var _ = this;

                            if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
                                var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
                                _.$list.css('height', targetHeight);
                            }

                        };

                        Slick.prototype.setOption =
                            Slick.prototype.slickSetOption = function () {

                                /**
                                 * accepts arguments in format of:
                                 *
                                 *  - for changing a single option's value:
                                 *     .slick("setOption", option, value, refresh )
                                 *
                                 *  - for changing a set of responsive options:
                                 *     .slick("setOption", 'responsive', [{}, ...], refresh )
                                 *
                                 *  - for updating multiple values at once (not responsive)
                                 *     .slick("setOption", { 'option': value, ... }, refresh )
                                 */

                                var _ = this,
                                    l, item, option, value, refresh = false,
                                    type;

                                if ($.type(arguments[0]) === 'object') {

                                    option = arguments[0];
                                    refresh = arguments[1];
                                    type = 'multiple';

                                } else if ($.type(arguments[0]) === 'string') {

                                    option = arguments[0];
                                    value = arguments[1];
                                    refresh = arguments[2];

                                    if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {

                                        type = 'responsive';

                                    } else if (typeof arguments[1] !== 'undefined') {

                                        type = 'single';

                                    }

                                }

                                if (type === 'single') {

                                    _.options[option] = value;


                                } else if (type === 'multiple') {

                                    $.each(option, function (opt, val) {

                                        _.options[opt] = val;

                                    });


                                } else if (type === 'responsive') {

                                    for (item in value) {

                                        if ($.type(_.options.responsive) !== 'array') {

                                            _.options.responsive = [value[item]];

                                        } else {

                                            l = _.options.responsive.length - 1;

                                            // loop through the responsive object and splice out duplicates.
                                            while (l >= 0) {

                                                if (_.options.responsive[l].breakpoint === value[item].breakpoint) {

                                                    _.options.responsive.splice(l, 1);

                                                }

                                                l--;

                                            }

                                            _.options.responsive.push(value[item]);

                                        }

                                    }

                                }

                                if (refresh) {

                                    _.unload();
                                    _.reinit();

                                }

                            };

                        Slick.prototype.setPosition = function () {

                            var _ = this;

                            _.setDimensions();

                            _.setHeight();

                            if (_.options.fade === false) {
                                _.setCSS(_.getLeft(_.currentSlide));
                            } else {
                                _.setFade();
                            }

                            _.$slider.trigger('setPosition', [_]);

                        };

                        Slick.prototype.setProps = function () {

                            var _ = this,
                                bodyStyle = document.body.style;

                            _.positionProp = _.options.vertical === true ? 'top' : 'left';

                            if (_.positionProp === 'top') {
                                _.$slider.addClass('slick-vertical');
                            } else {
                                _.$slider.removeClass('slick-vertical');
                            }

                            if (bodyStyle.WebkitTransition !== undefined ||
                                bodyStyle.MozTransition !== undefined ||
                                bodyStyle.msTransition !== undefined) {
                                if (_.options.useCSS === true) {
                                    _.cssTransitions = true;
                                }
                            }

                            if (_.options.fade) {
                                if (typeof _.options.zIndex === 'number') {
                                    if (_.options.zIndex < 3) {
                                        _.options.zIndex = 3;
                                    }
                                } else {
                                    _.options.zIndex = _.defaults.zIndex;
                                }
                            }

                            if (bodyStyle.OTransform !== undefined) {
                                _.animType = 'OTransform';
                                _.transformType = '-o-transform';
                                _.transitionType = 'OTransition';
                                if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
                            }
                            if (bodyStyle.MozTransform !== undefined) {
                                _.animType = 'MozTransform';
                                _.transformType = '-moz-transform';
                                _.transitionType = 'MozTransition';
                                if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
                            }
                            if (bodyStyle.webkitTransform !== undefined) {
                                _.animType = 'webkitTransform';
                                _.transformType = '-webkit-transform';
                                _.transitionType = 'webkitTransition';
                                if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
                            }
                            if (bodyStyle.msTransform !== undefined) {
                                _.animType = 'msTransform';
                                _.transformType = '-ms-transform';
                                _.transitionType = 'msTransition';
                                if (bodyStyle.msTransform === undefined) _.animType = false;
                            }
                            if (bodyStyle.transform !== undefined && _.animType !== false) {
                                _.animType = 'transform';
                                _.transformType = 'transform';
                                _.transitionType = 'transition';
                            }
                            _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
                        };


                        Slick.prototype.setSlideClasses = function (index) {

                            var _ = this,
                                centerOffset, allSlides, indexOffset, remainder;

                            allSlides = _.$slider
                                .find('.slick-slide')
                                .removeClass('slick-active slick-center slick-current')
                                .attr('aria-hidden', 'true');

                            _.$slides
                                .eq(index)
                                .addClass('slick-current');

                            if (_.options.centerMode === true) {

                                var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

                                centerOffset = Math.floor(_.options.slidesToShow / 2);

                                if (_.options.infinite === true) {

                                    if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                                        _.$slides
                                            .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                                            .addClass('slick-active')
                                            .attr('aria-hidden', 'false');

                                    } else {

                                        indexOffset = _.options.slidesToShow + index;
                                        allSlides
                                            .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                                            .addClass('slick-active')
                                            .attr('aria-hidden', 'false');

                                    }

                                    if (index === 0) {
                                        console.log(allSlides.length - 1 - _.options.slidesToShow - (_.slideCount - 1 - _.options.slidesToShow));
                                        allSlides
                                            .eq(allSlides.length - 1 - _.options.slidesToShow - (_.slideCount - 1 - _.options.slidesToShow))
                                            .addClass('slick-center');

                                    } else if (index === _.slideCount - 1) {

                                        allSlides
                                            .eq(_.options.slidesToShow)
                                            .addClass('slick-center');

                                    }

                                }

                                _.$slides
                                    .eq(index)
                                    .addClass('slick-center');

                            } else {

                                if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                                    _.$slides
                                        .slice(index, index + _.options.slidesToShow)
                                        .addClass('slick-active')
                                        .attr('aria-hidden', 'false');

                                } else if (allSlides.length <= _.options.slidesToShow) {

                                    allSlides
                                        .addClass('slick-active')
                                        .attr('aria-hidden', 'false');

                                } else {

                                    remainder = _.slideCount % _.options.slidesToShow;
                                    indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                                    if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                                        allSlides
                                            .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                                            .addClass('slick-active')
                                            .attr('aria-hidden', 'false');

                                    } else {

                                        allSlides
                                            .slice(indexOffset, indexOffset + _.options.slidesToShow)
                                            .addClass('slick-active')
                                            .attr('aria-hidden', 'false');

                                    }

                                }

                            }

                            if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
                                _.lazyLoad();
                            }
                        };

                        Slick.prototype.setupInfinite = function () {

                            var _ = this,
                                i, slideIndex, infiniteCount;

                            if (_.options.fade === true) {
                                _.options.centerMode = false;
                            }

                            if (_.options.infinite === true && _.options.fade === false) {

                                slideIndex = null;

                                if (_.slideCount > _.options.slidesToShow) {

                                    if (_.options.centerMode === true) {
                                        infiniteCount = _.options.slidesToShow + 1;
                                    } else {
                                        infiniteCount = _.options.slidesToShow;
                                    }

                                    for (i = _.slideCount; i > (_.slideCount -
                                            infiniteCount); i -= 1) {
                                        slideIndex = i - 1;
                                        $(_.$slides[slideIndex]).clone(true).attr('id', '')
                                            .attr('data-slick-index', slideIndex - _.slideCount)
                                            .prependTo(_.$slideTrack).addClass('slick-cloned');
                                    }
                                    for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
                                        slideIndex = i;
                                        $(_.$slides[slideIndex]).clone(true).attr('id', '')
                                            .attr('data-slick-index', slideIndex + _.slideCount)
                                            .appendTo(_.$slideTrack).addClass('slick-cloned');
                                    }
                                    _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
                                        $(this).attr('id', '');
                                    });

                                }

                            }

                        };

                        Slick.prototype.interrupt = function (toggle) {

                            var _ = this;

                            if (!toggle) {
                                _.autoPlay();
                            }
                            _.interrupted = toggle;

                        };

                        Slick.prototype.selectHandler = function (event) {

                            var _ = this;

                            var targetElement =
                                $(event.target).is('.slick-slide') ?
                                $(event.target) :
                                $(event.target).parents('.slick-slide');

                            var index = parseInt(targetElement.attr('data-slick-index'));

                            if (!index) index = 0;

                            if (_.slideCount <= _.options.slidesToShow) {

                                _.slideHandler(index, false, true);
                                return;

                            }

                            _.slideHandler(index);

                        };

                        Slick.prototype.slideHandler = function (index, sync, dontAnimate) {

                            var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
                                _ = this,
                                navTarget;

                            sync = sync || false;

                            if (_.animating === true && _.options.waitForAnimate === true) {
                                return;
                            }

                            if (_.options.fade === true && _.currentSlide === index) {
                                return;
                            }

                            if (sync === false) {
                                _.asNavFor(index);
                            }

                            targetSlide = index;
                            targetLeft = _.getLeft(targetSlide);
                            slideLeft = _.getLeft(_.currentSlide);

                            _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

                            if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
                                if (_.options.fade === false) {
                                    targetSlide = _.currentSlide;
                                    if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                                        _.animateSlide(slideLeft, function () {
                                            _.postSlide(targetSlide);
                                        });
                                    } else {
                                        _.postSlide(targetSlide);
                                    }
                                }
                                return;
                            } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
                                if (_.options.fade === false) {
                                    targetSlide = _.currentSlide;
                                    if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                                        _.animateSlide(slideLeft, function () {
                                            _.postSlide(targetSlide);
                                        });
                                    } else {
                                        _.postSlide(targetSlide);
                                    }
                                }
                                return;
                            }

                            if (_.options.autoplay) {
                                clearInterval(_.autoPlayTimer);
                            }

                            if (targetSlide < 0) {
                                if (_.slideCount % _.options.slidesToScroll !== 0) {
                                    animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
                                } else {
                                    animSlide = _.slideCount + targetSlide;
                                }
                            } else if (targetSlide >= _.slideCount) {
                                if (_.slideCount % _.options.slidesToScroll !== 0) {
                                    animSlide = 0;
                                } else {
                                    animSlide = targetSlide - _.slideCount;
                                }
                            } else {
                                animSlide = targetSlide;
                            }

                            _.animating = true;

                            _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

                            oldSlide = _.currentSlide;
                            _.currentSlide = animSlide;

                            _.setSlideClasses(_.currentSlide);

                            if (_.options.asNavFor) {

                                navTarget = _.getNavTarget();
                                navTarget = navTarget.slick('getSlick');

                                if (navTarget.slideCount <= navTarget.options.slidesToShow) {
                                    navTarget.setSlideClasses(_.currentSlide);
                                }

                            }

                            _.updateDots();
                            _.updateArrows();

                            if (_.options.fade === true) {
                                if (dontAnimate !== true) {

                                    _.fadeSlideOut(oldSlide);

                                    _.fadeSlide(animSlide, function () {
                                        _.postSlide(animSlide);
                                    });

                                } else {
                                    _.postSlide(animSlide);
                                }
                                _.animateHeight();
                                return;
                            }

                            if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                                _.animateSlide(targetLeft, function () {
                                    _.postSlide(animSlide);
                                });
                            } else {
                                _.postSlide(animSlide);
                            }

                        };

                        Slick.prototype.startLoad = function () {

                            var _ = this;

                            if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

                                _.$prevArrow.hide();
                                _.$nextArrow.hide();

                            }

                            if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

                                _.$dots.hide();

                            }

                            _.$slider.addClass('slick-loading');

                        };

                        Slick.prototype.swipeDirection = function () {

                            var xDist, yDist, r, swipeAngle, _ = this;

                            xDist = _.touchObject.startX - _.touchObject.curX;
                            yDist = _.touchObject.startY - _.touchObject.curY;
                            r = Math.atan2(yDist, xDist);

                            swipeAngle = Math.round(r * 180 / Math.PI);
                            if (swipeAngle < 0) {
                                swipeAngle = 360 - Math.abs(swipeAngle);
                            }

                            if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
                                return (_.options.rtl === false ? 'left' : 'right');
                            }
                            if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
                                return (_.options.rtl === false ? 'left' : 'right');
                            }
                            if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
                                return (_.options.rtl === false ? 'right' : 'left');
                            }
                            if (_.options.verticalSwiping === true) {
                                if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                                    return 'down';
                                } else {
                                    return 'up';
                                }
                            }

                            return 'vertical';

                        };

                        Slick.prototype.swipeEnd = function (event) {

                            var _ = this,
                                slideCount,
                                direction;

                            _.dragging = false;
                            _.swiping = false;

                            if (_.scrolling) {
                                _.scrolling = false;
                                return false;
                            }

                            _.interrupted = false;
                            _.shouldClick = (_.touchObject.swipeLength > 10) ? false : true;

                            if (_.touchObject.curX === undefined) {
                                return false;
                            }

                            if (_.touchObject.edgeHit === true) {
                                _.$slider.trigger('edge', [_, _.swipeDirection()]);
                            }

                            if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

                                direction = _.swipeDirection();

                                switch (direction) {

                                    case 'left':
                                    case 'down':

                                        slideCount =
                                            _.options.swipeToSlide ?
                                            _.checkNavigable(_.currentSlide + _.getSlideCount()) :
                                            _.currentSlide + _.getSlideCount();

                                        _.currentDirection = 0;

                                        break;

                                    case 'right':
                                    case 'up':

                                        slideCount =
                                            _.options.swipeToSlide ?
                                            _.checkNavigable(_.currentSlide - _.getSlideCount()) :
                                            _.currentSlide - _.getSlideCount();

                                        _.currentDirection = 1;

                                        break;

                                    default:


                                }

                                if (direction != 'vertical') {

                                    _.slideHandler(slideCount);
                                    _.touchObject = {};
                                    _.$slider.trigger('swipe', [_, direction]);

                                }

                            } else {

                                if (_.touchObject.startX !== _.touchObject.curX) {

                                    _.slideHandler(_.currentSlide);
                                    _.touchObject = {};

                                }

                            }

                        };

                        Slick.prototype.swipeHandler = function (event) {

                            var _ = this;

                            if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
                                return;
                            } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
                                return;
                            }

                            _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
                                event.originalEvent.touches.length : 1;

                            _.touchObject.minSwipe = _.listWidth / _.options
                                .touchThreshold;

                            if (_.options.verticalSwiping === true) {
                                _.touchObject.minSwipe = _.listHeight / _.options
                                    .touchThreshold;
                            }

                            switch (event.data.action) {

                                case 'start':
                                    _.swipeStart(event);
                                    break;

                                case 'move':
                                    _.swipeMove(event);
                                    break;

                                case 'end':
                                    _.swipeEnd(event);
                                    break;

                            }

                        };

                        Slick.prototype.swipeMove = function (event) {

                            var _ = this,
                                edgeWasHit = false,
                                curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

                            touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

                            if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
                                return false;
                            }

                            curLeft = _.getLeft(_.currentSlide);

                            _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
                            _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

                            _.touchObject.swipeLength = Math.round(Math.sqrt(
                                Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

                            verticalSwipeLength = Math.round(Math.sqrt(
                                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

                            if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
                                _.scrolling = true;
                                return false;
                            }

                            if (_.options.verticalSwiping === true) {
                                _.touchObject.swipeLength = verticalSwipeLength;
                            }

                            swipeDirection = _.swipeDirection();

                            if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
                                _.swiping = true;
                                event.preventDefault();
                            }

                            positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
                            if (_.options.verticalSwiping === true) {
                                positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
                            }


                            swipeLength = _.touchObject.swipeLength;

                            _.touchObject.edgeHit = false;

                            if (_.options.infinite === false) {
                                if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                                    swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                                    _.touchObject.edgeHit = true;
                                }
                            }

                            if (_.options.vertical === false) {
                                _.swipeLeft = curLeft + swipeLength * positionOffset;
                            } else {
                                _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
                            }
                            if (_.options.verticalSwiping === true) {
                                _.swipeLeft = curLeft + swipeLength * positionOffset;
                            }

                            if (_.options.fade === true || _.options.touchMove === false) {
                                return false;
                            }

                            if (_.animating === true) {
                                _.swipeLeft = null;
                                return false;
                            }

                            _.setCSS(_.swipeLeft);

                        };

                        Slick.prototype.swipeStart = function (event) {

                            var _ = this,
                                touches;

                            _.interrupted = true;

                            if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
                                _.touchObject = {};
                                return false;
                            }

                            if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
                                touches = event.originalEvent.touches[0];
                            }

                            _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
                            _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

                            _.dragging = true;

                        };

                        Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {

                            var _ = this;

                            if (_.$slidesCache !== null) {

                                _.unload();

                                _.$slideTrack.children(this.options.slide).detach();

                                _.$slidesCache.appendTo(_.$slideTrack);

                                _.reinit();

                            }

                        };

                        Slick.prototype.unload = function () {

                            var _ = this;

                            $('.slick-cloned', _.$slider).remove();

                            if (_.$dots) {
                                _.$dots.remove();
                            }

                            if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
                                _.$prevArrow.remove();
                            }

                            if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
                                _.$nextArrow.remove();
                            }

                            _.$slides
                                .removeClass('slick-slide slick-active slick-visible slick-current')
                                .attr('aria-hidden', 'true')
                                .css('width', '');
                        };

                        Slick.prototype.unslick = function (fromBreakpoint) {

                            var _ = this;
                            _.$slider.trigger('unslick', [_, fromBreakpoint]);
                            _.destroy();

                        };

                        Slick.prototype.updateArrows = function () {

                            var _ = this,
                                centerOffset;

                            centerOffset = Math.floor(_.options.slidesToShow / 2);

                            if (_.options.arrows === true &&
                                _.slideCount > _.options.slidesToShow &&
                                !_.options.infinite) {

                                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
                                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

                                if (_.currentSlide === 0) {

                                    _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                                    _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

                                } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                                    _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                                    _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

                                } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                                    _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                                    _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

                                }

                            }

                        };

                        Slick.prototype.updateDots = function () {

                            var _ = this;

                            if (_.$dots !== null) {

                                _.$dots
                                    .find('li')
                                    .removeClass('slick-active')
                                    .end();

                                _.$dots
                                    .find('li')
                                    .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                                    .addClass('slick-active');

                            }

                        };

                        Slick.prototype.visibility = function () {

                            var _ = this;

                            if (_.options.autoplay) {

                                if (document[_.hidden]) {

                                    _.interrupted = true;

                                } else {

                                    _.interrupted = false;

                                }

                            }

                        };

                        $.fn.slick = function () {
                            var _ = this,
                                opt = arguments[0],
                                args = Array.prototype.slice.call(arguments, 1),
                                l = _.length,
                                i,
                                ret;
                            for (i = 0; i < l; i++) {
                                if (typeof opt == 'object' || typeof opt == 'undefined')
                                    _[i].slick = new Slick(_[i], opt);
                                else
                                    ret = _[i].slick[opt].apply(_[i].slick, args);
                                if (typeof ret != 'undefined') return ret;
                            }
                            return _;
                        };

                    }));

                    return i('<button type="button" />').text(t + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            }, n.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(t), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(t).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0)
        }
    }()).prototype.activateADA = function () {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
        var s = this;
        if ("boolean" == typeof t) o = t, t = null;
        else if (t < 0 || t >= s.slideCount) return !1;
        s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
            i(t).attr("data-slick-index", e)
        }), s.$slidesCache = s.$slides, s.reinit()
    }, e.prototype.animateHeight = function () {
        var i = this;
        if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.animate({
                height: e
            }, i.options.speed)
        }
    }, e.prototype.animateSlide = function (e, t) {
        var o = {},
            s = this;
        s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (e = -e), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({
            left: e
        }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
            top: e
        }, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), i({
            animStart: s.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: s.options.speed,
            easing: s.options.easing,
            step: function (i) {
                i = Math.ceil(i), !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o))
            },
            complete: function () {
                t && t.call()
            }
        })) : (s.applyTransition(), e = Math.ceil(e), !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () {
            s.disableTransition(), t.call()
        }, s.options.speed))
    }, e.prototype.getNavTarget = function () {
        var e = this,
            t = e.options.asNavFor;
        return t && null !== t && (t = i(t).not(e.$slider)), t
    }, e.prototype.asNavFor = function (e) {
        var t = this.getNavTarget();
        null !== t && "object" == typeof t && t.each(function () {
            var t = i(this).slick("getSlick");
            t.unslicked || t.slideHandler(e, !0)
        })
    }, e.prototype.applyTransition = function (i) {
        var e = this,
            t = {};
        !1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }, e.prototype.autoPlay = function () {
        var i = this;
        i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
    }, e.prototype.autoPlayClear = function () {
        var i = this;
        i.autoPlayTimer && clearInterval(i.autoPlayTimer)
    }, e.prototype.autoPlayIterator = function () {
        var i = this,
            e = i.currentSlide + i.options.slidesToScroll;
        i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e))
    }, e.prototype.buildArrows = function () {
        var e = this;
        !0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, e.prototype.buildDots = function () {
        var e, t, o = this;
        if (!0 === o.options.dots) {
            for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
            o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active")
        }
    }, e.prototype.buildOut = function () {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
            i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "")
        }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable")
    }, e.prototype.buildRows = function () {
        var i, e, t, o, s, n, r, l = this;
        if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 1) {
            for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
                var d = document.createElement("div");
                for (e = 0; e < l.options.rows; e++) {
                    var a = document.createElement("div");
                    for (t = 0; t < l.options.slidesPerRow; t++) {
                        var c = i * r + (e * l.options.slidesPerRow + t);
                        n.get(c) && a.appendChild(n.get(c))
                    }
                    d.appendChild(a)
                }
                o.appendChild(d)
            }
            l.$slider.empty().append(o), l.$slider.children().children().children().css({
                width: 100 / l.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, e.prototype.checkResponsive = function (e, t) {
        var o, s, n, r = this,
            l = !1,
            d = r.$slider.width(),
            a = window.innerWidth || i(window).width();
        if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            s = null;
            for (o in r.breakpoints) r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
            null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || !1 === l || r.$slider.trigger("breakpoint", [r, l])
        }
    }, e.prototype.changeSlide = function (e, t) {
        var o, s, n, r = this,
            l = i(e.currentTarget);
        switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll != 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {
            case "previous":
                s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);
                break;
            case "next":
                s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);
                break;
            case "index":
                var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;
                r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");
                break;
            default:
                return
        }
    }, e.prototype.checkNavigable = function (i) {
        var e, t;
        if (e = this.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];
        else
            for (var o in e) {
                if (i < e[o]) {
                    i = t;
                    break
                }
                t = e[o]
            }
        return i
    }, e.prototype.cleanUpEvents = function () {
        var e = this;
        e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
    }, e.prototype.cleanUpSlideEvents = function () {
        var e = this;
        e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }, e.prototype.cleanUpRows = function () {
        var i, e = this;
        e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i))
    }, e.prototype.clickHandler = function (i) {
        !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault())
    }, e.prototype.destroy = function (e) {
        var t = this;
        t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
            i(this).attr("style", i(this).data("originalStyling"))
        }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t])
    }, e.prototype.disableTransition = function (i) {
        var e = this,
            t = {};
        t[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
    }, e.prototype.fadeSlide = function (i, e) {
        var t = this;
        !1 === t.cssTransitions ? (t.$slides.eq(i).css({
            zIndex: t.options.zIndex
        }), t.$slides.eq(i).animate({
            opacity: 1
        }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
            opacity: 1,
            zIndex: t.options.zIndex
        }), e && setTimeout(function () {
            t.disableTransition(i), e.call()
        }, t.options.speed))
    }, e.prototype.fadeSlideOut = function (i) {
        var e = this;
        !1 === e.cssTransitions ? e.$slides.eq(i).animate({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
            opacity: 0,
            zIndex: e.options.zIndex - 2
        }))
    }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
        var e = this;
        null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit())
    }, e.prototype.focusHandler = function () {
        var e = this;
        e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
            t.stopImmediatePropagation();
            var o = i(this);
            setTimeout(function () {
                e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay())
            }, 0)
        })
    }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
        return this.currentSlide
    }, e.prototype.getDotCount = function () {
        var i = this,
            e = 0,
            t = 0,
            o = 0;
        if (!0 === i.options.infinite)
            if (i.slideCount <= i.options.slidesToShow) ++o;
            else
                for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
        else if (!0 === i.options.centerMode) o = i.slideCount;
        else if (i.options.asNavFor)
            for (; e < i.slideCount;) ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
        else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
        return o - 1
    }, e.prototype.getLeft = function (i) {
        var e, t, o, s, n = this,
            r = 0;
        return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e
    }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
        return this.options[i]
    }, e.prototype.getNavigableIndexes = function () {
        var i, e = this,
            t = 0,
            o = 0,
            s = [];
        for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, i = 2 * e.slideCount); t < i;) s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return s
    }, e.prototype.getSlick = function () {
        return this
    }, e.prototype.getSlideCount = function () {
        var e, t, o = this;
        return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
            if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return e = n, !1
        }), Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
    }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(i)
            }
        }, e)
    }, e.prototype.init = function (e) {
        var t = this;
        i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay())
    }, e.prototype.initADA = function () {
        var e = this,
            t = Math.ceil(e.slideCount / e.options.slidesToShow),
            o = e.getNavigableIndexes().filter(function (i) {
                return i >= 0 && i < e.slideCount
            });
        e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
            var s = o.indexOf(t);
            i(this).attr({
                role: "tabpanel",
                id: "slick-slide" + e.instanceUid + t,
                tabindex: -1
            }), -1 !== s && i(this).attr({
                "aria-describedby": "slick-slide-control" + e.instanceUid + s
            })
        }), e.$dots.attr("role", "tablist").find("li").each(function (s) {
            var n = o[s];
            i(this).attr({
                role: "presentation"
            }), i(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + e.instanceUid + s,
                "aria-controls": "slick-slide" + e.instanceUid + n,
                "aria-label": s + 1 + " of " + t,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(e.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) e.$slides.eq(s).attr("tabindex", 0);
        e.activateADA()
    }, e.prototype.initArrowEvents = function () {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)))
    }, e.prototype.initDotEvents = function () {
        var e = this;
        !0 === e.options.dots && (i("li", e.$dots).on("click.slick", {
            message: "index"
        }, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1))
    }, e.prototype.initSlideEvents = function () {
        var e = this;
        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)))
    }, e.prototype.initializeEvents = function () {
        var e = this;
        e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition)
    }, e.prototype.initUI = function () {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show()
    }, e.prototype.keyHandler = function (i) {
        var e = this;
        i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "next" : "previous"
            }
        }) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({
            data: {
                message: !0 === e.options.rtl ? "previous" : "next"
            }
        }))
    }, e.prototype.lazyLoad = function () {
        function e(e) {
            i("img[data-lazy]", e).each(function () {
                var e = i(this),
                    t = i(this).attr("data-lazy"),
                    o = i(this).attr("data-srcset"),
                    s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
                    r = document.createElement("img");
                r.onload = function () {
                    e.animate({
                        opacity: 0
                    }, 100, function () {
                        o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({
                            opacity: 1
                        }, 200, function () {
                            e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }), n.$slider.trigger("lazyLoaded", [n, e, t])
                    })
                }, r.onerror = function () {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t])
                }, r.src = t
            })
        }
        var t, o, s, n = this;
        if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)), s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide, s = Math.ceil(o + n.options.slidesToShow), !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)), t = n.$slider.find(".slick-slide").slice(o, s), "anticipated" === n.options.lazyLoad)
            for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++) r < 0 && (r = n.slideCount - 1), t = (t = t.add(d.eq(r))).add(d.eq(l)), r--, l++;
        e(t), n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow))
    }, e.prototype.loadSlider = function () {
        var i = this;
        i.setPosition(), i.$slideTrack.css({
            opacity: 1
        }), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
    }, e.prototype.next = e.prototype.slickNext = function () {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }, e.prototype.orientationChange = function () {
        var i = this;
        i.checkResponsive(), i.setPosition()
    }, e.prototype.pause = e.prototype.slickPause = function () {
        var i = this;
        i.autoPlayClear(), i.paused = !0
    }, e.prototype.play = e.prototype.slickPlay = function () {
        var i = this;
        i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1
    }, e.prototype.postSlide = function (e) {
        var t = this;
        t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()))
    }, e.prototype.prev = e.prototype.slickPrev = function () {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }, e.prototype.preventDefault = function (i) {
        i.preventDefault()
    }, e.prototype.progressiveLazyLoad = function (e) {
        e = e || 1;
        var t, o, s, n, r, l = this,
            d = i("img[data-lazy]", l.$slider);
        d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function () {
            s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === l.options.adaptiveHeight && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad()
        }, r.onerror = function () {
            e < 3 ? setTimeout(function () {
                l.progressiveLazyLoad(e + 1)
            }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad())
        }, r.src = o) : l.$slider.trigger("allImagesLoaded", [l])
    }, e.prototype.refresh = function (e) {
        var t, o, s = this;
        o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, {
            currentSlide: t
        }), s.init(), e || s.changeSlide({
            data: {
                message: "index",
                index: t
            }
        }, !1)
    }, e.prototype.registerBreakpoints = function () {
        var e, t, o, s = this,
            n = s.options.responsive || null;
        if ("array" === i.type(n) && n.length) {
            s.respondTo = s.options.respondTo || "window";
            for (e in n)
                if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
                    for (t = n[e].breakpoint; o >= 0;) s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
                    s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings
                } s.breakpoints.sort(function (i, e) {
                return s.options.mobileFirst ? i - e : e - i
            })
        }
    }, e.prototype.reinit = function () {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
    }, e.prototype.resize = function () {
        var e = this;
        i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
            e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
        }, 50))
    }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
        var o = this;
        if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i, o.slideCount < 1 || i < 0 || i > o.slideCount - 1) return !1;
        o.unload(), !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit()
    }, e.prototype.setCSS = function (i) {
        var e, t, o = this,
            s = {};
        !0 === o.options.rtl && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {}, !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)))
    }, e.prototype.setDimensions = function () {
        var i = this;
        !1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({
            padding: "0px " + i.options.centerPadding
        }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({
            padding: i.options.centerPadding + " 0px"
        })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
        var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
        !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e)
    }, e.prototype.setFade = function () {
        var e, t = this;
        t.$slides.each(function (o, s) {
            e = t.slideWidth * o * -1, !0 === t.options.rtl ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0
            }) : i(s).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0
            })
        }), t.$slides.eq(t.currentSlide).css({
            zIndex: t.options.zIndex - 1,
            opacity: 1
        })
    }, e.prototype.setHeight = function () {
        var i = this;
        if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
            var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
            i.$list.css("height", e)
        }
    }, e.prototype.setOption = e.prototype.slickSetOption = function () {
        var e, t, o, s, n, r = this,
            l = !1;
        if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[o] = s;
        else if ("multiple" === n) i.each(o, function (i, e) {
            r.options[i] = e
        });
        else if ("responsive" === n)
            for (t in s)
                if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]];
                else {
                    for (e = r.options.responsive.length - 1; e >= 0;) r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
                    r.options.responsive.push(s[t])
                } l && (r.unload(), r.reinit())
    }, e.prototype.setPosition = function () {
        var i = this;
        i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i])
    }, e.prototype.setProps = function () {
        var i = this,
            e = document.body.style;
        i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType
    }, e.prototype.setSlideClasses = function (i) {
        var e, t, o, s, n = this;
        if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode) {
            var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
            e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center")
        } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = !0 === n.options.infinite ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad()
    }, e.prototype.setupInfinite = function () {
        var e, t, o, s = this;
        if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (t = null, s.slideCount > s.options.slidesToShow)) {
            for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
            for (e = 0; e < o + s.slideCount; e += 1) t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
            s.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
                i(this).attr("id", "")
            })
        }
    }, e.prototype.interrupt = function (i) {
        var e = this;
        i || e.autoPlay(), e.interrupted = i
    }, e.prototype.selectHandler = function (e) {
        var t = this,
            o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
            s = parseInt(o.attr("data-slick-index"));
        s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s)
    }, e.prototype.slideHandler = function (i, e, t) {
        var o, s, n, r, l, d = null,
            a = this;
        if (e = e || !1, !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i))
            if (!1 === e && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
                a.postSlide(o)
            }) : a.postSlide(o));
            else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
            a.postSlide(o)
        }) : a.postSlide(o));
        else {
            if (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide), a.updateDots(), a.updateArrows(), !0 === a.options.fade) return !0 !== t ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
                a.postSlide(s)
            })) : a.postSlide(s), void a.animateHeight();
            !0 !== t ? a.animateSlide(d, function () {
                a.postSlide(s)
            }) : a.postSlide(s)
        }
    }, e.prototype.startLoad = function () {
        var i = this;
        !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading")
    }, e.prototype.swipeDirection = function () {
        var i, e, t, o, s = this;
        return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical"
    }, e.prototype.swipeEnd = function (i) {
        var e, t, o = this;
        if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;
        if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;
        if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
            switch (t = o.swipeDirection()) {
                case "left":
                case "down":
                    e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1
            }
            "vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]))
        } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {})
    }, e.prototype.swipeHandler = function (i) {
        var e = this;
        if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
            case "start":
                e.swipeStart(i);
                break;
            case "move":
                e.swipeMove(i);
                break;
            case "end":
                e.swipeEnd(i)
        }
    }, e.prototype.swipeMove = function (i) {
        var e, t, o, s, n, r, l = this;
        return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s), !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))))
    }, e.prototype.swipeStart = function (i) {
        var e, t = this;
        if (t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow) return t.touchObject = {}, !1;
        void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, t.dragging = !0
    }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
        var i = this;
        null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit())
    }, e.prototype.unload = function () {
        var e = this;
        i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, e.prototype.unslick = function (i) {
        var e = this;
        e.$slider.trigger("unslick", [e, i]), e.destroy()
    }, e.prototype.updateArrows = function () {
        var i = this;
        Math.floor(i.options.slidesToShow / 2), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, e.prototype.updateDots = function () {
        var i = this;
        null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"))
    }, e.prototype.visibility = function () {
        var i = this;
        i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1)
    }, i.fn.slick = function () {
        var i, t, o = this,
            s = arguments[0],
            n = Array.prototype.slice.call(arguments, 1),
            r = o.length;
        for (i = 0; i < r; i++)
            if ("object" == typeof s || void 0 === s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), void 0 !== t) return t;
        return o
    }
});
